import { html } from 'lit';

export const FORMSTACK = html`
  <div class="fsBody fsEmbed">
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/3/reset_3d1cc6d59f.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/3/jquery-ui-1.13.2.min_164f2f8d51.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/3/default-v4_29cde3be75.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/../common/css/uil-static.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/common/dialogs_00a7ec5f05.css"
    />
    <!--[if IE]>
      <link
        rel="stylesheet"
        type="text/css"
        media="all"
        href="https://tuftsmedicine.formstack.com/forms/css/3/ie.css?20140508"
      />
    <![endif]-->
    <!--[if IE 7
      ]><link
        rel="stylesheet"
        type="text/css"
        media="all"
        href="https://tuftsmedicine.formstack.com/forms/css/3/ie7.css"
    /><![endif]-->
    <!--[if IE 6
      ]><link
        rel="stylesheet"
        type="text/css"
        media="all"
        href="https://tuftsmedicine.formstack.com/forms/css/3/ie6fixes.css"
    /><![endif]-->
    <style type="text/css">
      @charset "UTF-8";
      .fsBody {
        font-family: Arial, Helvetica, sans-serif;
        color: #595d64;
      }
      .fsBody input,
      .fsBody select,
      .fsBody textarea {
        font-family: Arial, Helvetica, sans-serif;
      }
      .wf-active .fsBody,
      .wf-active .fsBody input,
      .wf-active .fsBody select,
      .wf-active .fsBody textarea {
        font-family: 'Arial', Arial, Helvetica, sans-serif;
      }
      .fsBody .fsForm {
        float: center;
        border: 1px solid transparent;
        background-color: #ffffff;
        background-color: rgba(255, 255, 255, 1);
      }
      #fsHeaderImage {
        text-align: ;
      }
      #fsHeaderImage img {
        width: ;
        height: ;
      }
      #fsFooterImage {
        text-align: ;
      }
      #fsFooterImage img {
        width: ;
        height: ;
      }
      .fsborderradius .fsBody .fsForm {
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        -ms-border-radius: 6px;
        -o-border-radius: 6px;
        border-radius: 6px;
      }
      .fsBody {
        padding: 20px;
      }
      .fsBody .fsForm {
        margin: 20px auto;
        padding: 20px;
      }
      .fsBody .fsFieldRow {
        margin-bottom: 20px !important;
      }
      .fsBody .fsRowBody {
        margin-bottom: 20px !important;
      }
      .fsBody .fsSubField {
        margin-right: 10px;
      }
      @media (max-width: 40em) {
        .fsRow.fsFieldRow.fsLastRow {
          margin-bottom: 20px;
        }
        .fsSubFieldGroup .fsSubField:not(:last-child) {
          margin-bottom: 10px;
        }
      }
      .fsFieldFocused:not(.fsValidationError) {
        background-color: #cfd4d8;
        background-color: rgba(207, 212, 216, 0.25);
      }
      .fsFieldFocused:not(.fsValidationError).fsSpan100 {
        padding: 10px !important;
        margin: -10px -10px !important;
      }
      .fsFieldFocused:not(.fsValidationError).fsSpan75,
      .fsFieldFocused:not(.fsValidationError).fsSpan66,
      .fsFieldFocused:not(.fsValidationError).fsSpan50,
      .fsFieldFocused:not(.fsValidationError).fsSpan33,
      .fsFieldFocused:not(.fsValidationError).fsSpan25 {
        -webkit-box-shadow: 0 0 0 10px #cfd4d8;
        -moz-box-shadow: 0 0 0 10px #cfd4d8;
        box-shadow: 0 0 0 10px #cfd4d8;
        -webkit-box-shadow: 0 0 0 10px rgba(207, 212, 216, 0.25);
        -moz-box-shadow: 0 0 0 10px rgba(207, 212, 216, 0.25);
        box-shadow: 0 0 0 10px rgba(207, 212, 216, 0.25);
      }
      .fsRequiredMarker {
        margin-left: 2.5px !important;
        font-size: 19px;
        color: #f10a1f;
      }
      .fsValidationError {
        background-color: #fae9e9;
        -webkit-box-shadow: 0 0 0 calc(5px - 1px) #fae9e9, 0 0 0 5px #ce5f6d;
        -moz-box-shadow: 0 0 0 calc(5px - 1px) #fae9e9, 0 0 0 5px #ce5f6d;
        box-shadow: 0 0 0 calc(5px - 1px) #fae9e9, 0 0 0 5px #ce5f6d;
      }
      .fsForm input:focus,
      .fsForm select:focus,
      .fsForm textarea:focus,
      .fsForm .ui-slider-handle:focus {
        border-color: #cfd4d8;
        -webkit-box-shadow: 0 0 5px rgba(, 0.75);
        -moz-box-shadow: 0 0 5px rgba(, 0.75);
        box-shadow: 0 0 5px rgba(, 0.75);
      }
      .fsForm :-moz-focusring {
        text-shadow: 0 0 0 #595d64;
      }
      @media screen {
        .fsForm input:focus,
        .fsForm select:focus,
        .fsForm textarea:focus {
          filter: progid:DXImageTransform.Microsoft.Shadow(Color=#595d64, Strength=2, Direction=0) progid:DXImageTransform.Microsoft.Shadow(Color=#595d64, Strength=2, Direction=90) progid:DXImageTransform.Microsoft.Shadow(Color=#595d64, Strength=2, Direction=180) progid:DXImageTransform.Microsoft.Shadow(Color=#595d64, Strength=2, Direction=270);
        }
      }
      div.fsError {
        margin: 0 0 20px 0;
        padding: 10px;
        font-size: 13px;
      }
      .fsBody .showMobile {
        margin-top: 10px;
        font-size: 18px;
      }
      .fsBody .fsLabel,
      .fsBody label {
        font-size: 18px;
        color: #595d64;
      }
      .fsLabelVertical .fsLabel {
        margin-bottom: 10px;
      }
      .fsBody .fsSupporting {
        font-size: 18px;
        font-weight: 400;
        font-style: normal;
        line-height: 18px;
        color: #595d64;
      }
      .fsFieldFocused div.fsSupporting {
        color: #595d64;
      }
      .fsBody .fsCounter {
        font-size: 18px;
        color: #595d64;
      }
      .fsForm .fsLabelHorizontal > label,
      .fsForm .fsLabelHorizontal > legend,
      .fsForm .fsLabelHorizontal > span.fsLabel,
      .fsForm .fsLabelHorizontal legend.fsLabelHorizontal {
        width: calc(25% - 10px);
        margin-right: 10px;
      }
      label.fsOptionLabel {
        font-size: 13px;
        line-height: 26px;
      }
      .fsBody .fieldset-content .fsOptionLabel.horizontal {
        margin-right: 20px;
      }
      @media all and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait),
        all and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {
        .fsOptionLabel {
          line-height: 36px !important;
        }
      }
      @media (max-width: 40em) {
        label.fsOptionLabel {
          border: 1px solid #cfd4d8;
          -webkit-border-radius: 3px;
          -moz-border-radius: 3px;
          -ms-border-radius: 3px;
          -o-border-radius: 3px;
          border-radius: 3px;
          background-color: #f5f7f7;
          color: #171717;
        }
      }
      .fsBody .fsCalloutTop {
        border-color: transparent transparent #595d64 transparent;
      }
      .fsBody .fsCalloutBody {
        padding: 18px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        font-size: 18px;
        line-height: 36px;
        color: #ffffff;
        background-color: #595d64;
      }
      .fsRowBody input[type='text'],
      .fsRowBody input[type='email'],
      .fsRowBody input[type='number'],
      .fsRowBody input[type='tel'],
      .fsForm textarea,
      .fsSignature {
        border: 1px solid #cfd4d8;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        background-color: #ffffff;
        -webkit-transition-property: color, background-color, border,
          border-color, box-shadow;
        -moz-transition-property: color, background-color, border, border-color,
          box-shadow;
        -o-transition-property: color, background-color, border, border-color,
          box-shadow;
        transition-property: color, background-color, border, border-color,
          box-shadow;
        -webkit-transition-duration: 0s;
        -moz-transition-duration: 0s;
        -o-transition-duration: 0s;
        transition-duration: 0s;
        -webkit-transition-timing-function: ease-in-out;
        -moz-transition-timing-function: ease-in-out;
        -o-transition-timing-function: ease-in-out;
        transition-timing-function: ease-in-out;
      }
      .fsRowBody input[type='text'],
      .fsRowBody input[type='email'],
      .fsRowBody input[type='number'],
      .fsRowBody input[type='tel'],
      .fsForm select {
        height: 39px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
      }
      .fsRowBody input[type='text'],
      .fsRowBody input[type='email'],
      .fsRowBody input[type='number'],
      .fsRowBody input[type='tel'],
      .fsForm select,
      .fsForm textarea {
        padding: 6.5px;
        font-size: 13px;
        font-weight: 400;
        font-style: normal;
        line-height: 13px;
        color: #595d64;
      }
      .fsRowBody input[type='text'].fsRequired,
      .fsRowBody input[type='email'].fsRequired,
      .fsRowBody input[type='number'].fsRequired,
      .fsRowBody input[type='tel'].fsRequired,
      .fsForm select.fsRequired,
      .fsForm textarea.fsRequired {
        border: 1px solid #cfd4d8;
        background-color: #ffffff;
      }
      .fsCell {
        -webkit-transition-property: padding, box-shadow, background-color,
          margin-left, margin-right;
        -moz-transition-property: padding, box-shadow, background-color,
          margin-left, margin-right;
        -o-transition-property: padding, box-shadow, background-color,
          margin-left, margin-right;
        transition-property: padding, box-shadow, background-color, margin-left,
          margin-right;
        -webkit-transition-duration: 0s;
        -moz-transition-duration: 0s;
        -o-transition-duration: 0s;
        transition-duration: 0s;
        -webkit-transition-timing-function: ease-in-out;
        -moz-transition-timing-function: ease-in-out;
        -o-transition-timing-function: ease-in-out;
        transition-timing-function: ease-in-out;
      }
      .fsRowBody input[type='radio'],
      .fsRowBody input[type='checkbox'] {
        top: 6.5px;
        width: 13px;
        height: 13px;
      }
      .fsRowBody input[type='radio']:before,
      .fsRowBody input[type='radio']:checked:before,
      .fsRowBody input[type='checkbox']:before,
      .fsRowBody input[type='checkbox']:checked:before {
        width: 13px;
        height: 13px;
        margin-right: 6.5px;
        border: 1px solid #cfd4d8;
        background-color: #ffffff;
      }
      .fsRowBody input[type='radio']:checked:before {
        border: 4px solid #595d64;
      }
      .fsRatingShape .phx-Icon {
        fill: #595d64;
        height: 25px;
        width: 25px;
      }
      .fsRowBody input[type='checkbox']:checked:before {
        border-color: #595d64;
        background-color: #595d64;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 765.2'%3E%3Cpath fill='%23ffffff' d='M960,233.4L468.2,725.1c-53.4,53.4-140,53.4-193.3,0L40,490.3c-53.4-53.4-53.4-140,0-193.3c53.4-53.4,140-53.4,193.3,0	l138.2,138.2L766.6,40c53.4-53.4,140-53.4,193.3,0C1013.3,93.4,1013.3,180,960,233.4z'/%3E%3C/svg%3E");
      }
      .fsForm select {
        padding-right: calc(13px);
        padding-left: calc(6.5px);
        border: 1px solid #cfd4d8;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        color: #595d64;
        background-color: #ffffff;
        -webkit-transition-property: color, background-color, border,
          border-color;
        -moz-transition-property: color, background-color, border, border-color;
        -o-transition-property: color, background-color, border, border-color;
        transition-property: color, background-color, border, border-color;
        -webkit-transition-duration: 0s;
        -moz-transition-duration: 0s;
        -o-transition-duration: 0s;
        transition-duration: 0s;
        -webkit-transition-timing-function: ease-in-out;
        -moz-transition-timing-function: ease-in-out;
        -o-transition-timing-function: ease-in-out;
        transition-timing-function: ease-in-out;
      }
      .fsForm select:not([multiple='multiple']) {
        padding-right: calc(26px);
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1805.18'%3E%3Cpath fill='%23595d64' d='M461.6,643.4L10.9,79.9C-14.9,47.7,8,0,49.3,0h901.5c41.2,0,64.1,47.7,38.4,79.9L538.4,643.4	C518.7,668,481.3,668,461.6,643.4z' transform='rotate(180 500 902.59) translate(0 1143.28)'%3E%3C/path%3E%3Cpath fill='%23595d64' d='M461.6,643.4L10.9,79.9C-14.9,47.7,8,0,49.3,0h901.5c41.2,0,64.1,47.7,38.4,79.9L538.4,643.4	C518.7,668,481.3,668,461.6,643.4z' transform='translate(0 1143.28)'%3E%3C/path%3E%3C/svg%3E");
        background-position: right 6.5px top 50%;
      }
      @media screen {
        .fsForm select {
          padding-right: calc(13px) !important;
        }
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(2).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(1).fsNameFirst {
        width: calc(50% - 10px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(3).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(2).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(1).fsNameFirst {
        width: calc(40% - 10px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(3).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(3).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(3).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(3).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(2).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(2).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(2).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(2).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(1).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(1).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(1).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(1).fsNameSuffix {
        width: calc(20% - 10px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(4).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(3).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(2).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(1).fsNameFirst {
        width: calc(35% - 10px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(4).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(4).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(4).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(4).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(3).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(3).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(3).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(3).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(2).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(2).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(2).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(2).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(1).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(1).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(1).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(1).fsNameSuffix {
        width: calc(15% - 10px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(5).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(4).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(3).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(2).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(1).fsNameFirst {
        width: calc(32% - 10px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(5).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(5).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(5).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(5).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(4).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(4).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(4).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(4).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(3).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(3).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(3).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(3).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(2).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(2).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(2).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(2).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(1).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(1).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(1).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(1).fsNameSuffix {
        width: calc(12% - 10px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(6).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(5).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(4).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(3).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(2).fsNameFirst,
      .fsSubFieldGroup .fsSubField:nth-child(6):nth-last-child(1).fsNameFirst {
        width: calc(28% - 10px);
      }
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(6).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(6).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(6).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(1):nth-last-child(6).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(5).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(5).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(5).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(2):nth-last-child(5).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(4).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(4).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(4).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(3):nth-last-child(4).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(3).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(3).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(3).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(4):nth-last-child(3).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(2).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(2).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(2).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(5):nth-last-child(2).fsNameSuffix,
      .fsSubFieldGroup .fsSubField:nth-child(6):nth-last-child(1).fsNamePrefix,
      .fsSubFieldGroup .fsSubField:nth-child(6):nth-last-child(1).fsNameInitial,
      .fsSubFieldGroup .fsSubField:nth-child(6):nth-last-child(1).fsNameMiddle,
      .fsSubFieldGroup .fsSubField:nth-child(6):nth-last-child(1).fsNameSuffix {
        width: calc(11% - 10px);
      }
      .fsBody .fsSubField.fsFieldAddress {
        width: 100%;
      }
      .fsBody .fsSubField.fsFieldAddress2 {
        width: 100%;
      }
      .fsBody .fsSubField.fsFieldCity {
        width: calc(60% - 10px);
      }
      .fsBody .fsSubField.fsFieldState {
        width: calc(30% - 10px);
      }
      .fsBody .fsSubFieldGroup ~ select[name*='-country'] {
        margin-top: 10px !important;
      }
      .fsBody .fsSubField.fsFieldAddress,
      .fsBody .fsSubField.fsFieldAddress2 {
        margin-bottom: 10px;
      }
      @media all and (max-width: 699px),
        all and (device-height: 1024px) and (device-width: 768px) and (orientation: portrait),
        all and (device-height: 1024px) and (device-width: 768px) and (orientation: landscape) {
        .fsBody .fsSubField.fsFieldCity {
          margin-bottom: 10px;
        }
        .fsBody .fsSubField.fsFieldState {
          width: calc(70% - 10px);
        }
      }
      @media (max-width: 40em) {
        div.fsSubField.fsFieldState {
          margin-right: 10px;
        }
      }
      div.fsSliderValue {
        padding: 6.5px 13px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        font-size: 13px;
        line-height: 18px;
        color: #ffffff;
        background-color: #595d64;
      }
      .fsSliderDiv {
        font-size: 13px;
        background-color: #595d64;
      }
      .fsSliderDiv .ui-state-default,
      .fsSliderDiv .ui-widget-content .ui-state-default {
        background-color: #595d64;
      }
      .fsSliderDiv .ui-state-active,
      .fsSliderDiv .ui-widget-content .ui-state-active {
        background-color: #595d64;
      }
      .fsSliderDiv .ui-corner-all,
      .fsSliderDiv.ui-corner-all {
        -moz-border-radius-topleft: 3px;
        -webkit-border-top-left-radius: 3px;
        border-top-left-radius: 3px;
        -moz-border-radius-topright: 3px;
        -webkit-border-top-right-radius: 3px;
        border-top-right-radius: 3px;
        -moz-border-radius-bottomleft: 3px;
        -webkit-border-bottom-left-radius: 3px;
        border-bottom-left-radius: 3px;
        -moz-border-radius-bottomright: 3px;
        -webkit-border-bottom-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }
      .fsSliderDiv.ui-widget-content {
        border: 1px solid #428fec !important;
      }
      .fsSliderDiv .ui-widget-header {
        background-color: #428fec;
      }
      .fsCurrency {
        margin-right: 5px !important;
        font-size: 13px;
        line-height: 36px;
        color: #595d64;
      }
      .fsCurrency.fsCurrencySuffix {
        margin-right: 0 !important;
        margin-left: 5px !important;
      }
      .fsCurrency ~ input.fsField {
        width: calc(96% - 5px) !important;
      }
      .fsRowBody input[type='email'] ~ p {
        margin-top: 10px;
      }
      @font-face {
        font-family: 'TextMask';
        src: url('/forms/fonts/3/password.ttf') format('truetype');
        font-weight: 400;
        font-style: normal;
      }
      .fsTextMask {
        font-family: 'TextMask' !important;
      }
      .fsRowBody input[type='text'] ~ p {
        margin-top: 10px;
      }
      .fsProductField__fields__quantity {
        color: #595d64;
      }
      .fsProductField__fields__fixed-amount,
      .fsProductField__fields__no-charge {
        font-size: 13px;
        color: #595d64;
      }
      .fsProductField__info__name {
        font-size: 18px;
        color: #595d64;
      }
      .fsProductField__info__description {
        margin-top: 5px;
        font-size: 18px;
        line-height: 18px;
        color: #595d64;
      }
      .fsProductField__fields__sold-out {
        font-size: 13px;
        color: #f10a1f;
      }
      .fsProductField__wait-list {
        margin-top: 10px;
      }
      @media (max-width: 40em) {
        .fsProductField__image {
          -webkit-border-radius: 3px;
          -moz-border-radius: 3px;
          -ms-border-radius: 3px;
          -o-border-radius: 3px;
          border-radius: 3px;
        }
        .fsProductField__fields__fixed-amount,
        .fsProductField__fields__quantity {
          font-size: 13px;
        }
      }
      .fsMatrix {
        font-size: 18px;
        color: #595d64;
      }
      .fsMatrix th,
      .fsMatrix td {
        border-top: 1px solid #cfd4d8;
        border-left: 1px solid #cfd4d8;
      }
      .fsMatrix th:nth-child(2) {
        -webkit-border-radius: 3px 0 0 0;
        -moz-border-radius: 3px 0 0 0;
        -ms-border-radius: 3px 0 0 0;
        -o-border-radius: 3px 0 0 0;
        border-radius: 3px 0 0 0;
      }
      .fsMatrix tr:first-child th:last-child {
        -webkit-border-radius: 0 3px 0 0;
        -moz-border-radius: 0 3px 0 0;
        -ms-border-radius: 0 3px 0 0;
        -o-border-radius: 0 3px 0 0;
        border-radius: 0 3px 0 0;
      }
      .fsMatrix tr:last-child td:last-child {
        -webkit-border-radius: 0 0 3px 0;
        -moz-border-radius: 0 0 3px 0;
        -ms-border-radius: 0 0 3px 0;
        -o-border-radius: 0 0 3px 0;
        border-radius: 0 0 3px 0;
      }
      .fsMatrix tr:last-child th {
        -webkit-border-radius: 0 0 0 3px;
        -moz-border-radius: 0 0 0 3px;
        -ms-border-radius: 0 0 0 3px;
        -o-border-radius: 0 0 0 3px;
        border-radius: 0 0 0 3px;
      }
      .fsMatrix tr:last-child th,
      .fsMatrix tr:last-child td {
        border-bottom: 1px solid #cfd4d8;
      }
      .fsMatrix tr th:last-child,
      .fsMatrix tr td:last-child {
        border-right: 1px solid #cfd4d8;
      }
      .fsMatrix th.fsMatrixLabelColumn {
        text-align: center;
      }
      .fsMatrix th.fsMatrixLabelRow {
        text-align: right;
      }
      .fsMatrix th.fsMatrixLabelColumn,
      .fsMatrix th.fsMatrixLabelRow {
        padding: 9px;
      }
      .fsMatrixCol1 {
        background: #f1f2f2;
        background: rgba(241, 242, 242, 0.2);
      }
      .fsMatrixCol2 {
        background: #428fec;
        background: rgba(66, 143, 236, 0.2);
      }
      .rtl .fsMatrix th,
      .rtl .fsMatrix td {
        border-right: 1px solid #cfd4d8;
      }
      .fsForm input[type='file']::-webkit-file-upload-button,
      .fsForm .fsFileUploadButton {
        height: 36px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        font-size: 13px;
        color: #ffffff;
        background-color: #595d64;
      }
      .fsFileUploadName {
        font-size: 13px;
      }
      .fsBody .fieldset-content .always-ltr {
        margin-top: 10px;
      }
      .fsBody .fieldset-content select span,
      .fsBody .fieldset-content .always-ltr span,
      .fsBody .fieldset-content .always-ltr-align-right span {
        top: 9px;
      }
      .fsBody .fieldset-content select {
        margin-right: 10px;
      }
      .fsBody .fieldset-content span {
        right: 5px;
      }
      .fsBody .ui-datepicker-trigger {
        top: 9px;
        margin-left: 10px;
      }
      .fsSignatureClear {
        font-size: 18px;
        color: #595d64;
      }
      .fsSignature + div {
        margin-left: 10px;
        line-height: 18px;
      }
      .wf-active .fsSignature {
        font-family: Arial, Tahoma, sans-serif;
      }
      img.fsCreditCardLogo {
        margin-top: 5px;
      }
      .fsBody .fsSectionHeader {
        background-color: #f5f7f7;
      }
      .fsBody .fsForm .fsSectionHeading {
        margin-bottom: 10px;
        text-align: center;
        font-size: 29px;
        font-weight: 400;
        font-style: normal;
        line-height: 29px;
        color: #171717;
      }
      .fsborderradius .fsBody .fsSectionHeader {
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
      }
      .fsborderradius .fsBody .fsSectionHeader {
        margin-bottom: 40px;
      }
      .fsBody .fsSectionHeader {
        padding: 20px;
      }
      .fsForm select[multiple='multiple']::-webkit-scrollbar-thumb,
      .fsForm textarea::-webkit-scrollbar-thumb {
        background-color: #cfd4d8;
      }
      .fsForm .fsSubmit {
        margin-top: 40px;
        padding: 20px 0;
      }
      .fsPreviousButton,
      .fsSubmitButton,
      .fsNextButton {
        padding: 20px 25px;
        border: 1px solid transparent;
        -webkit-border-radius: 3px !important;
        -moz-border-radius: 3px !important;
        -ms-border-radius: 3px !important;
        -o-border-radius: 3px !important;
        border-radius: 3px !important;
        font-size: 18px !important;
        font-weight: 700;
        font-style: normal;
        line-height: 18px;
        color: #ffffff !important;
        background-color: #008c3c !important;
      }
      div.fsProgress {
        margin-top: 20px;
      }
      div.fsProgressBarContainer {
        height: 18px;
        background-color: #f1f2f2;
      }
      div.fsProgressText {
        margin-top: -18px;
        font-size: 9px;
        line-height: 18px;
        color: #595d64;
      }
      div.fsProgressBar {
        background-color: #428fec;
      }
      div.fsSaveIncomplete {
        margin-bottom: 20px;
        padding: 10px 0;
        background-color: #f1f2f2;
      }
      div.fsSaveIncomplete a {
        font-size: 13px;
        color: #595d64;
      }
      div.fsSaveIncomplete a:visited {
        color: #595d64;
      }
      @media all and (max-width: 699px),
        all and (device-height: 1024px) and (device-width: 768px) and (orientation: portrait),
        all and (device-height: 1024px) and (device-width: 768px) and (orientation: landscape) {
        .fsPagination .fsNextButton,
        .fsPagination .fsPreviousButton {
          background-color: #008c3c;
        }
        .fsPagination .fsSubmitMultipage {
          margin-top: 20px !important;
        }
      }
      #fsSubmissionCheckmark {
        margin: 10px 0;
        background-image: linear-gradient(transparent, transparent),
          url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath fill='%23595d64' d='M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M749.4,423	L495.6,676.8c-27.6,27.6-72.2,27.6-99.8,0L274.7,555.6c-27.6-27.6-27.6-72.2,0-99.8c27.6-27.6,72.2-27.6,99.8,0l71.3,71.3	l203.9-203.9c27.6-27.6,72.2-27.6,99.8,0C777,350.8,777,395.5,749.4,423z'/%3E%3C/svg%3E");
      }
      #fsSubmissionCheckmark ~ .fsSectionHeading {
        margin-bottom: 10px;
      }
      #fsSubmissionCheckmark ~ .fsSectionText {
        text-align: center;
      }
      #recaptcha_area {
        margin-bottom: 20px;
      }
      .recaptchatable img:hover {
        -webkit-box-shadow: 0px 0px 0px 1px #f10a1f;
        -moz-box-shadow: 0px 0px 0px 1px #f10a1f;
        box-shadow: 0px 0px 0px 1px #f10a1f;
      }
      .fsForm .fsWorkflowSendBack {
        margin-top: 20px;
        font-size: 16px;
      }
      .fsForm .fsWorkflowSendBack a {
        text-decoration: underline;
        cursor: pointer;
      }
      .fsForm .fsWorkflowSendBack svg {
        margin-bottom: -2px;
        width: 14px;
        height: 14px;
        fill: #595d64;
      }
      .fsEmbed .fsWelcomeMessage {
        position: relative;
      }
      .fsWelcomeMessage:not(.fsWelcomeMessage--hidden) + form.fsForm {
        display: none;
      }
      .fsWelcomeMessage--hidden + form.fsForm {
        display: inherit;
      }
      .fsWelcomeMessage {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        padding: 0;
        z-index: 99999;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
      .fsWelcomeMessage.fsWelcomeMessage--hidden {
        display: none;
      }
      .fsWelcomeMessage .fsWelcomeMessage__header {
        position: absolute;
        width: 180px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left center;
        height: 82px;
        z-index: 10;
        margin-left: 19px;
        top: 2px;
        left: 0;
      }
      .fsWelcomeMessage .fsWelcomeMessage__image {
        background-repeat: no-repeat;
        background-size: unset;
        background-position: center;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 8;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__image.fsWelcomeMessage__sizing--repeat {
        background-repeat: repeat;
        background-size: unset;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__image.fsWelcomeMessage__sizing--contain {
        background-size: contain;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__image.fsWelcomeMessage__sizing--cover {
        background-size: cover;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__image.fsWelcomeMessage__sizing--stretch {
        background-size: 100% 100%;
      }
      .fsWelcomeMessage .fsWelcomeMessage__content {
        z-index: 9;
        background-color: #ffffff;
        padding: 40px;
        margin: 10px;
        border-radius: 6px;
        position: relative;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__content.fsWelcomeMessage__content--hide-form-background {
        background-color: transparent;
      }
      .fsWelcomeMessage .fsWelcomeMessage__content .fsWelcomeMessage__message {
        color: #595d64;
        font-size: 29px;
      }
      .fsWelcomeMessage
        .fsWelcomeMessage__content
        .fsWelcomeMessage__start-button {
        padding: 20px 25px;
        margin-top: 40px;
        border: 1px solid transparent;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        -ms-border-radius: 3px;
        -o-border-radius: 3px;
        border-radius: 3px;
        font-size: 18px;
        font-weight: 700;
        font-style: normal;
        line-height: 18px;
        color: #ffffff;
        background-color: #008c3c;
        cursor: pointer;
      }
      html:not([data-scroll='0']) .survey-mode.fsBody .fsForm .survey-header {
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
      }
      .survey-mode.fsBody #fsHeaderImage {
        transition: all 0.1s;
        position: fixed;
        width: 180px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left center;
        height: 82px;
        z-index: 10;
        margin: 2px 0 0 19px;
        top: 0;
        left: 0;
      }
      .survey-mode.fsBody #fsHeaderImage.fsHeaderImage--relative {
        display: none;
      }
      .survey-mode.fsBody .fsHeaderImage--sticky {
        transition: all 0.1s;
        position: absolute;
        width: 180px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left center;
        height: 82px;
        z-index: 10;
        margin-left: 19px;
        bottom: 2px;
        left: 0;
      }
      .survey-mode.fsBody .payment-warning {
        margin-top: 61px;
        margin-left: 7px;
        margin-right: 7px;
      }
      .survey-mode.fsBody .fsSignatureClear {
        text-decoration: none;
        background: #fff;
        color: #000;
        padding: 7px 12px;
        border-radius: 3px;
        text-transform: capitalize;
      }
      .survey-mode.fsBody [fs-field-type='signature'] .fsSupporting {
        clear: left;
        margin-left: 12px;
        margin-top: 9px;
        line-height: 1.5;
      }
      .survey-mode.fsBody .fsForm {
        margin-top: 140px !important;
        min-width: inherit;
        width: 100%;
        background-color: #ffffff;
        border: none;
        max-width: 1024px;
      }
      .survey-mode.fsBody .fsForm .g-recaptcha .grecaptcha-badge {
        z-index: 9;
      }
      .survey-mode.fsBody
        .fsForm.with-ads:not(.fsgo-form)
        .g-recaptcha
        .grecaptcha-badge {
        bottom: 54px !important;
      }
      .survey-mode.fsBody .fsForm.with-ads:not(.fsgo-form) .fsProgress {
        bottom: 40px;
      }
      .survey-mode.fsBody .fsForm .fsSignature + div {
        margin-top: 7px;
        line-height: 1.5;
      }
      .survey-mode.fsBody .fsForm .fsProgress {
        position: fixed;
        border: 0;
        bottom: 0;
        left: 0;
        z-index: 11;
      }
      .survey-mode.fsBody .fsForm .fsProgress div.fsProgressText {
        display: none;
      }
      .survey-mode.fsBody .fsForm .fsProgress div.fsProgressBar {
        transition: width 1s;
      }
      .survey-mode.fsBody .fsForm .survey-header {
        background-color: #ffffff;
        z-index: 9;
        box-sizing: border-box;
        position: fixed;
        width: 100%;
        top: -1px;
        left: 0;
        height: 88px;
        display: flex;
        align-items: flex-end;
        padding: 19px;
        transition: all 0.1s linear;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header.with-progressbar
        div.shareLinksWrapper {
        margin-bottom: 11px;
      }
      .survey-mode.fsBody .fsForm .survey-header .fsSubmit.fsPagination {
        position: relative;
        flex: 1;
        padding: 0;
        margin: 0 0 7px 0;
        display: flex;
        justify-content: flex-end;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        span.fsFull {
        display: none;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsSubmitButton {
        display: inline-block;
        width: auto;
        margin: 0 !important;
        height: 44px;
        padding: 0 30px;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsNextButton,
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsPreviousButton,
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsSubmitButton {
        margin-right: 29px;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsNextButton,
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsPreviousButton {
        width: 41px;
        height: 41px;
        padding: 0;
        -webkit-border-radius: 50% !important;
        -moz-border-radius: 50% !important;
        -ms-border-radius: 50% !important;
        -o-border-radius: 50% !important;
        border-radius: 50% !important;
        user-select: none;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsSlim {
        display: none;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsNextButton:before,
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsPreviousButton:before {
        display: block;
        text-indent: 0;
        font-size: 1.5em;
        line-height: 0;
        font-family: 'Zapf Dingbats';
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsNextButton:before {
        content: '➤';
        margin-left: 3px;
        margin-top: 3px;
      }
      .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsPreviousButton:before {
        content: '➤';
        transform: rotate(180deg);
        margin-left: -3px;
      }
      .rtl
        .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsNextButton:before {
        content: '➤';
        transform: rotate(180deg);
      }
      .rtl
        .survey-mode.fsBody
        .fsForm
        .survey-header
        .fsSubmit.fsPagination
        .fsPreviousButton:before {
        content: '➤';
      }
      @media all and (max-width: 1024px) {
        .survey-mode.fsBody .fsHeaderImage.fsHeaderImage--relative {
          display: none;
        }
        .survey-mode.fsBody .payment-warning {
          margin-top: 91px;
        }
        .survey-mode.fsBody #fsFooterImage {
          margin-bottom: 61px;
        }
        .survey-mode.fsBody .fsForm label.fsOptionLabel {
          color: #595d64;
        }
        .survey-mode.fsBody .fsForm .survey-header .fsSubmit.fsPagination {
          margin-top: 0 !important;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsProgress {
          margin-top: 0;
          position: fixed;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          div.shareLinksWrapper {
          margin-bottom: 12px;
        }
        .survey-mode.fsBody .fsForm .fsFieldHighlight.fsSubFieldGroup {
          flex-direction: column;
        }
        .survey-mode.fsBody
          .fsForm
          [fs-field-type='address']
          .fsSubFieldGroup
          .fsSubField {
          width: 100%;
          margin-bottom: 15px;
        }
        .survey-mode.fsBody
          .fsForm
          [fs-field-type='address']
          .fsFieldHighlight
          > select {
          margin-top: 0 !important;
        }
        .survey-mode.fsBody
          .fsForm
          [fs-field-type='address']
          .fsFieldHighlight
          > label {
          margin-top: 7px;
        }
        .survey-mode.fsBody .fsForm [fs-field-type='name'] .fsSubField {
          width: 100%;
        }
        .survey-mode.fsBody
          .fsForm
          [fs-field-type='name']
          .fsSubField:not(:last-child) {
          margin-bottom: 10px;
        }
      }
      @media all and (max-width: 480px) {
        .survey-mode.fsBody #fsHeaderImage {
          position: relative;
          transform: scale(0.8);
          transform-origin: left center;
          height: 51px;
        }
        .survey-mode.fsBody #fsHeaderImage.fsHeaderImage--relative {
          display: block;
        }
        .survey-mode.fsBody .fsHeaderImage--sticky {
          display: none;
        }
        .survey-mode.fsBody .payment-warning {
          margin-top: 11px;
        }
        .survey-mode.fsBody #fsFooterImage {
          margin-bottom: 121px;
        }
        .survey-mode.fsBody .fsForm {
          position: relative;
          margin-top: 0 !important;
          padding: 30px 19px;
          margin-bottom: 20px !important;
          overflow: hidden;
        }
        .survey-mode.fsBody .fsForm .reportAbuse {
          margin-bottom: 51px !important;
        }
        .survey-mode.fsBody .fsForm .g-recaptcha .grecaptcha-badge {
          bottom: 64px !important;
        }
        .survey-mode.fsBody
          .fsForm.with-ads:not(.fsgo-form)
          .g-recaptcha
          .grecaptcha-badge {
          bottom: 104px !important;
        }
        .survey-mode.fsBody .fsForm.with-ads:not(.fsgo-form) .survey-header {
          bottom: 40px;
        }
        .survey-mode.fsBody .fsForm .fsRatingFieldContainer svg.phx-Icon {
          max-height: 60px;
        }
        .survey-mode.fsBody .fsForm .fsRatingFieldContainer .fsRatingPipButton {
          margin: 0 2px;
        }
        .survey-mode.fsBody .fsForm .fsSignature {
          margin: 0 -12px;
        }
        .survey-mode.fsBody .fsForm .survey-header {
          padding: 12px;
          height: 51px;
          margin: 0;
          position: fixed;
          bottom: 0;
          left: 0;
          top: unset;
          box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.25);
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsHeaderImage.fsHeaderImage--sticky {
          display: none;
        }
        .survey-mode.fsBody .fsForm .survey-header.with-progressbar {
          padding: 12px 12px 22px;
          height: 61px;
        }
        .survey-mode.fsBody .fsForm .survey-header .fsSubmit.fsPagination {
          justify-content: space-between;
          margin-bottom: 0;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          div.shareLinksWrapper {
          margin-bottom: 59px;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsProgress {
          position: fixed;
          margin-top: 0;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsProgress
          .fsProgressBarContainer {
          height: 12px;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsSubmitButton {
          height: 31px;
          padding: 7px;
          margin-left: auto !important;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsNextButton {
          margin-left: auto;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsNextButton,
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsPreviousButton,
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsSubmitButton {
          margin-right: 12px;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsNextButton,
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsPreviousButton {
          width: 31px;
          height: 31px;
        }
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsNextButton:before,
        .survey-mode.fsBody
          .fsForm
          .survey-header
          .fsSubmit.fsPagination
          .fsPreviousButton:before {
          font-size: 1.3em;
        }
      }
      .survey-mode .fsForm .fsFieldFocused:not(.fsValidationError) {
        background-color: transparent;
      }
      .survey-mode .fsForm .fsFieldFocused:not(.fsValidationError).fsSpan100 {
        margin: 0 !important;
        padding: 0 !important;
      }
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError).fsSpan100.fsRowBody {
        margin-bottom: 20px !important;
      }
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError)
        .fsFieldHighlight {
        background-color: rgba(207, 212, 216, 0.25);
      }
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError)
        .fsFieldHighlight::after {
        background-color: rgba(207, 212, 216, 0.25);
      }
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError)
        .fsOptionLabel:focus,
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError)
        .fsOptionLabel:active {
        background-color: rgba(207, 212, 216, 0.25);
      }
      .survey-mode
        .fsForm
        .fsFieldFocused:not(.fsValidationError)
        .fsOptionLabel {
        -webkit-tap-highlight-color: rgba(207, 212, 216, 0.3);
      }
      .survey-mode .fsForm .fieldset-content label.fsOptionLabel {
        background-color: #ffffff;
      }
      .survey-mode .fsForm .fsSubField label.fsSupporting {
        margin-top: 7px;
      }
      .survey-mode .fsForm .fsSubField.fsFieldCity {
        padding: 0;
      }
      .survey-mode .fsForm .fsSubField.fsSubField.fsFieldState {
        padding: 0;
      }
      .survey-mode .fsForm .fsSubField.fsFieldZip {
        padding: 0;
      }
      .survey-mode .fsForm .fsRatingFieldContainer {
        box-sizing: border-box;
        border-radius: 6px;
        display: flex;
      }
      .survey-mode .fsForm .fsRatingFieldContainer svg.phx-Icon {
        max-height: 100px;
        max-width: 100px;
        height: auto;
        width: 100%;
      }
      .survey-mode .fsForm .fsRatingFieldContainer .fsRatingPipButton {
        margin: 25px 5px;
        flex: 1;
        max-width: 133px;
      }
      .survey-mode .fsForm .fsRatingFieldContainer .fsRatingPipButton:focus {
        opacity: 1;
      }
      .survey-mode .fsForm .fsFieldHighlight {
        background-color: #ffffff;
        padding: 19px;
        box-sizing: border-box;
        border-radius: 6px;
        z-index: 5;
        position: relative;
      }
      .survey-mode .fsForm .fsFieldHighlight::before {
        background-color: #ffffff;
        border-radius: 6px;
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        z-index: -1;
        left: 0;
        top: 0;
      }
      .survey-mode .fsForm .fsFieldHighlight::after {
        transition: background-color 0.4s;
        background-color: #ffffff;
        border-radius: 6px;
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        z-index: -1;
        left: 0;
        top: 0;
      }
      .survey-mode .fsForm .fsFieldHighlight.fsSubFieldGroup {
        display: flex;
      }
      .survey-mode .fsForm [fs-field-type='address'] .fsFieldHighlight {
        margin-bottom: 20px;
      }
      .survey-mode .fsForm [fs-field-type='address'] .fsFieldHighlight > label {
        margin-top: 7px;
      }
      .survey-mode .fsForm [fs-field-type='datetime'] .fsFieldHighlight::after {
        clear: both;
        content: '';
        display: table;
      }
      .survey-mode .fsForm table.fsMatrix td {
        padding: 19px 0;
      }
      .survey-mode .fsForm table.fsMatrix th {
        padding: 19px 6.5px;
      }
      .survey-mode .fsForm label.fsOptionLabel {
        display: block;
        margin: 0.5em 0;
        padding: 0.5em 1em;
        line-height: 26px !important;
        cursor: pointer;
      }
      .survey-mode .fsForm label.fsOptionLabel.horizontal {
        float: none;
        margin: 0.5em 0;
        margin-right: 0 !important;
      }
      .survey-mode .fsForm label.fsOptionLabel.horizontal ~ div.horizontal {
        display: block !important;
        margin-top: 0 !important;
      }
      .survey-mode .fsForm label.fsOptionLabel.vertical ~ div.vertical {
        margin-top: 0 !important;
      }
      .survey-mode .fsForm .fieldset-content .fsOptionLabel:first-child {
        margin-top: 0;
      }
      .survey-mode
        .fsForm
        .rtl
        .fsFieldRow
        .fieldset-content
        .fsOptionLabel.horizontal {
        float: none !important;
        margin: 0 0 0 20px;
      }
      .fsSubmissionMessageImage {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        padding: 0;
        z-index: 99999;
        margin: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
      .fsSubmissionMessageImage.fsSubmissionMessageImage--hidden {
        display: none;
      }
      .fsSubmissionMessageImage .fsSubmissionMessageImage__header {
        position: absolute;
        width: 180px;
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: left center;
        height: 82px;
        z-index: 10;
        margin-left: 19px;
        top: 2px;
        left: 0;
      }
      .fsSubmissionMessageImage .fsSubmissionMessageImage__image {
        background-repeat: no-repeat;
        background-size: unset;
        background-position: center;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 8;
      }
      .fsSubmissionMessageImage
        .fsSubmissionMessageImage__image.fsSubmissionMessageImage__sizing--repeat {
        background-repeat: repeat;
        background-size: unset;
      }
      .fsSubmissionMessageImage
        .fsSubmissionMessageImage__image.fsSubmissionMessageImage__sizing--contain {
        background-size: contain;
      }
      .fsSubmissionMessageImage
        .fsSubmissionMessageImage__image.fsSubmissionMessageImage__sizing--cover {
        background-size: cover;
      }
      .fsSubmissionMessageImage
        .fsSubmissionMessageImage__image.fsSubmissionMessageImage__sizing--stretch {
        background-size: 100% 100%;
      }
      .fsSubmissionMessageImage .fsSubmissionMessageImage__content {
        z-index: 9;
        background-color: #ffffff;
        padding: 40px;
        margin: 10px;
        border-radius: 6px;
        position: relative;
      }
      .fsSubmissionMessageImage
        .fsSubmissionMessageImage__content.fsSubmissionMessageImage__content--hide-form-background {
        background-color: transparent;
      }
    </style>
    <style type="text/css">
      .fsSupporting {
        margin-bottom: 10px;
      }
      .fsSectionHeading {
        margin-top: 10px !important;
      }
      .fsError {
        display: none;
      }
      .fsSectionHeader:not(:has(> *)) {
        display: none;
      }
    </style>
    <form
      method="post"
      accept-charset="UTF-8"
      novalidate=""
      enctype="multipart/form-data"
      action="https://tuftsmedicine.formstack.com/forms/index.php"
      class="fsForm fsMultiColumn"
      id="fsForm5374790"
    >
      <input type="hidden" name="form" value="5374790" />
      <input type="hidden" name="viewkey" value="eMa9ojGgNP" />
      <input type="hidden" name="password" value="" />
      <input
        type="hidden"
        name="hidden_fields"
        id="hidden_fields5374790"
        value=""
      />
      <input type="hidden" name="incomplete" id="incomplete5374790" value="" />
      <input
        type="hidden"
        name="incomplete_password"
        id="incomplete_password5374790"
      />
      <input
        type="hidden"
        name="referrer"
        id="referrer5374790"
        value="http://tufts.docksal.site/"
      />
      <input
        type="hidden"
        name="referrer_type"
        id="referrer_type5374790"
        value="js"
      />
      <input type="hidden" name="_submit" value="1" />
      <input type="hidden" name="style_version" value="3" />
      <input type="hidden" id="viewparam" name="viewparam" value="1108780" />
      <div id="requiredFieldsError" style="display:none;">
        Please fill in a valid value for all required fields
      </div>
      <div id="invalidFormatError" style="display:none;">
        Please ensure all values are in a proper format.
      </div>
      <div id="resumeConfirm" style="display:none;">
        Are you sure you want to leave this form and resume later?
      </div>
      <div id="resumeConfirmPassword" style="display: none;">
        Are you sure you want to leave this form and resume later? If so, please
        enter a password below to securely save your form.
      </div>
      <div id="saveAndResume" style="display: none;">Save and Resume Later</div>
      <div id="saveResumeProcess" style="display: none;">Save and get link</div>
      <div id="fileTypeAlert" style="display:none;">
        You must upload one of the following file types for the selected field:
      </div>
      <div id="embedError" style="display:none;">
        There was an error displaying the form. Please copy and paste the embed
        code again.
      </div>
      <div id="applyDiscountButton" style="display:none;">Apply Discount</div>
      <div id="dcmYouSaved" style="display:none;">You saved</div>
      <div id="dcmWithCode" style="display:none;">with code</div>
      <div id="submitButtonText" style="display:none;">Submit Form</div>
      <div id="submittingText" style="display:none;">Submitting</div>
      <div id="validatingText" style="display:none;">Validating</div>
      <div id="autocaptureDisabledText" style="display:none;"></div>
      <div id="paymentInitError" style="display:none;">
        There was an error initializing the payment processor on this form.
        Please contact the form owner to correct this issue.
      </div>
      <div id="checkFieldPrompt" style="display:none;">
        Please check the field:
      </div>
      <div id="translatedWord-fields" style="display:none;">Fields</div>
      <div class="fsPage" id="fsPage5374790-1">
        <div
          id="ReactContainer5374790"
          style="display:none"
          class="FsReactContainerInitApp"
          data-fs-react-app-id="5374790"
        ></div>

        <div class="fsSection fs2Col" id="fsSection148427522">
          <div class="fsSectionHeader">
            <h2 class="fsSectionHeading">
              Referring Physician/Clinician Information
            </h2>
          </div>

          <div id="fsRow5374790-2" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148429737"
              aria-describedby="fsSupporting148429737"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148429737"
                class="fsSupporting"
                aria-hidden="true"
              >
                Physician/Clinician Group
                <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="text"
                id="field148429737"
                name="field148429737"
                size="50"
                required=""
                value=""
                class="fsField fsFormatText fsRequired   "
                aria-required="true"
                aria-label="Physician/Clinician Group *"
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50"
              id="fsCell148429690"
              aria-describedby="fsSupporting148429690"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148429690"
                class="fsSupporting"
                aria-hidden="true"
              >
                Physician/Clinician Name <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="text"
                id="field148429690"
                name="field148429690"
                size="50"
                required=""
                value=""
                class="fsField fsFormatText fsRequired   "
                aria-required="true"
                aria-label="Physician/Clinician Name *"
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-3" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148429957"
              aria-describedby="fsSupporting148429957"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148429957"
                class="fsSupporting"
                aria-hidden="true"
              >
                Office Contact Name <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="text"
                id="field148429957"
                name="field148429957"
                size="50"
                required=""
                value=""
                class="fsField fsFormatText fsRequired   "
                aria-required="true"
                aria-label="Office Contact Name *"
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50"
              id="fsCell148430006"
              aria-describedby="fsSupporting148430006"
              lang="en"
              fs-field-type="phone"
              fs-field-validation-name="Phone"
            >
              <div
                id="fsSupporting148430006"
                class="fsSupporting"
                aria-hidden="true"
              >
                Office Contact Phone Number
                <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="tel"
                id="field148430006"
                name="field148430006"
                size="2"
                required=""
                value=""
                class="fsField fsFormatPhoneUS  fsRequired"
                aria-required="true"
                data-country="US"
                data-format="national"
                aria-label="Office Contact Phone Number *"
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-4" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148430169"
              aria-describedby="fsSupporting148430169"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148430169"
                class="fsSupporting"
                aria-hidden="true"
              >
                MD Requested (if known)
              </div>

              <input
                type="text"
                id="field148430169"
                name="field148430169"
                size="50"
                value=""
                class="fsField fsFormatText    "
                aria-label="MD Requested (if known)"
              />
            </div>
            <div class="fs-clear"></div>
          </div>
        </div>

        <div class="fsSection fs2Col" id="fsSection148430369">
          <div class="fsSectionHeader">
            <h2 class="fsSectionHeading">Patient Information</h2>
          </div>

          <div id="fsRow5374790-6" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148427523"
              aria-describedby="fsSupporting148427523"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="first_name"
            >
              <div
                id="fsSupporting148427523"
                class="fsSupporting"
                aria-hidden="true"
              >
                First Name <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="text"
                id="field148427523"
                name="field148427523"
                size="50"
                required=""
                value=""
                class="fsField fsFormatText fsRequired   "
                aria-required="true"
                aria-label="First Name *"
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50"
              id="fsCell148427524"
              aria-describedby="fsSupporting148427524"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="last_name"
            >
              <div
                id="fsSupporting148427524"
                class="fsSupporting"
                aria-hidden="true"
              >
                Last Name <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="text"
                id="field148427524"
                name="field148427524"
                size="50"
                required=""
                value=""
                class="fsField fsFormatText fsRequired   "
                aria-required="true"
                aria-label="Last Name *"
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-7" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148431937"
              aria-describedby="fsSupporting148431937"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148431937"
                class="fsSupporting"
                aria-hidden="true"
              >
                Patient's Height <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="text"
                id="field148431937"
                name="field148431937"
                size="50"
                required=""
                value=""
                class="fsField fsFormatText fsRequired   "
                aria-required="true"
                aria-label="Patient's Height *"
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50"
              id="fsCell148431940"
              aria-describedby="fsSupporting148431940"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148431940"
                class="fsSupporting"
                aria-hidden="true"
              >
                Patient's Weight <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="text"
                id="field148431940"
                name="field148431940"
                size="50"
                value=""
                class="fsField fsFormatText    "
                aria-label="Patient's Weight *"
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-8" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148432897"
              aria-describedby="fsSupporting148432897"
              lang="en"
              fs-field-type="datetime"
              fs-field-validation-name="Date/Time"
            >
              <fieldset
                role="group"
                aria-labelledby="fsSupporting148432897"
                id="label148432897"
              >
                <legend
                  id="fsLegend148432897"
                  class="fsLabel fsRequiredLabel fsLabelVertical hidden"
                >
                  <span>Date/Time<span class="fsRequiredMarker">*</span></span>
                </legend>
                <div class="fieldset-content">
                  <div
                    id="fsSupporting148432897"
                    class="fsSupporting"
                    aria-hidden="true"
                  >
                    *Patients Date of Birth
                  </div>

                  <!-- Used to pull in url for jquery -->
                  <span
                    aria-hidden="true"
                    style="display:none;"
                    id="fsCalendar148432897ImageUrl"
                    >https://tuftsmedicine.formstack.com/forms/images/2/calendar.png</span
                  >

                  <input
                    data-skip-validation=""
                    data-date-format="M d, Y"
                    type="hidden"
                    id="field148432897Format"
                    name="field148432897Format"
                    value="MDY"
                    aria-label="*Patients Date of Birth"
                  />

                  <div class="hidden">
                    <label for="field148432897M">Month</label>
                  </div>
                  <select
                    id="field148432897M"
                    name="field148432897M"
                    class=" fsField fsRequired"
                    aria-required="true"
                    aria-label="*Patients Date of Birth, Month"
                  >
                    <option value=""></option>
                    <option value="Jan">Jan</option>
                    <option value="Feb">Feb</option>
                    <option value="Mar">Mar</option>
                    <option value="Apr">Apr</option>
                    <option value="May">May</option>
                    <option value="Jun">Jun</option>
                    <option value="Jul">Jul</option>
                    <option value="Aug">Aug</option>
                    <option value="Sep">Sep</option>
                    <option value="Oct">Oct</option>
                    <option value="Nov">Nov</option>
                    <option value="Dec">Dec</option>
                  </select>
                  <div class="hidden">
                    <label for="field148432897D">Day</label>
                  </div>
                  <select
                    id="field148432897D"
                    name="field148432897D"
                    class=" fsField fsRequired"
                    aria-required="true"
                    aria-label="*Patients Date of Birth, Day"
                  >
                    <option value=""></option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select>
                  <div class="hidden">
                    <label for="field148432897Y">Year</label>
                  </div>
                  <select
                    id="field148432897Y"
                    name="field148432897Y"
                    class=" fsField fsRequired"
                    aria-required="true"
                    aria-label="*Patients Date of Birth, Year"
                  >
                    <option value=""></option>
                    <option value="1903">1903</option>
                    <option value="1904">1904</option>
                    <option value="1905">1905</option>
                    <option value="1906">1906</option>
                    <option value="1907">1907</option>
                    <option value="1908">1908</option>
                    <option value="1909">1909</option>
                    <option value="1910">1910</option>
                    <option value="1911">1911</option>
                    <option value="1912">1912</option>
                    <option value="1913">1913</option>
                    <option value="1914">1914</option>
                    <option value="1915">1915</option>
                    <option value="1916">1916</option>
                    <option value="1917">1917</option>
                    <option value="1918">1918</option>
                    <option value="1919">1919</option>
                    <option value="1920">1920</option>
                    <option value="1921">1921</option>
                    <option value="1922">1922</option>
                    <option value="1923">1923</option>
                    <option value="1924">1924</option>
                    <option value="1925">1925</option>
                    <option value="1926">1926</option>
                    <option value="1927">1927</option>
                    <option value="1928">1928</option>
                    <option value="1929">1929</option>
                    <option value="1930">1930</option>
                    <option value="1931">1931</option>
                    <option value="1932">1932</option>
                    <option value="1933">1933</option>
                    <option value="1934">1934</option>
                    <option value="1935">1935</option>
                    <option value="1936">1936</option>
                    <option value="1937">1937</option>
                    <option value="1938">1938</option>
                    <option value="1939">1939</option>
                    <option value="1940">1940</option>
                    <option value="1941">1941</option>
                    <option value="1942">1942</option>
                    <option value="1943">1943</option>
                    <option value="1944">1944</option>
                    <option value="1945">1945</option>
                    <option value="1946">1946</option>
                    <option value="1947">1947</option>
                    <option value="1948">1948</option>
                    <option value="1949">1949</option>
                    <option value="1950">1950</option>
                    <option value="1951">1951</option>
                    <option value="1952">1952</option>
                    <option value="1953">1953</option>
                    <option value="1954">1954</option>
                    <option value="1955">1955</option>
                    <option value="1956">1956</option>
                    <option value="1957">1957</option>
                    <option value="1958">1958</option>
                    <option value="1959">1959</option>
                    <option value="1960">1960</option>
                    <option value="1961">1961</option>
                    <option value="1962">1962</option>
                    <option value="1963">1963</option>
                    <option value="1964">1964</option>
                    <option value="1965">1965</option>
                    <option value="1966">1966</option>
                    <option value="1967">1967</option>
                    <option value="1968">1968</option>
                    <option value="1969">1969</option>
                    <option value="1970">1970</option>
                    <option value="1971">1971</option>
                    <option value="1972">1972</option>
                    <option value="1973">1973</option>
                    <option value="1974">1974</option>
                    <option value="1975">1975</option>
                    <option value="1976">1976</option>
                    <option value="1977">1977</option>
                    <option value="1978">1978</option>
                    <option value="1979">1979</option>
                    <option value="1980">1980</option>
                    <option value="1981">1981</option>
                    <option value="1982">1982</option>
                    <option value="1983">1983</option>
                    <option value="1984">1984</option>
                    <option value="1985">1985</option>
                    <option value="1986">1986</option>
                    <option value="1987">1987</option>
                    <option value="1988">1988</option>
                    <option value="1989">1989</option>
                    <option value="1990">1990</option>
                    <option value="1991">1991</option>
                    <option value="1992">1992</option>
                    <option value="1993">1993</option>
                    <option value="1994">1994</option>
                    <option value="1995">1995</option>
                    <option value="1996">1996</option>
                    <option value="1997">1997</option>
                    <option value="1998">1998</option>
                    <option value="1999">1999</option>
                    <option value="2000">2000</option>
                    <option value="2001">2001</option>
                    <option value="2002">2002</option>
                    <option value="2003">2003</option>
                    <option value="2004">2004</option>
                    <option value="2005">2005</option>
                    <option value="2006">2006</option>
                    <option value="2007">2007</option>
                    <option value="2008">2008</option>
                    <option value="2009">2009</option>
                    <option value="2010">2010</option>
                    <option value="2011">2011</option>
                    <option value="2012">2012</option>
                    <option value="2013">2013</option>
                    <option value="2014">2014</option>
                    <option value="2015">2015</option>
                    <option value="2016">2016</option>
                    <option value="2017">2017</option>
                    <option value="2018">2018</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                  </select>

                  <input
                    data-skip-validation=""
                    type="text"
                    id="fsCalendar148432897Link"
                    class="fsCalendarPickerLink hasDatepicker"
                    style="display:none;"
                    aria-hidden="true"
                    aria-label="*Patients Date of Birth"
                  /><img
                    class="ui-datepicker-trigger"
                    src="https://tuftsmedicine.formstack.com/forms/images/2/calendar.png"
                    alt="Select Date"
                    title="Select Date"
                    aria-hidden="true"
                  />
                  <div
                    id="fsCalendar148432897"
                    class="fsCalendar"
                    style=" position:absolute"
                  ></div>
                </div>
              </fieldset>
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50"
              id="fsCell148427525"
              aria-describedby="fsSupporting148427525"
              lang="en"
              fs-field-type="email"
              fs-field-validation-name="email_address"
            >
              <div
                id="fsSupporting148427525"
                class="fsSupporting"
                aria-hidden="true"
              >
                Email
              </div>

              <input
                type="email"
                id="field148427525"
                name="field148427525"
                size="50"
                value=""
                class="fsField fsFormatEmail"
                aria-label="Email"
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-9" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148427532"
              aria-describedby="fsSupporting148427532"
              lang="en"
              fs-field-type="phone"
              fs-field-validation-name="mobile_phone"
            >
              <div
                id="fsSupporting148427532"
                class="fsSupporting"
                aria-hidden="true"
              >
                Mobile Phone (XXX-XXX-XXXX)
                <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="tel"
                id="field148427532"
                name="field148427532"
                size="2"
                required=""
                value=""
                class="fsField fsFormatPhoneUS  fsRequired"
                aria-required="true"
                data-country="US"
                data-format="national"
                aria-label="Mobile Phone (XXX-XXX-XXXX) *"
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50"
              id="fsCell148427526"
              aria-describedby="fsSupporting148427526"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="street_address_1"
            >
              <div
                id="fsSupporting148427526"
                class="fsSupporting"
                aria-hidden="true"
              >
                Street Address Line 1 <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="text"
                id="field148427526"
                name="field148427526"
                size="50"
                required=""
                value=""
                class="fsField fsFormatText fsRequired   "
                aria-required="true"
                aria-label="Street Address Line 1 *"
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-10" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148427530"
              aria-describedby="fsSupporting148427530"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="postal_code"
            >
              <div
                id="fsSupporting148427530"
                class="fsSupporting"
                aria-hidden="true"
              >
                Zipcode <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="text"
                id="field148427530"
                name="field148427530"
                size="50"
                required=""
                value=""
                class="fsField fsFormatText fsRequired   "
                aria-required="true"
                aria-label="Zipcode *"
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50"
              id="fsCell148431478"
              aria-describedby="fsSupporting148431478"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148431478"
                class="fsSupporting"
                aria-hidden="true"
              >
                Preferred language <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="text"
                id="field148431478"
                name="field148431478"
                size="50"
                required=""
                value=""
                class="fsField fsFormatText fsRequired   "
                aria-required="true"
                aria-label="Preferred language *"
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-11" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148431500"
              aria-describedby="fsSupporting148431500"
              lang="en"
              fs-field-type="radio"
              fs-field-validation-name="Radio Button"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend148431500"
                id="label148431500"
              >
                <legend
                  id="fsLegend148431500"
                  class="fsLabel fsRequiredLabel fsLabelVertical hidden"
                >
                  <span
                    >Radio Button<span class="fsRequiredMarker">*</span></span
                  >
                </legend>
                <div class="fieldset-content">
                  <div
                    id="fsSupporting148431500"
                    class="fsSupporting"
                    aria-hidden="true"
                  >
                    Interpreter Required <span class="fsRequiredMarker">*</span>
                  </div>

                  <label class="fsOptionLabel vertical" for="field148431500_1"
                    ><input
                      type="radio"
                      id="field148431500_1"
                      name="field148431500"
                      value="Yes"
                      class="fsField fsRequired vertical"
                      aria-required="true"
                      aria-label="Interpreter Required *"
                    />Yes</label
                  >

                  <label class="fsOptionLabel vertical" for="field148431500_2"
                    ><input
                      type="radio"
                      id="field148431500_2"
                      name="field148431500"
                      value="No"
                      class="fsField fsRequired vertical"
                      aria-required="true"
                      aria-label="Interpreter Required *"
                    />No</label
                  >
                </div>
              </fieldset>
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50"
              id="fsCell148431619"
              aria-describedby="fsSupporting148431619"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148431619"
                class="fsSupporting"
                aria-hidden="true"
              >
                Patients PCP Name
              </div>

              <input
                type="text"
                id="field148431619"
                name="field148431619"
                size="50"
                value=""
                class="fsField fsFormatText    "
                aria-label="Patients PCP Name"
              />
            </div>
            <div class="fs-clear"></div>
          </div>
        </div>

        <div class="fsSection fs2Col" id="fsSection148431677">
          <div class="fsSectionHeader">
            <h2 class="fsSectionHeading">Insurance Information</h2>
          </div>

          <div id="fsRow5374790-13" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148431750"
              aria-describedby="fsSupporting148431750"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148431750"
                class="fsSupporting"
                aria-hidden="true"
              >
                Insurance Provider <span class="fsRequiredMarker">*</span>
              </div>

              <input
                type="text"
                id="field148431750"
                name="field148431750"
                size="50"
                required=""
                value=""
                class="fsField fsFormatText fsRequired   "
                aria-required="true"
                aria-label="Insurance Provider *"
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50"
              id="fsCell148431762"
              aria-describedby="fsSupporting148431762"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148431762"
                class="fsSupporting"
                aria-hidden="true"
              >
                Insurance ID
              </div>

              <input
                type="text"
                id="field148431762"
                name="field148431762"
                size="50"
                value=""
                class="fsField fsFormatText    "
                aria-label="Insurance ID"
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-14" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148431772"
              aria-describedby="fsSupporting148431772"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148431772"
                class="fsSupporting"
                aria-hidden="true"
              >
                Subscriber Name
              </div>

              <input
                type="text"
                id="field148431772"
                name="field148431772"
                size="50"
                value=""
                class="fsField fsFormatText    "
                aria-label="Subscriber Name"
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50"
              id="fsCell148431807"
              aria-describedby="fsSupporting148431807"
              lang="en"
              fs-field-type="phone"
              fs-field-validation-name="Phone"
            >
              <div
                id="fsSupporting148431807"
                class="fsSupporting"
                aria-hidden="true"
              >
                Insured Phone Number
              </div>

              <input
                type="tel"
                id="field148431807"
                name="field148431807"
                size="2"
                value=""
                class="fsField fsFormatPhoneUS "
                data-country="US"
                data-format="national"
                aria-label="Insured Phone Number"
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-15" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsSpan50"
              id="fsCell148431784"
              aria-describedby="fsSupporting148431784"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="Short Answer"
            >
              <div
                id="fsSupporting148431784"
                class="fsSupporting"
                aria-hidden="true"
              >
                Relationship to Insured
              </div>

              <input
                type="text"
                id="field148431784"
                name="field148431784"
                size="50"
                value=""
                class="fsField fsFormatText    "
                aria-label="Relationship to Insured"
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsSpan50"
              id="fsCell148431840"
              aria-describedby="fsSupporting148431840"
              lang="en"
              fs-field-type="textarea"
              fs-field-validation-name="Long Answer"
            >
              <div
                id="fsSupporting148431840"
                class="fsSupporting"
                aria-hidden="true"
              >
                Additional Comments
              </div>

              <textarea
                id="field148431840"
                class="fsField fsTextAreaMaxLength   fsFormatLength"
                name="field148431840"
                rows="7"
                cols="50"
                maxlength="500"
                aria-describedby="fsCounterContainer148431840 "
                aria-label="Additional Comments"
              ></textarea>
              <span
                id="fsCounterContainer148431840"
                aria-live="polite"
                aria-atomic="true"
                tabindex="-1"
              >
                <span class="hidden">Characters remaining: </span>
                <div
                  id="fsCounter148431840"
                  class="fsCounter"
                  style="width: 740.625px;"
                >
                  500/500
                </div>
              </span>
            </div>
            <div class="fs-clear"></div>
          </div>
        </div>

        <div class="fsSection fs2Col" id="fsSection148427535">
          <div class="fsSectionHeader"></div>

          <div id="fsRow5374790-17" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsHidden fsSpan50 fsHiddenByFieldSetting"
              id="fsCell148427536"
              aria-describedby="fsSupporting148427536"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="elqFormName"
            >
              <div
                id="fsSupporting148427536"
                class="fsSupporting"
                aria-hidden="true"
              >
                elqFormName
              </div>
              <label id="label148427536" class="fsLabel" for="field148427536"
                >elqFormName
              </label>

              <input
                type="text"
                id="field148427536"
                name="field148427536"
                size="50"
                value=""
                class="fsField fsFormatText    "
                aria-label="elqFormName"
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsHidden fsSpan50 fsHiddenByFieldSetting"
              id="fsCell148427537"
              aria-describedby="fsSupporting148427537"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="elqSiteID"
            >
              <div
                id="fsSupporting148427537"
                class="fsSupporting"
                aria-hidden="true"
              >
                elqSiteID
              </div>
              <label id="label148427537" class="fsLabel" for="field148427537"
                >elqSiteID
              </label>

              <input
                type="text"
                id="field148427537"
                name="field148427537"
                size="50"
                value="60351"
                class="fsField fsFormatText    "
                aria-label="elqSiteID"
              />
            </div>
            <div class="fs-clear"></div>
          </div>
        </div>

        <div class="fsSection fs4Col" id="fsSection148427538">
          <div class="fsSectionHeader"></div>

          <div id="fsRow5374790-19" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427539"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="hgcrm_agency"
            >
              <label id="label148427539" class="fsLabel" for="field148427539"
                >hgcrm_agency
              </label>

              <input
                type="text"
                id="field148427539"
                name="field148427539"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427540"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="hgcrm_channel"
            >
              <label id="label148427540" class="fsLabel" for="field148427540"
                >hgcrm_channel
              </label>

              <input
                type="text"
                id="field148427540"
                name="field148427540"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427541"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="hgcrm_campaignid"
            >
              <label id="label148427541" class="fsLabel" for="field148427541"
                >hgcrm_campaignid
              </label>

              <input
                type="text"
                id="field148427541"
                name="field148427541"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427542"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="hgcrm_promoted_facility"
            >
              <label id="label148427542" class="fsLabel" for="field148427542"
                >hgcrm_promoted_facility
              </label>

              <input
                type="text"
                id="field148427542"
                name="field148427542"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-20" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427543"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="keyword"
            >
              <label id="label148427543" class="fsLabel" for="field148427543"
                >keyword
              </label>

              <input
                type="text"
                id="field148427543"
                name="field148427543"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427544"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="matchtype"
            >
              <label id="label148427544" class="fsLabel" for="field148427544"
                >matchtype
              </label>

              <input
                type="text"
                id="field148427544"
                name="field148427544"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427545"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="placement"
            >
              <label id="label148427545" class="fsLabel" for="field148427545"
                >placement
              </label>

              <input
                type="text"
                id="field148427545"
                name="field148427545"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427546"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="target"
            >
              <label id="label148427546" class="fsLabel" for="field148427546"
                >target
              </label>

              <input
                type="text"
                id="field148427546"
                name="field148427546"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-21" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427547"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="hgcrm_promoted_serviceline"
            >
              <label id="label148427547" class="fsLabel" for="field148427547"
                >hgcrm_promoted_serviceline
              </label>

              <input
                type="text"
                id="field148427547"
                name="field148427547"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427548"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="utm_medium"
            >
              <label id="label148427548" class="fsLabel" for="field148427548"
                >utm_medium
              </label>

              <input
                type="text"
                id="field148427548"
                name="field148427548"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427549"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="utm_source"
            >
              <label id="label148427549" class="fsLabel" for="field148427549"
                >utm_source
              </label>

              <input
                type="text"
                id="field148427549"
                name="field148427549"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427550"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="utm_content"
            >
              <label id="label148427550" class="fsLabel" for="field148427550"
                >utm_content
              </label>

              <input
                type="text"
                id="field148427550"
                name="field148427550"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-22" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427551"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="hgcrm_tacticid"
            >
              <label id="label148427551" class="fsLabel" for="field148427551"
                >hgcrm_tacticid
              </label>

              <input
                type="text"
                id="field148427551"
                name="field148427551"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427552"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="utm_term"
            >
              <label id="label148427552" class="fsLabel" for="field148427552"
                >utm_term
              </label>

              <input
                type="text"
                id="field148427552"
                name="field148427552"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427553"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="hgcrm_trackingsetid"
            >
              <label id="label148427553" class="fsLabel" for="field148427553"
                >hgcrm_trackingsetid
              </label>

              <input
                type="text"
                id="field148427553"
                name="field148427553"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLast fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427554"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="hgcrm_source"
            >
              <label id="label148427554" class="fsLabel" for="field148427554"
                >hgcrm_source
              </label>

              <input
                type="text"
                id="field148427554"
                name="field148427554"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>
            <div class="fs-clear"></div>
          </div>

          <div id="fsRow5374790-23" class="fsRow fsFieldRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427555"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="utm_campaign"
            >
              <label id="label148427555" class="fsLabel" for="field148427555"
                >utm_campaign
              </label>

              <input
                type="text"
                id="field148427555"
                name="field148427555"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLabelVertical fsHidden fsSpan25 fsHiddenByFieldSetting"
              id="fsCell148427556"
              lang="en"
              fs-field-type="text"
              fs-field-validation-name="hgcrm_campaign_url"
            >
              <label id="label148427556" class="fsLabel" for="field148427556"
                >hgcrm_campaign_url
              </label>

              <input
                type="text"
                id="field148427556"
                name="field148427556"
                size="50"
                value=""
                class="fsField fsFormatText    "
              />
            </div>

            <div
              class="fsRowBody fsCell fsFieldCell fsLabelVertical fsSpan25"
              id="fsCell148427557"
              lang="en"
              fs-field-type="embed"
              fs-field-validation-name=""
            >
              <!-- WebMD Ignite - Orbit - Formstack -->
              <script src="https://script-app.mercuryhealthcare.com/modules/mhc-orbit.module.formstack.min.js"></script>
              <script src="https://script-app.mercuryhealthcare.com/modules/mhc-orbit.module.formstackADA.min.js"></script>
              <script
                async=""
                src="https://script-app.mercuryhealthcare.com/mhc-orbit-v1.0.min.js"
              ></script>
              <!--/ WebMD Ignite - Orbit - Formstack -->
            </div>
            <div class="fs-clear"></div>
          </div>
        </div>
      </div>

      <div id="fsSubmit5374790" class="fsSubmit fsPagination">
        <button
          type="button"
          id="fsPreviousButton5374790"
          class="fsPreviousButton"
          value="Previous Page"
          style="display:none;"
          aria-label="Previous"
        >
          <span class="fsFull">Previous</span><span class="fsSlim">←</span>
        </button>
        <button
          type="button"
          id="fsNextButton5374790"
          class="fsNextButton"
          value="Next Page"
          style="display:none;"
          aria-label="Next"
        >
          <span class="fsFull">Next</span><span class="fsSlim">→</span>
        </button>
        <input
          id="fsSubmitButton5374790"
          class="fsSubmitButton"
          style=""
          type="submit"
          value="Submit Form"
        />

        <div class="clear"></div>
        <div class=""></div>
      </div>
      <script type="text/javascript">
        window.FS_FIELD_DATA_5374790 = [];
      </script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/jquery-3.5.1.min_dc5e7f18c8.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/jquery-ui-1.13.2.min_1e20479789.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/scripts_8ef5a1adee.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/analytics_7d49daa365.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/libphonenumber-min_6f64debfdd.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/modernizr_60a2d5aeb5.js"
      ></script>

      <script type="text/javascript">
        if (window.addEventListener) {
          window.addEventListener('load', loadFormstack, false);
        } else if (window.attachEvent) {
          window.attachEvent('onload', loadFormstack);
        } else {
          loadFormstack();
        }

        function loadFormstack() {
          var form5374790 = new Formstack.Form(
            5374790,
            'https://tuftsmedicine.formstack.com/forms/'
          );

          form5374790.logicFields = [];

          form5374790.calcFields = [];

          form5374790.dateCalcFields = [];
          form5374790.init();
          if (Formstack.Analytics) {
            form5374790.plugins.analytics = new Formstack.Analytics(
              'https://tuftsmedicine.formstack.com',
              5374790,
              form5374790
            );
            form5374790.plugins.analytics.trackTouch();
            form5374790.plugins.analytics.trackBottleneck();
          }

          window.form5374790 = form5374790;
        }
      </script>
      <input
        name="fsUserAgent"
        id="fsUserAgent"
        type="hidden"
        value="Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/114.0.0.0 Safari/537.36"
      />
    </form>
    <div
      class="fs-ngdialog fs-modal-small fs-form-dialog fs-form-dialog--hidden"
    >
      <div class="fs-ngdialog-overlay"></div>
      <div class="fs-ngdialog-content">
        <div class="fs-modal__top fs-form-dialog__title"></div>
        <div class="fs-modal__middle">
          <div class="fs-form-dialog__message"></div>
          <label class="hidden" for="fsSaveResumePassword"
            >Enter your save and resume password</label
          >
          <input
            type="password"
            id="fsSaveResumePassword"
            class="fs-form-input fs-form-dialog__password fs-form-dialog--hidden fs--mt20"
            placeholder="Enter your save and resume password"
          />
          <textarea
            class="fs-form-dialog__textarea fs-form-dialog--hidden"
            rows="3"
            style="width: 100%; margin-top: 10px"
            aria-label="Add an optional comment"
          ></textarea>
        </div>
        <div class="fs-modal__bottom">
          <a
            class="fs-form-dialog__cancel fs-btn2 fs-btn2--size_medium fs-btn2--style_edit-dark"
            title="Cancel"
          >
            <div class="fs-btn2__content">
              <div class="fs-btn2__text">
                <span class="fs-form-dialog__button-text">Cancel</span>
              </div>
            </div>
          </a>
          <a
            class="fs-form-dialog__confirm fs-btn2 fs-btn2--size_medium fs-btn2--style_create fs--float-right"
            title="Confirm"
          >
            <div class="fs-btn2__content">
              <div class="fs-btn2__text">
                <span class="fs-form-dialog__button-text">Confirm</span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
`;

export const mockFields = html`
  <div class="fsBody fsEmbed">
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/3/reset_3d1cc6d59f.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/3/jquery-ui-1.13.2.min_164f2f8d51.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/3/default-v4_29cde3be75.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/3/light_2849050b8e.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/../common/css/uil-static.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/forms/css/common/dialogs_00a7ec5f05.css"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="//static.formstack.com/admin/forms-frontend/build/modules/live-form/live-form_4763869ce491bc0d3d83.css"
    />
    <!--[if IE]>
      <link
        rel="stylesheet"
        type="text/css"
        media="all"
        href="https://abc-xjsgw.formstack.com/forms/css/3/ie.css?20140508"
      />
    <![endif]-->
    <!--[if IE 7
      ]><link
        rel="stylesheet"
        type="text/css"
        media="all"
        href="https://abc-xjsgw.formstack.com/forms/css/3/ie7.css"
    /><![endif]-->
    <!--[if IE 6
      ]><link
        rel="stylesheet"
        type="text/css"
        media="all"
        href="https://abc-xjsgw.formstack.com/forms/css/3/ie6fixes.css"
    /><![endif]-->
    <form
      method="post"
      accept-charset="UTF-8"
      novalidate=""
      enctype="multipart/form-data"
      action="https://abc-xjsgw.formstack.com/forms/index.php"
      class="fsForm fsSingleColumn"
      id="fsForm5415035"
    >
      <input type="hidden" name="form" value="5415035" />
      <input type="hidden" name="viewkey" value="oQJVQOGY42" />
      <input type="hidden" name="password" value="" />
      <input
        type="hidden"
        name="hidden_fields"
        id="hidden_fields5415035"
        value=""
      />
      <input type="hidden" name="incomplete" id="incomplete5415035" value="" />
      <input
        type="hidden"
        name="incomplete_password"
        id="incomplete_password5415035"
      />
      <input
        type="hidden"
        name="referrer"
        id="referrer5415035"
        value="https://7hlc86.csb.app/"
      />
      <input
        type="hidden"
        name="referrer_type"
        id="referrer_type5415035"
        value="js"
      />
      <input type="hidden" name="_submit" value="1" />
      <input type="hidden" name="style_version" value="3" />
      <input type="hidden" id="viewparam" name="viewparam" value="1125927" />
      <div id="requiredFieldsError" style="display:none;">
        Please fill in a valid value for all required fields
      </div>
      <div id="invalidFormatError" style="display:none;">
        Please ensure all values are in a proper format.
      </div>
      <div id="resumeConfirm" style="display:none;">
        Are you sure you want to leave this form and resume later?
      </div>
      <div id="resumeConfirmPassword" style="display: none;">
        Are you sure you want to leave this form and resume later? If so, please
        enter a password below to securely save your form.
      </div>
      <div id="saveAndResume" style="display: none;">Save and Resume Later</div>
      <div id="saveResumeProcess" style="display: none;">Save and get link</div>
      <div id="fileTypeAlert" style="display:none;">
        You must upload one of the following file types for the selected field:
      </div>
      <div id="embedError" style="display:none;">
        There was an error displaying the form. Please copy and paste the embed
        code again.
      </div>
      <div id="applyDiscountButton" style="display:none;">Apply Discount</div>
      <div id="dcmYouSaved" style="display:none;">You saved</div>
      <div id="dcmWithCode" style="display:none;">with code</div>
      <div id="submitButtonText" style="display:none;">Submit Form</div>
      <div id="submittingText" style="display:none;">Submitting</div>
      <div id="validatingText" style="display:none;">Validating</div>
      <div id="autocaptureDisabledText" style="display:none;"></div>
      <div id="paymentInitError" style="display:none;">
        There was an error initializing the payment processor on this form.
        Please contact the form owner to correct this issue.
      </div>
      <div id="checkFieldPrompt" style="display:none;">
        Please check the field:
      </div>
      <div id="translatedWord-fields" style="display:none;">Fields</div>
      <div class="fsPage" id="fsPage5415035-1">
        <div
          id="ReactContainer5415035"
          style="display:none"
          class="FsReactContainerInitApp"
          data-fs-react-app-id="5415035"
        >
          <div>
            <div style="display: none;">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <symbol viewBox="0 0 1000 1000" id="abandonment">
                  <path
                    d="M500,0C225,0,0,225,0,500s225,500,500,500s500-225,500-500S775,0,500,0z M125,500c0-205,170-375,375-375 c80.2,0,155.1,26.1,216.6,70.1L195.1,716.6C151.1,655.1,125,580.2,125,500z M500,875c-80.2,0-155.1-26.1-216.6-70.1l521.5-521.5 c44,61.4,70.1,136.3,70.1,216.6C875,705,705,875,500,875z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="abandonment-rate">
                  <path
                    d="M687.5,500c0-103.6-83.9-187.5-187.5-187.5S312.5,396.4,312.5,500c0,103.6,83.9,187.5,187.5,187.5S687.5,603.6,687.5,500z M359.4,500c0-77.5,63.1-140.6,140.6-140.6c30.3,0,58.4,9.7,81.4,26.1l-196,196C369.1,558.4,359.4,530.3,359.4,500z M500,640.6 c-30.3,0-58.4-9.7-81.4-26.1l196-196c16.4,23,26.1,51.1,26.1,81.4C640.6,577.5,577.5,640.6,500,640.6z"
                  ></path>
                  <path
                    d="M500.2 875c-.1 0-.2 0-.2 0-205 0-375-170-375-375 0-109.2 48.2-208.4 124.3-277.3l62.9 90.5c5.8 8.3 18.5 6.7 22-2.8L442.2 17.6c3-8.1-3-16.8-11.7-16.8L118.5 0c-10.1 0-16.1 11.3-10.3 19.6l69 99.3C69 210.9 0 347.8 0 500c0 275 225 500 500 500 .2 0 .3 0 .5 0 12.4 0 22.5-10.2 22.5-22.6v-79.7C523 885.1 512.8 875 500.2 875zM822.1 881.6C930.7 789.7 1000 652.6 1000 500 1000 225 775 0 500 0c-.1 0-.2 0-.3 0C487.2 0 477 10.3 477 22.8v79.5c0 12.6 10.2 22.8 22.8 22.8l.2 0c205 0 375 170 375 375 0 109.5-48.5 209-124.9 278l-63.3-91.1c-5.8-8.3-18.5-6.7-22 2.8L556.7 982.4c-3 8.2 3 16.8 11.7 16.8l312 .7c10.1 0 16.1-11.3 10.3-19.6L822.1 881.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="add-hollow">
                  <path
                    d="M62 463.5c0-14.1-11.4-25.5-25.5-25.5h-12C10.4 438-1 449.4-1 463.5v74c0 14.1 11.4 25.5 25.5 25.5h12c14.1 0 25.5-11.4 25.5-25.5V463.5zM1000 463.5c0-14.1-11.4-25.5-25.5-25.5h-12c-14.1 0-25.5 11.4-25.5 25.5v74c0 14.1 11.4 25.5 25.5 25.5h12c14.1 0 25.5-11.4 25.5-25.5V463.5zM562 963.5c0-14.1-11.4-25.5-25.5-25.5h-74c-14.1 0-25.5 11.4-25.5 25.5v12c0 14.1 11.4 25.5 25.5 25.5h74c14.1 0 25.5-11.4 25.5-25.5V963.5zM562 25.5C562 11.4 550.6 0 536.5 0h-74C448.4 0 437 11.4 437 25.5v12c0 14.1 11.4 25.5 25.5 25.5h74c14.1 0 25.5-11.4 25.5-25.5V25.5zM164.4 783.2c-10-10-26.1-10-36.1 0l-8.1 8.1c-10 10-10 26.1 0 36.1l52.3 52.3c10 10 26.1 10 36.1 0l8.1-8.1c10-10 10-26.1 0-36.1L164.4 783.2zM827.3 120.3c-10-10-26.1-10-36.1 0l-8.1 8.1c-10 10-10 26.1 0 36.1l52.3 52.3c10 10 26.1 10 36.1 0l8.1-8.1c10-10 10-26.1 0-36.1L827.3 120.3zM871.5 783.2c-10-10-26.1-10-36.1 0l-52.3 52.3c-10 10-10 26.1 0 36.1l8.1 8.1c10 10 26.1 10 36.1 0l52.3-52.3c10-10 10-26.1 0-36.1L871.5 783.2zM208.6 120.3c-10-10-26.1-10-36.1 0l-52.3 52.3c-10 10-10 26.1 0 36.1l8.1 8.1c10 10 26.1 10 36.1 0l52.3-52.3c10-10 10-26.1 0-36.1L208.6 120.3zM81.6 633.3c-5.4-13-20.3-19.2-33.3-13.8l-10.6 4.4c-13 5.4-19.2 20.3-13.8 33.3l28.3 68.3c5.4 13 20.3 19.2 33.3 13.8l10.6-4.4c13-5.4 19.2-20.3 13.8-33.3L81.6 633.3zM918.3 366.7c5.4 13 20.3 19.2 33.3 13.8l10.6-4.4c13-5.4 19.2-20.3 13.8-33.3l-28.3-68.3c-5.4-13-20.3-19.2-33.3-13.8l-10.6 4.4c-13 5.4-19.2 20.3-13.8 33.3L918.3 366.7zM734.9 903.9c-5.4-13-20.3-19.2-33.3-13.8l-68.3 28.3c-13 5.4-19.2 20.3-13.8 33.3l4.4 10.6c5.4 13 20.3 19.2 33.3 13.8l68.3-28.3c13-5.4 19.2-20.3 13.8-33.3L734.9 903.9zM265 96.1c5.4 13 20.3 19.2 33.3 13.8l68.3-28.3c13-5.4 19.2-20.3 13.8-33.3l-4.4-10.6c-5.4-13-20.3-19.2-33.3-13.8l-68.3 28.3c-13 5.4-19.2 20.3-13.8 33.3L265 96.1zM366.7 918.4L298.3 890c-13-5.4-27.9.8-33.3 13.8l-4.4 10.6c-5.4 13 .8 27.9 13.8 33.3l68.3 28.3c13 5.4 27.9-.8 33.3-13.8l4.4-10.6C385.9 938.7 379.7 923.7 366.7 918.4zM725.5 52.2l-68.3-28.3c-13-5.4-27.9.8-33.3 13.8l-4.4 10.6c-5.4 13 .8 27.9 13.8 33.3l68.3 28.3c13 5.4 27.9-.8 33.3-13.8l4.4-10.6C744.7 72.5 738.5 57.6 725.5 52.2zM962.2 623.8l-10.6-4.4c-13-5.4-27.9.8-33.3 13.8L890 701.6c-5.4 13 .8 27.9 13.8 33.3l10.6 4.4c13 5.4 27.9-.8 33.3-13.8l28.3-68.3C981.4 644.2 975.2 629.2 962.2 623.8zM96.1 265.1l-10.6-4.4c-13-5.4-27.9.8-33.3 13.8l-28.3 68.3c-5.4 13 .8 27.9 13.8 33.3l10.6 4.4c13 5.4 27.9-.8 33.3-13.8l28.3-68.3C115.3 285.4 109.1 270.5 96.1 265.1zM679.4 425c39 0 70.6 33.8 70.6 72.8v3.3c0 39-31.6 73.9-70.6 73.9H575v104.4c0 39-33.8 70.6-72.8 70.6h-3.3c-39 0-73.9-31.6-73.9-70.6V575H320.6c-39 0-70.6-36-70.6-75 0-39 31.6-75 70.6-75H425V320.6c0-39 36-70.6 75-70.6 39 0 75 31.6 75 70.6V425H679.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 696.9 999.9" id="address">
                  <path
                    d="M350.4,0C155.4-1.1-1.6,159.8,0,354.8c1.5,184.9,70.9,330.6,329.3,636.2c10,11.8,28.2,11.8,38.2,0 C629,681.9,696.9,536.4,696.9,348.5C696.9,156.7,542,1.1,350.4,0z M348.4,522.7c-96.2,0-174.2-78-174.2-174.2 c0-96.1,78.2-174.2,174.2-174.2c96.2,0,174.2,78,174.2,174.2C522.7,444.5,444.5,522.7,348.4,522.7z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="alert-circle">
                  <path
                    d="M499.7,0C223.6,0,0,223.6,0,499.7C0,775.8,223.6,1000,499.7,1000S1000,776.4,1000,499.7C1000,223.6,776.4,0,499.7,0z M500.3,775c-41.6,0-75-33.4-75-75s33.4-75,75-75s75,33.4,75,75S541.9,775,500.3,775z M574,488c0,41.4-33.6,75-75,75h0 c-41.4,0-75-33.6-75-75V263c0-41.4,33.6-75,75-75h0c41.4,0,75,33.6,75,75V488z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="all">
                  <circle cx="900" cy="900" r="100"></circle>
                  <circle cx="633.3" cy="900" r="100"></circle>
                  <circle cx="366.7" cy="900" r="100"></circle>
                  <circle cx="100" cy="900" r="100"></circle>
                  <circle cx="766.7" cy="633.3" r="100"></circle>
                  <circle cx="500" cy="633.3" r="100"></circle>
                  <circle cx="233.3" cy="633.3" r="100"></circle>
                  <circle cx="633.3" cy="366.7" r="100"></circle>
                  <circle cx="366.7" cy="366.7" r="100"></circle>
                  <circle cx="500" cy="100" r="100"></circle>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="archive">
                  <path
                    d="M12 250v696.7c0 29.4 22.2 53.3 49 53.3h878c26.8 0 48.1-23.9 48.1-53.3V250H12zM687 400c0 27.6-22.4 50-50 50H362c-27.6 0-50-22.4-50-50v0c0-27.6 22.4-50 50-50h275C664.6 350 687 372.4 687 400L687 400zM950 0H50C22.5 0 0 22.5 0 50v125c0 13.8 11.2 25 25 25h950c13.8 0 25-11.2 25-25V50C1000 22.4 977.6 0 950 0z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="archive-2">
                  <path
                    d="M882.3,66.3C869,16.3,854.9,0,816,0H191.2c-33.9,0-46.8,17-61.7,66.3L0,628.3v5v289.1c0,45.1,45.6,77.6,84.5,77.6h831.9 c50.2,0,83.6-38.8,83.6-83.9V628.3v-5L882.3,66.3z M787.1,563h-11.3c-50.2,0-84.1,39.3-84.1,84.3l1.3,50.6 c0,33.8-22.6,52.1-55.2,52.1H369.3c-33.9,0-56.3-16.6-56.3-49.1v-50.1c0-50.1-37.8-87.8-82.9-87.8h-11.3 c-16.3,0-22.6-9.3-22.6-25.6l55.2-389.6c0-11.3,11.3-22.9,22.6-22.9h458c11.3,0,22.6,6.3,22.6,23.9l55.2,387.9 C814.7,553.1,804.7,563,787.1,563z"
                  ></path>
                  <path
                    d="M510.3,208.9c-5-7.1-15.5-7.5-20.5-0.3L311.2,463.7c-5.8,8.3,0.1,18.3,10.2,18.3h91.2c6.9,0,12.3,5.6,12.3,12.5v168.6 c0,6.9,5.8,12.8,12.7,12.8h125c6.9,0,12.3-5.9,12.3-12.8V494.5c0-6.9,5.8-12.5,12.7-12.5h91.2c10.1,0,16-10.2,10.2-18.5 L510.3,208.9z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="arrow-bottom">
                  <path
                    d="M500,1000c276.1,0,500-223.9,500-500S776.1,0,500,0S0,223.9,0,500S223.9,1000,500,1000z M500,62.5 c241.2,0,437.5,196.3,437.5,437.5S741.2,937.5,500,937.5S62.5,741.2,62.5,500S258.8,62.5,500,62.5z"
                  ></path>
                  <path
                    d="M489.8 631.4c5 7.1 15.5 7.5 20.5.4l178.7-255c5.8-8.3-.1-18.1-10.2-18.1h-91.2c-6.9 0-12.5-6.1-12.5-13V177.1c0-6.9-5.6-12.4-12.5-12.4h-125c-6.9 0-12.5 5.5-12.5 12.4v168.6c0 6.9-5.7 13-12.5 13h-91.2c-10.1 0-16 10-10.2 18.3L489.8 631.4zM275 736.1h450c13.8 0 25-11.2 25-25v-25c0-13.8-11.2-25-25-25H275c-13.8 0-25 11.2-25 25v25C250 724.9 261.2 736.1 275 736.1z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 996.3 880.6" id="arrow-caret-double-left">
                  <path
                    d="M12.6,409.7L415.1,7.3c9.7-9.7,25.6-9.7,35.4,0l99.6,99.6c9.7,9.7,9.7,25.6,0,35.4L269.7,422.6c-9.7,9.7-9.7,25.6,0,35.4 l280.3,280.3c9.7,9.7,9.7,25.6,0,35.4l-99.6,99.6c-9.7,9.7-25.6,9.7-35.4,0L12.6,470.9C-4.2,454.1-4.2,426.6,12.6,409.7z"
                  ></path>
                  <path
                    d="M451.6,409.7L854.1,7.3c9.7-9.7,25.6-9.7,35.4,0l99.6,99.6c9.7,9.7,9.7,25.6,0,35.4L708.7,422.6c-9.7,9.7-9.7,25.6,0,35.4 l280.3,280.3c9.7,9.7,9.7,25.6,0,35.4l-99.6,99.6c-9.7,9.7-25.6,9.7-35.4,0L451.6,470.9C434.8,454.1,434.8,426.6,451.6,409.7z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 996.3 880.6" id="arrow-caret-double-right">
                  <path
                    d="M983.7,409.7L581.3,7.3c-9.7-9.7-25.6-9.7-35.4,0l-99.6,99.6c-9.7,9.7-9.7,25.6,0,35.4l280.3,280.3 c9.7,9.7,9.7,25.6,0,35.4L446.3,738.3c-9.7,9.7-9.7,25.6,0,35.4l99.6,99.6c9.7,9.7,25.6,9.7,35.4,0l402.5-402.5 C1000.5,454.1,1000.5,426.6,983.7,409.7z"
                  ></path>
                  <path
                    d="M544.7,409.7L142.3,7.3c-9.7-9.7-25.6-9.7-35.4,0L7.3,106.9c-9.7,9.7-9.7,25.6,0,35.4l280.3,280.3c9.7,9.7,9.7,25.6,0,35.4 L7.3,738.3c-9.7,9.7-9.7,25.6,0,35.4l99.6,99.6c9.7,9.7,25.6,9.7,35.4,0l402.5-402.5C561.6,454.1,561.6,426.6,544.7,409.7z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 557.4 880.6" id="arrow-caret-left">
                  <path
                    d="M12.6,409.7L415.1,7.3c9.7-9.7,25.6-9.7,35.4,0l99.6,99.6c9.7,9.7,9.7,25.6,0,35.4L269.7,422.6c-9.7,9.7-9.7,25.6,0,35.4 l280.3,280.3c9.7,9.7,9.7,25.6,0,35.4l-99.6,99.6c-9.7,9.7-25.6,9.7-35.4,0L12.6,470.9C-4.2,454.1-4.2,426.6,12.6,409.7z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 557.4 880.6" id="arrow-caret-right">
                  <path
                    d="M544.7,409.7L142.3,7.3c-9.7-9.7-25.6-9.7-35.4,0L7.3,106.9c-9.7,9.7-9.7,25.6,0,35.4l280.3,280.3c9.7,9.7,9.7,25.6,0,35.4 L7.3,738.3c-9.7,9.7-9.7,25.6,0,35.4l99.6,99.6c9.7,9.7,25.6,9.7,35.4,0l402.5-402.5C561.6,454.1,561.6,426.6,544.7,409.7z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 999.9 999.9" id="arrow-directional">
                  <path
                    d="M994.7,489.6L739.4,311c-8.3-5.8-18.6,0.1-18.6,10.2v91.2c0,6.9-5.6,12.5-12.5,12.5h-121c-6.9,0-12.5-5.6-12.5-12.5v-121 c0-6.9,5.6-12.5,12.5-12.5h91.4c10.1,0,16-10.4,10.2-18.7L510.2,5.5c-5-7.1-15.5-7.5-20.5-0.4L311,260.4 c-5.8,8.3,0.1,18.5,10.2,18.5h91.1c6.9,0,12.5,5.6,12.5,12.5v121c0,6.9-5.6,12.5-12.5,12.5h-121c-6.9,0-12.5-5.6-12.5-12.5v-91.2 c0-10.1-10.3-16-18.6-10.2L5.5,489.7c-7.1,5-7.5,15.5-0.4,20.5l255.2,178.7c8.3,5.8,18.4-0.1,18.4-10.2v-91.2 c0-6.9,5.6-12.5,12.5-12.5h121c6.9,0,12.5,5.6,12.5,12.5v121c0,6.9-5.6,12.5-12.5,12.5h-91.1c-10.1,0-16,10.4-10.2,18.7l178.8,254.7 c5,7.1,15.5,7.5,20.5,0.4l178.7-255.3c5.8-8.3-0.1-18.5-10.2-18.5h-91.4c-6.9,0-12.5-5.6-12.5-12.5v-121c0-6.9,5.6-12.5,12.5-12.5 h121c6.9,0,12.5,5.6,12.5,12.5v91.2c0,10.1,10.5,16,18.7,10.2l254.8-178.8C1001.4,505.1,1001.9,494.6,994.7,489.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="arrow-down-circle">
                  <path
                    d="M0,499.7C0,775.8,224,1000,500,1000c276,0,500-223.6,500-500.3C1000,223.6,776,0,500,0C224,0,0,223.6,0,499.7z M562.5,264 c6.9,0,12.5,5.5,12.5,12.4V445c0,6.9,5.6,13,12.5,13h91.2c10.1,0,16,9.8,10.2,18.1l-178.7,255c-5,7.1-15.5,6.7-20.5-0.4L311,476.3 c-5.8-8.3,0.1-18.3,10.2-18.3h91.2c6.9,0,12.5-6.1,12.5-13V276.4c0-6.9,5.6-12.4,12.5-12.4H562.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="arrow-down-hollow">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500s223.9,500,500,500s500-223.9,500-500S776.1,0,500,0z M500,937.5 C258.8,937.5,62.5,741.2,62.5,500S258.8,62.5,500,62.5S937.5,258.8,937.5,500S741.2,937.5,500,937.5z"
                  ></path>
                  <path
                    d="M678.7,458h-91.2c-6.9,0-12.5-6.1-12.5-13V276.4c0-6.9-5.6-12.4-12.5-12.4h-125c-6.9,0-12.5,5.5-12.5,12.4V445 c0,6.9-5.7,13-12.5,13h-91.2c-10.1,0-16,10-10.2,18.3l178.8,254.4c5,7.1,15.5,7.5,20.5,0.4l178.7-255 C694.7,467.8,688.8,458,678.7,458z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 999.9 809.8" id="arrow-left">
                  <path
                    d="M999.9,536.1c0,15.2-12.2,27.8-27.4,27.8h-355c-15.1,0-27.6,12.1-27.6,27.2v192.1c0,21.4-21.2,34-38.7,21.7L11,426.7 c-15.1-10.5-14.4-32.9,0.7-43.4L550.8,4.8c17.5-12.3,39.1,0.3,39.1,21.7v192c0,15.1,12.5,27.4,27.6,27.4h355 c15.2,0,27.4,12.5,27.4,27.6V536.1z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="arrow-left-circle">
                  <path
                    d="M500.3,0C224.2,0,0,224,0,500c0,276,223.6,500,500.3,500c276.1,0,499.7-224,499.7-500C1000,224,776.4,0,500.3,0z M736,562.5 c0,6.9-5.5,12.5-12.4,12.5H555c-6.9,0-13,5.6-13,12.5v91.2c0,10.1-9.8,16-18.1,10.2l-255-178.7c-7.1-5-6.7-15.5,0.4-20.5L523.7,311 c8.3-5.8,18.3,0.1,18.3,10.2v91.2c0,6.9,6.1,12.5,13,12.5h168.6c6.9,0,12.4,5.6,12.4,12.5V562.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000.1 809.8" id="arrow-right">
                  <path
                    d="M0,273.7c0-15.2,12.5-27.8,27.6-27.8h355c15.1,0,27.3-12.1,27.3-27.2V26.5c0-21.4,21.3-34,38.9-21.7l540.2,378.3 c15.1,10.5,14.4,32.9-0.7,43.4L449.2,805c-17.5,12.3-39.2-0.3-39.2-21.7v-192c0-15.1-12.2-27.4-27.3-27.4h-355 C12.5,563.9,0,551.4,0,536.3V273.7z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="arrow-right-circle">
                  <path
                    d="M499.7,1000c276.1,0,500.3-224,500.3-500C1000,224,776.4,0,499.7,0C223.6,0,0,224,0,500C0,776,223.6,1000,499.7,1000z M264,437.6c0-6.9,5.5-12.6,12.4-12.6H445c6.9,0,13-5.6,13-12.4v-91.2c0-10.1,9.8-16,18.1-10.2l255,178.7c7.1,5,6.7,15.5-0.4,20.5 L476.3,689c-8.3,5.8-18.3-0.1-18.3-10.2v-91.2c0-6.9-6.1-12.6-13-12.6H276.4c-6.9,0-12.4-5.5-12.4-12.4V437.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 382.5 999.9" id="arrow-sort">
                  <path
                    d="M369.9,720.9h-91.4c-6.9,0-12.5-5.6-12.5-12.5v-417c0-6.9,5.6-12.5,12.5-12.5h91.4c10.1,0,16-10.4,10.2-18.7L201.4,5.5 c-5-7.1-15.5-7.5-20.5-0.4L2.3,260.4c-5.8,8.3,0.1,18.5,10.2,18.5h91.1c6.9,0,12.5,5.6,12.5,12.5v417c0,6.9-5.6,12.5-12.5,12.5H12.5 c-10.1,0-16,10.4-10.2,18.7L181,994.3c5,7.1,15.5,7.5,20.5,0.4l178.7-255.3C386,731.1,380,720.9,369.9,720.9z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="arrow-top">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500s223.9,500,500,500s500-223.9,500-500S776.1,0,500,0z M500,937.5 C258.8,937.5,62.5,741.2,62.5,500S258.8,62.5,500,62.5S937.5,258.8,937.5,500S741.2,937.5,500,937.5z"
                  ></path>
                  <path
                    d="M510.2 368.6c-5-7.1-15.5-7.5-20.5-.4L311 623.2c-5.8 8.3.1 18.1 10.2 18.1h91.2c6.9 0 12.5 6.1 12.5 13v168.6c0 6.9 5.6 12.4 12.5 12.4h125c6.9 0 12.5-5.5 12.5-12.4V654.3c0-6.9 5.7-13 12.5-13h91.2c10.1 0 16-10 10.2-18.3L510.2 368.6zM725 263.9H275c-13.8 0-25 11.2-25 25v25c0 13.8 11.2 25 25 25h450c13.8 0 25-11.2 25-25v-25C750 275.1 738.8 263.9 725 263.9z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="arrow-up-circle">
                  <path
                    d="M1000,500.3C1000,224.2,776,0,500,0C224,0,0,223.6,0,500.3C0,776.4,224,1000,500,1000C776,1000,1000,776.4,1000,500.3z M437.5,736c-6.9,0-12.5-5.4-12.5-12.3V555c0-6.9-5.6-12-12.5-12h-91.2c-10.1,0-16-10.3-10.2-18.6l178.7-255.3 c5-7.1,15.5-6.9,20.5,0.3L689,524.3c5.8,8.3-0.1,18.7-10.2,18.7h-91.2c-6.9,0-12.5,5.2-12.5,12v168.6c0,6.9-5.6,12.3-12.5,12.3 H437.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="arrow-up-hollow">
                  <path
                    d="M500,937.5C258.8,937.5,62.5,741.2,62.5,500S258.8,62.5,500,62.5S937.5,258.8,937.5,500S741.2,937.5,500,937.5 M500,1000 c276.1,0,500-223.9,500-500S776.1,0,500,0S0,223.9,0,500S223.9,1000,500,1000L500,1000z"
                  ></path>
                  <path
                    d="M437.5,736c-6.9,0-12.5-5.5-12.5-12.4V555c0-6.9-5.6-13-12.5-13h-91.2c-10.1,0-16-9.8-10.2-18.1l178.7-255 c5-7.1,15.5-6.7,20.5,0.4L689,523.7c5.8,8.3-0.1,18.3-10.2,18.3h-91.2c-6.9,0-12.5,6.1-12.5,13v168.6c0,6.9-5.6,12.4-12.5,12.4 H437.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 12 12" id="asterisk">
                  <path
                    d="M418.41768,872.2804 C418.60904,872.39088 418.67456,872.63544 418.56408,872.8268 L418.36408,873.1732 C418.25368,873.36456 418.00904,873.43008 417.81768,873.3196 L415.6,872.0392 L415.6,874.6 C415.6,874.82096 415.42096,875 415.2,875 L414.8,875 C414.57912,875 414.4,874.82096 414.4,874.6 L414.4,872.0392 L412.1824,873.3196 C411.99104,873.43008 411.74632,873.36456 411.636,873.1732 L411.436,872.8268 C411.32552,872.63544 411.39104,872.39088 411.5824,872.2804 L413.8,871 L411.5824,869.7196 C411.39104,869.60912 411.32552,869.36456 411.436,869.1732 L411.636,868.8268 C411.74632,868.63544 411.99104,868.56992 412.1824,868.6804 L414.4,869.9608 L414.4,867.4 C414.4,867.17912 414.57912,867 414.8,867 L415.2,867 C415.42096,867 415.6,867.17912 415.6,867.4 L415.6,869.9608 L417.81768,868.6804 C418.00904,868.56992 418.25368,868.63544 418.36408,868.8268 L418.56408,869.1732 C418.67456,869.36456 418.60904,869.60912 418.41768,869.7196 L416.2,871 L418.41768,872.2804 Z M415,865 C411.68624,865 409,867.68632 409,871 C409,874.31368 411.68624,877 415,877 C418.31376,877 421,874.31368 421,871 C421,867.68632 418.31376,865 415,865 Z"
                    transform="translate(-409.000000, -865.000000)"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 9 17" id="breadcrumb">
                  <polygon
                    points="93.698 2 93 2.712 100.585 10.257 93 17.803 93.698 18.514 102 10.257"
                    transform="translate(-93.000000, -2.000000)"
                  ></polygon>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="browser">
                  <path
                    d="M950,0h-73.2H106.5H50C22.4,0,0,22.4,0,50v900c0,27.5,22.5,50,50,50h900 c27.6,0,50-22.4,50-50V50C1000,22.4,977.6,0,950,0z M250,125.5c0-20.7,16.8-37.5,37.5-37.5h0c20.7,0,37.5,16.8,37.5,37.5v0 c0,20.7-16.8,37.5-37.5,37.5h0C266.8,163,250,146.2,250,125.5L250,125.5z M125,125.5c0-20.7,16.8-37.5,37.5-37.5 s37.5,16.8,37.5,37.5v0c0,20.7-16.8,37.5-37.5,37.5S125,146.2,125,125.5L125,125.5z M875,850c0,13.8-11.2,25-25,25H150 c-13.8,0-25-11.2-25-25V275c0-13.8,11.2-25,25-25h700c13.8,0,25,11.2,25,25V850z M875,138c0,13.8-11.2,25-25,25H400 c-13.8,0-25-11.2-25-25v-25c0-13.8,11.2-25,25-25h450c13.8,0,25,11.2,25,25V138z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 803.8" id="bubble">
                  <path
                    d="M695.6,0H305.3H305C136.9,0,0,136.2,0,303.4v27.9C0,462.1,82.2,574,197.2,617.8l-1.2,16.9l-11.7,155.5 c-0.6,7.7,5.7,13.6,12.6,13.6c1.6,0,3.3-0.3,4.9-1c0.5-0.2,1-0.5,1.4-0.8L462,638h233.6c168.1,0,304.4-137.8,304.4-306.7v-27.9 C1000,136.2,863.7,0,695.6,0z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="build">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500s223.9,500,500,500s500-223.9,500-500S776.1,0,500,0z M752.8,474.1 c-46.5,46.5-114.6,58.6-172.2,36L309.4,781.6c-25.1,25.1-65.7,25.4-90.8,0.4h0c-25.1-25-25.1-66.1,0-91.2l271.3-271.7 c-22.4-57.5-10.5-125.6,35.8-172c31.5-31.6,72.9-47.3,114.2-47.1c0.4,0,0.7,0,1.1,0c22.4,0.8,33,27.1,18.3,44l-92.8,92.8l23.4,72.9 l72.9,23.4l92.8-92.8c17-14.8,43.3-4.1,44.1,18.4c0,0.4,0,0.8,0,1.1C799.9,401.2,784.2,442.7,752.8,474.1z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="button">
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50 V50C1000,22.4,977.6,0,950,0z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h700 c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M446.2 633.6c-24.5 25.2-59.8 37.8-106.1 37.8-46.3 0-81.7-12.6-106.1-37.8-32.8-30.9-49.2-75.4-49.2-133.6 0-59.3 16.4-103.9 49.2-133.6 24.5-25.2 59.8-37.8 106.1-37.8 46.3 0 81.7 12.6 106.1 37.8 32.7 29.7 49 74.3 49 133.6C495.2 558.2 478.8 602.7 446.2 633.6zM403.9 584.4c15.7-19.8 23.6-47.9 23.6-84.4 0-36.3-7.9-64.4-23.6-84.3-15.7-19.8-37-29.8-63.8-29.8s-48.2 9.9-64.2 29.7c-16 19.8-24 47.9-24 84.4 0 36.5 8 64.6 24 84.4 16 19.8 37.4 29.7 64.2 29.7S388.1 604.2 403.9 584.4zM547.9 338.5h66.6v133.4l125.1-133.4h87.4L694.2 471.7l139.7 190.7h-87L647.1 521l-32.6 33.1v108.3h-66.6V338.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="calculation">
                  <path
                    d="M223.8 0C99.9 0 0 99.9 0 223.8c0 123.9 99.9 223.8 223.8 223.8 123.9 0 223.8-100.8 223.8-223.8C447.6 99.9 346.9 0 223.8 0zM308.8 263H263v44.6c0 22.8-14.7 41.3-37.5 41.3S188 330.4 188 307.6V263h-44.4c-22.8 0-41.3-14.7-41.3-37.5s18.5-37.5 41.3-37.5H188v-45.6c0-22.8 14.7-41.3 37.5-41.3s37.5 18.5 37.5 41.3V188h45.8c22.8 0 41.3 14.7 41.3 37.5S331.6 263 308.8 263zM223.8 552.4C99.9 552.4 0 652.3 0 776.2S99.9 1000 223.8 1000s223.8-99.9 223.8-223.8S346.9 552.4 223.8 552.4zM315.1 808.3c16.1 16.1 16.1 42.3 0 58.4-16.1 16.1-42.3 16.1-58.4 0l-29.2-29.2-29.2 29.2c-16.1 16.1-42.3 16.1-58.4 0-16.1-16.1-16.1-42.3 0-58.4l29.2-29.2-29.2-29.2c-16.1-16.1-16.1-42.3 0-58.4 16.1-16.1 42.3-16.1 58.4 0l29.2 29.2 29.2-29.2c16.1-16.1 42.3-16.1 58.4 0 16.1 16.1 16.1 42.3 0 58.4l-29.2 29.2L315.1 808.3zM776.2 0C652.3 0 552.4 99.9 552.4 223.8s99.9 223.8 223.8 223.8S1000 347.7 1000 223.8C999.2 99.9 899.2 0 776.2 0zM858.8 263H693.6c-22.8 0-41.3-14.7-41.3-37.5s18.5-37.5 41.3-37.5h165.2c22.8 0 41.3 14.7 41.3 37.5S881.6 263 858.8 263zM776.2 552.4c-123.9 0-223.8 99.9-223.8 223.8S652.3 1000 776.2 1000 1000 900.1 1000 776.2C999.2 652.3 899.2 552.4 776.2 552.4zM858.8 877H693.6c-22.8 0-41.3-14.7-41.3-37.5s18.5-37.5 41.3-37.5h165.2c22.8 0 41.3 14.7 41.3 37.5S881.6 877 858.8 877zM858.8 752H693.6c-22.8 0-41.3-14.7-41.3-37.5s18.5-37.5 41.3-37.5h165.2c22.8 0 41.3 14.7 41.3 37.5S881.6 752 858.8 752z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 750 1000" id="calculator">
                  <path
                    d="M700,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h650c27.6,0,50-22.4,50-50V50C750,22.4,727.6,0,700,0z M160.4,897.5 c-39.4,0-72.4-32.4-71.2-73.4c1.1-38.5,33.2-69.3,71.7-69.1c39.8,0.2,70.8,31.4,70.8,71.2C231.7,866.2,199.2,897.5,160.4,897.5z M160.4,707.5c-39.4,0-72.4-32.4-71.2-73.4c1.1-38.5,33.2-69.3,71.7-69.1c39.8,0.2,70.8,31.4,70.8,71.2 C231.7,676.2,199.2,707.5,160.4,707.5z M160.4,515c-39.4,0-72.4-32.4-71.2-73.4c1.1-38.5,33.2-69.3,71.7-69.1 c39.8,0.2,70.8,31.4,70.8,71.2C231.7,483.8,199.2,515,160.4,515z M374.2,897.5c-39.4,0-72.4-32.4-71.2-73.4 c1.1-38.5,33.2-69.3,71.7-69.1c39.8,0.2,70.8,31.4,70.8,71.2C445.4,866.2,412.9,897.5,374.2,897.5z M374.2,707.5 c-39.4,0-72.4-32.4-71.2-73.4c1.1-38.5,33.2-69.3,71.7-69.1c39.8,0.2,70.8,31.4,70.8,71.2C445.4,676.2,412.9,707.5,374.2,707.5z M374.2,515c-39.4,0-72.4-32.4-71.2-73.4c1.1-38.5,33.2-69.3,71.7-69.1c39.8,0.2,70.8,31.4,70.8,71.2 C445.4,483.8,412.9,515,374.2,515z M663,826.2c0,40-35,71.2-75,71.2c-38.8,0-75-31.2-75-71.2V640.9c0-40.7,33.3-75.4,74.1-75.9 c40.4-0.5,75.9,30.9,75.9,71.2V826.2z M516.7,441.6c1.1-38.5,33.2-69.3,71.7-69.1c39.8,0.2,70.8,31.4,70.8,71.2 c0,40-31.2,71.2-71.3,71.2C548.5,515,515.5,482.6,516.7,441.6z M663,251c0,13.8-11.2,25-25,25H113c-13.8,0-25-11.2-25-25V113 c0-13.8,11.2-25,25-25h525c13.8,0,25,11.2,25,25V251z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="calendar">
                  <rect x="213" y="400" width="150" height="150"></rect>
                  <rect x="425" y="400" width="150" height="150"></rect>
                  <rect x="213" y="638" width="150" height="150"></rect>
                  <rect x="425" y="638" width="150" height="150"></rect>
                  <rect x="638" y="400" width="150" height="150"></rect>
                  <rect x="638" y="638" width="150" height="150"></rect>
                  <path
                    d="M950,0h-25c-27.6,0-50,22.4-50,50v100v5v10.2c0,12.6-10.2,22.8-22.8,22.8H584.8 c-12.6,0-22.8-10.2-22.8-22.8V50c0-27.6-22.4-50-50-50h-25c-27.6,0-50,22.4-50,50v115.2c0,12.6-10.2,22.8-22.7,22.8H147.8 c-12.6,0-22.8-10.2-22.8-22.8V150V50c0-27.6-22.4-50-50-50H50C22.4,0,0,22.4,0,50v138v125v637c0,27.6,22.4,50,50,50h900 c27.6,0,50-22.4,50-50V313V188V50C1000,22.4,977.6,0,950,0z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V313h750V850z"
                  ></path>
                  <circle cx="281.8" cy="62.5" r="62.5"></circle>
                  <circle cx="718.5" cy="62.5" r="62.5"></circle>
                </symbol>
                <symbol viewBox="0 0 30 30" id="caret-circle">
                  <path
                    d="M15,30 C6.71572875,30 0,23.2842712 0,15 C0,6.71572875 6.71572875,0 15,0 C23.2842712,0 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 Z M9.21412873,14.9787349 C8.92862376,15.2666231 8.92862376,15.7350803 9.21412873,16.0212651 L16.0526526,22.8760718 C16.2191971,23.0413094 16.4894072,23.0413094 16.6542523,22.8760718 L18.3468889,21.1794049 C18.5117341,21.0124638 18.5117341,20.7416104 18.3468889,20.5763727 L13.5833744,15.8015161 C13.4185293,15.634575 13.4185293,15.3637215 13.5833744,15.1984839 L18.3485884,10.4236273 C18.5134335,10.2566862 18.5134335,9.98583272 18.3485884,9.82059508 L16.6559518,8.12392823 C16.4894072,7.95869059 16.2191971,7.95869059 16.054352,8.12392823 L9.21412873,14.9787349 Z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="charts">
                  <path
                    d="M499,499.1V0C224,0.7-0.7,225.1,0,501.2c0.7,276.1,225,499.4,501.1,498.8c276.1-0.7,499.4-225.1,498.7-501.2 C999.5,391,964.7,286.1,900,199.9L499,499.1z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 803.9" id="chat-bubble">
                  <path
                    d="M304,75h390.7h0.2c31,0,61.1,6.1,89.4,18.1c27.4,11.6,52,28.1,73.2,49.2c21.2,21.1,37.8,45.5,49.4,72.7 c12,28.1,18,57.9,18,88.6v27.9c0,47.8-14.5,93.7-41.9,132.8c-13.2,18.9-29.1,35.6-47.2,49.8c-18.2,14.3-38.4,25.7-59.8,33.9 l-51.9,19.8l3.8,55.4l1.2,16.9l0,0.2l0,0.2l0.5,6.7c0.8,10.3-10.5,17-19.2,11.5l-132.4-84L559.7,563H538H304.4 C177.9,563,75,459.2,75,331.4v-27.9C75,177.6,177.9,75,304.4,75 M304.4,0C136.3,0,0,136.3,0,303.5v27.9C0,500.3,136.3,638,304.4,638 H538l258.8,164c0.5,0.3,0.9,0.6,1.4,0.8c1.6,0.7,3.3,1,4.9,1c6.9,0,13.2-5.9,12.6-13.6L804,634.8l-1.2-16.9 c115-43.9,197.2-155.8,197.2-286.5v-27.9C1000,136.3,863.1,0,695,0h-0.2H304.4L304.4,0z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 709.9" id="chat-bubbles">
                  <path
                    d="M298.8,456.7l-45.7,21.2c-4.5,2.1-9.5-1.6-8.8-6.6l6.8-47.7c-96,0-176.1-75.8-176.1-169.2v-2.8 C75,158.1,157.3,75,253.3,75h248.5c49,0,93.2,25,124.8,63h97.7C681.3,50,597.6,0,501.7,0H253.3C113.6,0,0,114.4,0,251.5 c0,105.2,67,196.9,161.2,233.1l-19.6,108.9c-1.9,10.5,8.9,18.9,18.6,14.4l115.9-53.5l61.9-28.5 C321.3,505.2,307.9,481.9,298.8,456.7z"
                  ></path>
                  <path
                    d="M759.5,238.3c85.3,0,153.5,62.9,153.5,140.7v-0.2c0,77.9-65.4,140.9-150.8,140.9l-2.7,48c-0.3,4.9-5.7,7.6-9.8,4.8 l-87-59.4H545.3C459.9,513,388,454.9,388,377.1v1.2c0-77.9,71.9-140.3,157.3-140.3H763 M766,163H545.3c-129,0-234,96.9-234,218.5 c0,121.6,105,218.5,234,218.5h94.4l78.5,49.4l92.4,58.4c8.4,5.4,19.5-0.6,20.4-10.5l9.1-108.9l0.1-0.8 c92.9-29.3,160-109.4,160-206.6C1000,259.4,895,163,766,163L766,163z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 765.2" id="check">
                  <path
                    d="M960,233.4L468.2,725.1c-53.4,53.4-140,53.4-193.3,0L40,490.3c-53.4-53.4-53.4-140,0-193.3c53.4-53.4,140-53.4,193.3,0 l138.2,138.2L766.6,40c53.4-53.4,140-53.4,193.3,0C1013.3,93.4,1013.3,180,960,233.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="check-circle">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M749.4,423 L495.6,676.8c-27.6,27.6-72.2,27.6-99.8,0L274.7,555.6c-27.6-27.6-27.6-72.2,0-99.8c27.6-27.6,72.2-27.6,99.8,0l71.3,71.3 l203.9-203.9c27.6-27.6,72.2-27.6,99.8,0C777,350.8,777,395.5,749.4,423z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="check-hollow">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M500,937.5 C258.8,937.5,62.5,741.2,62.5,500S258.8,62.5,500,62.5S937.5,258.8,937.5,500S741.2,937.5,500,937.5z"
                  ></path>
                  <path
                    d="M649.6,323.2L445.8,527.1l-71.3-71.3c-27.6-27.6-72.2-27.6-99.8,0c-27.6,27.6-27.6,72.2,0,99.8l121.2,121.2 c27.6,27.6,72.2,27.6,99.8,0L749.4,423c27.6-27.6,27.6-72.2,0-99.8C721.9,295.7,677.2,295.7,649.6,323.2z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="check-square">
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50 V50C1000,22.4,977.6,0,950,0z M749.4,423L495.6,676.8c-27.6,27.6-72.2,27.6-99.8,0L274.7,555.6c-27.6-27.6-27.6-72.2,0-99.8 c27.6-27.6,72.2-27.6,99.8,0l71.3,71.3l203.9-203.9c27.6-27.6,72.2-27.6,99.8,0C777,350.8,777,395.5,749.4,423z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="circle">
                  <circle cx="500" cy="500" r="500"></circle>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="clear">
                  <path
                    d="M982.5,388.6L611.4,17.5C599.8,5.8,584.5,0,569.2,0s-30.5,5.8-42.2,17.5L279.8,264.8l0,0L17.5,527.1 c-23.3,23.3-23.3,61.1,0,84.3l371.1,371.1c11.6,11.6,26.9,17.5,42.2,17.5c15.3,0,30.5-5.8,42.2-17.5l247.3-247.3l0,0l262.3-262.3 C1005.8,449.6,1005.8,411.9,982.5,388.6z M448.4,830.3c-9.8,9.8-25.6,9.8-35.4,0L169.7,586.9c-9.8-9.8-9.8-25.6,0-35.4l183.4-183.4 l0,0l278.7,278.7L448.4,830.3z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 791.8 790.5" id="close">
                  <path
                    d="M395.3,596.6l153,153c55,55,144.6,54.4,199.6-0.5c55-55,55.5-144.6,0.5-199.6l-153-153l155.4-155.4 c55-55,54.4-144.6-0.5-199.6c-55-55-144.6-55.5-199.6-0.5L395.3,196.4L242.2,43.3c-55-55-145.6-57.3-200.6-2.3l-1.2,1.2 c-55,55-53.2,146.3,1.7,201.2l153.1,153.1L44.5,547.1c-55,55-59.1,148.7-4.2,203.6l0.4,0.4c55,55,149,51,203.9-3.9L395.3,596.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="close-circle">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M676.8,577 c27.6,27.6,27.6,72.2,0,99.8v0c-27.6,27.6-72.2,27.6-99.8,0l-77-77l-77,77c-27.6,27.6-72.2,27.6-99.8,0v0 c-27.6-27.6-27.6-72.2,0-99.8l77-77l-77-77c-27.6-27.6-27.6-72.2,0-99.8c27.6-27.6,72.2-27.6,99.8,0l77,77l77-77 c27.6-27.6,72.2-27.6,99.8,0c27.6,27.6,27.6,72.2,0,99.8l-77,77L676.8,577z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="close-variation">
                  <path
                    d="M584.7,500l400-400c20.4-20.4,20.4-53.4,0-73.8l-11-11c-20.4-20.4-53.4-20.4-73.8,0l-400,400l-400-400 c-20.4-20.4-53.4-20.4-73.8,0l-11,11c-20.4,20.4-20.4,53.4,0,73.8l400,400l-400,400c-20.4,20.4-20.4,53.4,0,73.8l11,11 c20.4,20.4,53.4,20.4,73.8,0l400-400l400,400c20.4,20.4,53.4,20.4,73.8,0l11-11c20.4-20.4,20.4-53.4,0-73.8L584.7,500z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 615.9" id="code">
                  <path
                    d="M293.4 415.5L139.9 308l153.5-107.5c23.1-16.2 28.7-48.1 12.6-71.2-16.2-23.1-48.1-28.7-71.2-12.6l-213 149.2C10.8 273.5 4 284.7 1.3 296.8c-.1.3-.2.6-.2.9-.4 2.2-.6 4.4-.8 6.6C.2 305.5 0 306.7 0 308c0 1.2.2 2.4.3 3.7.2 2.2.3 4.4.8 6.6.1.3.2.6.2.9 2.7 12.1 9.5 23.3 20.4 30.9l213 149.2c23.1 16.2 55 10.6 71.2-12.6C322.2 463.5 316.5 431.7 293.4 415.5zM706.6 200.4L860.1 308 706.6 415.5c-23.1 16.2-28.7 48.1-12.6 71.2 16.2 23.1 48.1 28.7 71.2 12.6l213-149.2c10.9-7.7 17.8-18.8 20.4-30.9.1-.3.2-.6.2-.9.4-2.2.6-4.4.8-6.6.1-1.2.3-2.4.3-3.7 0-1.2-.2-2.4-.3-3.7-.2-2.2-.3-4.4-.8-6.6-.1-.3-.2-.6-.2-.9-2.7-12.1-9.5-23.3-20.4-30.9l-213-149.2c-23.1-16.2-55-10.6-71.2 12.6C677.8 152.4 683.5 184.2 706.6 200.4zM418 614.2L418 614.2c-27.3-7.3-43.5-35.3-36.1-62.6L519.4 37.9c7.3-27.3 35.3-43.5 62.6-36.1l0 0c27.3 7.3 43.5 35.3 36.1 62.6L480.6 578C473.3 605.3 445.2 621.5 418 614.2z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 999.7 1000" id="cog">
                  <path
                    d="M995.9,339.1l-31.4-75.8c-10.6-25.5-39.8-37.6-65.3-27l-48.2,20c-6.3,2.6-13.7,0.6-17.7-4.9c-24.4-32.8-53-61.1-84.8-84.8 c-5.5-4.1-7.5-11.4-4.9-17.7l20-48.4c10.5-25.5-1.6-54.7-27.1-65.2l-76-31.4c-25.5-10.5-54.7,1.5-65.3,27l-20.1,48.5 c-2.6,6.3-9.2,10.1-16,9.1c-39.2-5.7-79.5-5.9-119.9,0.1c-6.8,1-13.4-2.8-16-9.1l-20-48.2c-10.6-25.5-39.8-37.6-65.3-27l-75.8,31.4 c-25.5,10.6-37.6,39.8-27,65.3l20,48.2c2.6,6.3,0.6,13.6-4.8,17.7c-32.1,24.1-60.7,52.8-84.4,84.6c-4.1,5.5-11.4,7.5-17.7,4.9 l-48.1-19.9c-25.5-10.6-54.8,1.6-65.3,27.1L3.9,338.3c-10.7,26,1.6,55.8,27.6,66.6L79,424.6c6.3,2.6,10.1,9.2,9.1,16 c-5.7,39.2-5.9,79.5,0.1,119.9c1,6.8-2.8,13.4-9.1,16l-48.2,20C5.5,607.1-6.6,636.3,4,661.8l31.4,75.8c10.6,25.5,39.8,37.6,65.3,27 l48.2-20c6.3-2.6,13.6-0.6,17.7,4.8c24.1,32.1,52.8,60.7,84.6,84.4c5.5,4.1,7.5,11.4,4.9,17.7l-19.9,48.1 c-10.6,25.5,1.6,54.8,27.1,65.3l75.7,31.3c25.5,10.6,54.8-1.6,65.3-27.2l19.8-48c2.6-6.3,9.2-10.1,16-9.1c39.2,5.7,79.7,5.7,119.4,0 c6.8-1,13.3,2.8,15.9,9.1l20,48.2c10.6,25.5,39.8,37.6,65.3,27l75.8-31.4c25.5-10.6,37.6-39.8,27-65.3l-20-48.2 c-2.6-6.3-0.6-13.7,4.9-17.7c32.8-24.4,61.1-53,84.8-84.8c4.1-5.5,11.4-7.5,17.7-4.9l48.4,20c25.5,10.5,54.7-1.6,65.2-27.1 l31.4-75.8c10.6-25.5-1.6-54.8-27.1-65.3l-48-19.8c-6.3-2.6-10.1-9.2-9.1-16c5.7-39.2,5.8-79.7,0.1-119.5c-1-6.8,2.8-13.3,9.1-15.9 l48.2-20C994.3,393.8,1006.4,364.6,995.9,339.1z M707.7,500c0,114.9-93.1,208-208,208s-208-93.1-208-208s93.1-208,208-208 S707.7,385.1,707.7,500z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 727.5" id="cog-old">
                  <path
                    d="M495.6,249.8c-19.6,0-38.3-16.6-45.7-34.6c-7.4-18-5.4-42.8,8.6-56.6l25.1-25.2 c13.8-13.8,13.8-36.4,0-50.3c-13.8-13.8-36.3-13.8-50.2-0.1c0,0-11.2,11.1-25.1,25.1c-13.8,13.8-40.9,15.9-58.9,8.5 c-18-7.4-36.4-26.1-36.4-45.7V35.4C313,15.8,301.1,0,281.5,0S250,15.8,250,35.4v35.4c0,19.6-16.8,38.3-34.7,45.7 c-18,7.5-42.7,5.4-56.7-8.6l-25.4-24.9c-13.8-13.8-36.4-13.8-50.2,0s-13.8,36.3-0.1,50l25.1,25.1c13.8,13.8,16.2,38.3,10.1,56.6 c-5.9,18.3-24.4,33.8-43.9,33.5l-38.9-0.3c-19.6,0-35.4,13-35.4,32.5c0,19.6,15.8,32.5,35.4,32.5h35.4c19.6,0,38.4,18.4,47.1,35.7 s6.7,42.5-7.4,56.3l-27.7,28c-13.8,13.8-13.8,36.6,0,50.4s36.3,14,50,0.2l25.1-25c13.8-13.8,39.3-15.9,57.3-8.5 c18,7.5,34.8,26.1,34.8,45.7v35.4c0,19.6,11.9,35.4,31.5,35.4s31.5-15.8,31.5-35.4v-35.4c0-19.6,18.4-38.3,36.4-45.7 c18-7.5,43.6-5.4,57.5,8.6l25.8,25.1c13.8,13.8,36.6,13.8,50.4,0s14.1-36.3,0.2-50l-25-25.1c-13.8-13.8-15.9-41-8.5-59 c7.5-18,26.1-36.5,45.7-36.5h35.4c19.6,0,35.4-11.9,35.4-31.5c0-19.6-15.8-31.5-35.4-31.5H495.6z M283.2,389.3 c-58.6,0-106.3-47.7-106.3-106.3s47.7-106.3,106.3-106.3S389.5,224.5,389.5,283S341.8,389.3,283.2,389.3z"
                  ></path>
                  <path
                    d="M943.7,500.4c-18.4-6.8-30.5-28-31.2-47.6c-0.7-19.4,9.7-41.5,27.6-49.6l32.2-14.8 c17.8-8.1,25.5-29.1,17.4-47c-8.1-17.8-29.1-25.5-47-17.4c0,0-14.4,6.7-32.2,14.8c-17.8,8.1-41.3,1.7-55.5-11.5 c-14.2-13.2-22.5-36.3-15.7-54.5l12.3-33.2c6.8-18.4-2.5-38.7-20.9-45.5s-38.7,2.5-45.5,20.9l-12.3,33.2 c-6.8,18.4-28,30.5-47.4,31.2c-19.4,0.7-41.5-9.7-49.6-27.6l-14.8-32.2c-8.1-17.8-29.1-25.5-46.8-17.4c-17.8,8.1-25.5,29.1-17.4,47 l14.8,32.2c8.1,17.8,1.9,41.5-10.2,56.6s-34.7,23.2-52.9,16.1l-36.3-13.8c-18.3-6.8-38.7,2.6-45.5,20.9 c-6.8,18.4,2.6,38.7,20.9,45.5l33.2,12.3c18.3,6.8,30.7,28,32.8,47.1c2.2,19.1-8.1,40.7-26,48.7l-35.5,16 c-17.8,8.1-25.5,29.3-17.4,47c8.1,17.8,29.1,25.5,47,17.4l32.2-14.8c17.8-8.1,41.2-1.7,55.5,11.6c14.2,13.2,22.5,36.3,15.7,54.5 l-12.3,33.2c-6.8,18.3,2.6,38.7,20.9,45.5c18.4,6.8,38.7-2.5,45.5-20.9l12.3-33.2c6.8-18.4,28.1-30.3,47.4-31 c19.4-0.7,41.5,9.7,49.6,27.6l14.8,32.2c8.1,17.8,29.1,25.5,46.8,17.4c17.8-8.1,25.7-29.1,17.5-47l-14.8-32.2 c-8.1-17.8-1.7-41.3,11.6-55.5c13.2-14.2,36.3-22.5,54.5-15.7l33.2,12.3c18.4,6.8,38.7-2.5,45.5-20.9c6.8-18.4-2.5-38.7-20.9-45.5 L943.7,500.4z M695.1,559.3c-55-20.4-82.9-81.6-62.6-136.6c20.4-55,81.6-82.9,136.6-62.6c55,20.4,82.9,81.6,62.6,136.6 C811.3,551.6,750.1,579.7,695.1,559.3z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1345.1 1000" id="conversion-kit">
                  <path
                    d="M787.5 850V150c0-82.5-67.5-150-150-150s-150 67.5-150 150v700c0 82.5 67.5 150 150 150S787.5 932.5 787.5 850zM600 150c0-20.7 16.8-37.5 37.5-37.5S675 129.3 675 150c0 20.7-16.8 37.5-37.5 37.5S600 170.7 600 150zM600 849.9c0-20.7 16.8-37.5 37.5-37.5s37.5 16.8 37.5 37.5c0 20.7-16.8 37.5-37.5 37.5S600 870.6 600 849.9zM275.4 786.8v75h-75v-75h-62.9c-34.5 0-62.5 28-62.5 62.5s28 62.5 62.5 62.5h283.6c2.5 8.7 5.5 17.3 9.1 25.7 7.5 17.7 17.2 34.2 28.8 49.3H137.5C61.7 986.8 0 925.2 0 849.3s61.7-137.5 137.5-137.5h274.9v75H275.4zM862.5 202.6l389.2 215-160.7 54L862.5 345.4v85.7l197 108.9c15.3 8.5 33.6 10.1 50.1 4.5l192.8-64.8c23.5-7.9 40.1-28.9 42.3-53.6 2.2-24.7-10.3-48.4-32-60.3l-453-250.2c1.8 11.4 2.7 22.9 2.7 34.6V202.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="conversion-rate">
                  <path
                    d="M619.9,553.3c0-58.1-58.9-77.5-96.9-87.2V408c13,4.8,38.1,14.5,52.7,29.1l33.3-43.6c-24.2-24.2-60.9-33.9-85.9-38.8V313 h-37v41.7c-63,4.8-92,43.6-92,87.2c0,58.1,42,77.5,92,87.2v67.8c-38-4.8-55.6-24.2-70.1-38.8l-36.2,48.4 C404,630.8,436,645.3,486,650.2V688h37v-42.7C586,640.5,619.9,601.7,619.9,553.3z M486,461.2c-25-4.8-33.9-9.7-33.9-24.2 S461,412.8,486,408V461.2z M523,596.9v-58.1c25,4.8,33.9,14.5,33.9,29.1S548,592,523,596.9z"
                  ></path>
                  <path
                    d="M500.2 875c-.1 0-.2 0-.2 0-205 0-375-170-375-375 0-109.2 48.2-208.4 124.3-277.3l62.9 90.5c5.8 8.3 18.5 6.7 22-2.8L442.2 17.6c3-8.1-3-16.8-11.7-16.8L118.5 0c-10.1 0-16.1 11.3-10.3 19.6l69 99.3C69 210.9 0 347.8 0 500c0 275 225 500 500 500 .2 0 .3 0 .5 0 12.4 0 22.5-10.2 22.5-22.6v-79.7C523 885.1 512.8 875 500.2 875zM822.1 881.6C930.7 789.7 1000 652.6 1000 500 1000 225 775 0 500 0c-.2 0-.3 0-.5 0C487 0 477 10.2 477 22.6v79.7c0 12.6 10.2 22.6 22.8 22.6.1 0 .2 0 .2 0 205 0 375 170 375 375 0 109.5-48.5 209-124.9 278l-63.3-91.1c-5.8-8.3-18.5-6.7-22 2.8L556.7 982.4c-3 8.2 3 16.8 11.7 16.8l312 .7c10.1 0 16.1-11.3 10.3-19.6L822.1 881.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="copy">
                  <path
                    d="M950,0H300c-27.5,0-50,22.5-50,50v200H50c-27.5,0-50,22.5-50,50v650c0,27.5,22.5,50,50,50h650c27.6,0,50-22.4,50-50V750h200 c27.6,0,50-22.4,50-50V50C1000,22.4,977.6,0,950,0z M600,875H150c-13.8,0-25-11.2-25-25V400c0-13.8,11.2-25,25-25h100v325 c0,27.6,22.4,50,50,50h325v100C625,863.8,613.8,875,600,875z M625,625H400.4c-14,0-25.4-11.4-25.4-25.4V375h225 c13.8,0,25,11.2,25,25V625z M850,625H750V300c0-27.6-22.4-50-50-50H375V150c0-13.8,11.2-25,25-25h450c13.8,0,25,11.2,25,25v450 C875,613.8,863.8,625,850,625z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="cost-per-paid-lead">
                  <path
                    d="M523,466.1V408c13,4.8,38.1,14.5,52.7,29.1l33.3-43.6c-24.2-24.2-60.9-33.9-85.9-38.8V313h-37v41.7 c-63,4.8-92,43.6-92,87.2c0,58.1,42,77.5,92,87.2v67.8c-38-4.8-55.6-24.2-70.1-38.8l-36.2,48.4C404,630.8,436,645.3,486,650.2V688 h37v-42.7c63-4.8,96.9-43.6,96.9-92C619.9,495.2,561,475.8,523,466.1z M486,461.2c-25-4.8-33.9-9.7-33.9-24.2S461,412.8,486,408 V461.2z M523,596.9v-58.1c25,4.8,33.9,14.5,33.9,29.1S548,592,523,596.9z"
                  ></path>
                  <path
                    d="M500,0C225,0,0,225,0,500s225,500,500,500s500-225,500-500S775,0,500,0z M500,875c-205,0-375-170-375-375s170-375,375-375 s375,170,375,375S705,875,500,875z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="create">
                  <path
                    d="M975,500h-75c-13.8,0-25,11.2-25,25v325c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h325 c13.8,0,25-11.2,25-25V25c0-13.8-11.2-25-25-25H50C22.5,0,0,22.5,0,50v900c0,27.5,22.5,50,50,50h900c27.6,0,50-22.4,50-50V525 C1000,511.2,988.8,500,975,500z"
                  ></path>
                  <path
                    d="M260.7,537.5L279,678.3c2.9,22.5,20.6,40.2,43.1,43.1l140.7,18.4c15.4,2,30.8-3.2,41.8-14.2l480.2-481.1 c19.5-19.5,19.5-51.2,0-70.7L825.8,14.6c-19.5-19.5-51.2-19.5-70.7,0L274.9,495.7C263.9,506.7,258.7,522.1,260.7,537.5z M411.2,518.5l362.4-362.4c9.8-9.8,25.6-9.8,35.4,0l35.4,35.4c9.8,9.8,9.8,25.6,0,35.4L481.9,589.2c-9.8,9.8-25.6,9.8-35.4,0 l-35.4-35.4C401.4,544.1,401.4,528.3,411.2,518.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="credit-card">
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50 V50C1000,22.4,977.6,0,950,0z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V475h750V850z M875,250H125V150 c0-13.8,11.2-25,25-25h700c13.8,0,25,11.2,25,25V250z"
                  ></path>
                  <path
                    d="M244 775h137c13.8 0 25-11.2 25-25V613c0-13.8-11.2-25-25-25H244c-13.8 0-25 11.2-25 25v137C219 763.8 230.2 775 244 775zM494 775h12c13.8 0 25-11.2 25-25v-12c0-13.8-11.2-25-25-25h-12c-13.8 0-25 11.2-25 25v12C469 763.8 480.2 775 494 775zM744 775h12c13.8 0 25-11.2 25-25v-12c0-13.8-11.2-25-25-25h-12c-13.8 0-25 11.2-25 25v12C719 763.8 730.2 775 744 775zM619 775h12c13.8 0 25-11.2 25-25v-12c0-13.8-11.2-25-25-25h-12c-13.8 0-25 11.2-25 25v12C594 763.8 605.2 775 619 775z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="crm">
                  <path
                    d="M400 256h200c13.8 0 25-11.2 25-25v-10c0-13.8-11.2-25-25-25H400c-13.8 0-25 11.2-25 25v10C375 244.8 386.2 256 400 256zM895.5 554.4c-9.8-9.8-25.6-9.8-35.4 0L683.4 731.2c-9.8 9.8-9.8 25.6 0 35.4l7.1 7.1c9.8 9.8 25.6 9.8 35.4 0l176.8-176.8c9.8-9.8 9.8-25.6 0-35.4L895.5 554.4zM309.5 773.6l7.1-7.1c9.8-9.8 9.8-25.6 0-35.4L139.8 554.4c-9.8-9.8-25.6-9.8-35.4 0l-7.1 7.1c-9.8 9.8-9.8 25.6 0 35.4l176.8 176.8C283.9 783.4 299.8 783.4 309.5 773.6z"
                  ></path>
                  <path
                    d="M418 479.9v-37.4c0-92.8-60.5-171.5-144.2-198.7 39.4-22.4 65.9-64.8 65.9-113.3C339.7 58.4 281.3 0 209.3 0S78.9 58.4 78.9 130.4c0 48.6 26.6 91 66.1 113.4-.1 0-.3.1-.4.1l-.3-.2C60.5 270.9 0 349.7 0 442.4v37.4C0 491 9 500 20.1 500h377.7C409 500 418 491 418 479.9zM139.2 130.4c0-38.6 31.4-70 70-70 38.6 0 70 31.4 70 70 0 38.6-31.4 70-70 70C170.7 200.4 139.2 169 139.2 130.4zM60.4 440c.6-38.7 15.9-75 43.3-102.4 8.5-8.5 17.9-15.9 27.9-22 1.3-.4 2.6-1 3.8-1.7 22.3-12.9 47.7-19.8 74.2-19.8 39.6 0 76.8 15.4 104.8 43.4C341.7 365 357 401.3 357.6 440H60.4zM855.8 243.7c39.4-22.4 65.9-64.8 65.9-113.3C921.7 58.4 863.3 0 791.3 0c-72 0-130.4 58.4-130.4 130.4 0 48.6 26.6 91 66.1 113.4-.1 0-.3.1-.4.1l-.3-.2C642.5 270.9 582 349.7 582 442.4v37.4c0 11.1 9 20.1 20.1 20.1h377.7c11.1 0 20.1-9 20.1-20.1v-37.4C1000 349.7 939.5 270.9 855.8 243.7zM721.3 130.4c0-38.6 31.4-70 70-70 38.6 0 70 31.4 70 70 0 38.6-31.4 70-70 70C752.7 200.4 721.3 169 721.3 130.4zM642.4 440c.6-38.7 15.9-75 43.3-102.4 8.5-8.5 17.9-15.9 27.9-22 1.3-.4 2.6-1 3.8-1.7 22.3-12.9 47.7-19.8 74.2-19.8 39.6 0 76.8 15.4 104.8 43.4C923.7 365 939 401.3 939.6 440H642.4zM564.8 743.7c39.4-22.4 65.9-64.8 65.9-113.3 0-72-58.4-130.4-130.4-130.4s-130.4 58.4-130.4 130.4c0 48.6 26.6 91 66.1 113.4-.1 0-.3.1-.4.1l-.3-.2C351.5 770.9 291 849.7 291 942.4v37.4c0 11.1 9 20.1 20.1 20.1h377.7c11.1 0 20.1-9 20.1-20.1v-37.4C709 849.7 648.5 770.9 564.8 743.7zM430.2 630.4c0-38.6 31.4-70 70-70 38.6 0 70 31.4 70 70 0 38.6-31.4 70-70 70C461.7 700.4 430.2 669 430.2 630.4zM351.4 940c.6-38.7 15.9-75 43.3-102.4 8.5-8.5 17.9-15.9 27.9-22 1.3-.4 2.6-1 3.8-1.7 22.3-12.9 47.7-19.8 74.2-19.8 39.6 0 76.8 15.4 104.8 43.4C632.7 865 648 901.3 648.6 940H351.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="csv">
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50V50C1000,22.4,977.6,0,950,0z M875,850 c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h700c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M329.9 445.3c-3.4-5.4-7.5-10.1-12.6-14.2-5-4.1-10.7-7.2-17.1-9.5s-13-3.4-19.9-3.4c-12.7 0-23.5 2.5-32.3 7.4-8.9 4.9-16.1 11.5-21.6 19.8s-9.5 17.7-12 28.2-3.8 21.4-3.8 32.7c0 10.8 1.3 21.3 3.8 31.4 2.5 10.2 6.5 19.4 12 27.5s12.7 14.7 21.6 19.6c8.9 4.9 19.6 7.4 32.3 7.4 17.3 0 30.7-5.3 40.4-15.8 9.7-10.5 15.6-24.4 17.8-41.7h54.6c-1.4 16.1-5.2 30.5-11.1 43.5-6 12.9-13.9 24-23.7 33.1-9.8 9.1-21.3 16.1-34.5 20.8-13.2 4.8-27.7 7.2-43.5 7.2-19.6 0-37.3-3.4-53-10.2s-28.9-16.2-39.7-28.2-19-26.1-24.8-42.2-8.6-33.6-8.6-52.3c0-19.2 2.9-37 8.6-53.4 5.8-16.4 14-30.7 24.8-42.9 10.8-12.2 24-21.8 39.7-28.8 15.7-6.9 33.4-10.4 53-10.4 14.1 0 27.5 2 40.1 6.1s23.8 10 33.8 17.8c9.9 7.8 18.1 17.4 24.6 28.9s10.5 24.7 12.2 39.5h-54.6C335.4 456.7 333.3 450.7 329.9 445.3zM465.8 570.2c3.1 6 7.2 10.8 12.4 14.6 5.1 3.7 11.2 6.5 18.1 8.3s14.1 2.7 21.6 2.7c5 0 10.4-.4 16.2-1.3 5.8-.8 11.1-2.5 16.2-4.9 5-2.4 9.2-5.7 12.6-9.9 3.4-4.2 5-9.5 5-16 0-6.9-2.2-12.6-6.6-16.9-4.4-4.3-10.2-7.9-17.4-10.8-7.2-2.9-15.3-5.4-24.4-7.5-9.1-2.2-18.3-4.5-27.7-7.2-9.6-2.4-18.9-5.3-28-8.8s-17.3-8-24.4-13.5c-7.2-5.5-13-12.4-17.4-20.7-4.4-8.3-6.6-18.3-6.6-30 0-13.2 2.8-24.6 8.4-34.3 5.6-9.7 13-17.8 22.1-24.3s19.4-11.3 30.9-14.4 23-4.7 34.5-4.7c13.4 0 26.3 1.5 38.6 4.5s23.3 7.9 32.9 14.6c9.6 6.7 17.2 15.3 22.8 25.7 5.6 10.4 8.4 23.1 8.4 37.9h-54.6c-.5-7.7-2.1-14-4.9-19-2.8-5-6.4-9-11-11.9s-9.8-4.9-15.6-6.1c-5.9-1.2-12.3-1.8-19.2-1.8-4.6 0-9.1.5-13.7 1.4-4.6 1-8.7 2.6-12.4 5-3.7 2.4-6.8 5.4-9.2 9-2.4 3.6-3.6 8.1-3.6 13.7 0 5 1 9.1 2.9 12.2s5.7 6 11.3 8.6c5.6 2.6 13.4 5.3 23.4 7.9 9.9 2.6 22.9 6 39 10.1 4.8 1 11.4 2.7 19.9 5.2s16.9 6.5 25.3 12c8.4 5.5 15.6 12.9 21.7 22.1 6.1 9.2 9.2 21 9.2 35.4 0 11.7-2.3 22.6-6.8 32.7-4.6 10.1-11.3 18.8-20.3 26.1s-20.1 13-33.4 17.1c-13.3 4.1-28.7 6.1-46.2 6.1-14.1 0-27.9-1.7-41.2-5.2-13.3-3.5-25-8.9-35.2-16.4-10.2-7.4-18.3-16.9-24.3-28.4s-8.9-25.2-8.6-41h54.6C461.1 556.9 462.6 564.2 465.8 570.2zM702.6 633.5l-83-256.6h57.9l57.1 180.4h.7l57.9-180.4h58.2l-85.2 256.6H702.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="dashboard">
                  <path
                    d="M388 0H50C22.4 0 0 22.4 0 50v100c0 27.6 22.4 50 50 50h338c27.6 0 50-22.4 50-50V50C438 22.4 415.6 0 388 0zM950 0H612c-27.6 0-50 22.4-50 50v100c0 27.6 22.4 50 50 50h338c27.6 0 50-22.4 50-50V50C1000 22.4 977.6 0 950 0zM388 325H50c-27.6 0-50 22.4-50 50v575c0 27.6 22.4 50 50 50h338c27.6 0 50-22.4 50-50V375C438 347.4 415.6 325 388 325zM950 325H612c-27.6 0-50 22.4-50 50v575c0 27.6 22.4 50 50 50h338c27.6 0 50-22.4 50-50V375C1000 347.4 977.6 325 950 325z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 584.5" id="data">
                  <path
                    d="M374.1,584.5c-18.2,0-35.7-8-47.6-22L197.7,410.7l-85,114.6c-20.6,27.7-59.7,33.5-87.4,13c-27.7-20.6-33.5-59.7-13-87.4 L144.2,273c11.4-15.3,29.1-24.6,48.1-25.2c19-0.6,37.4,7.5,49.7,22l121.4,143L505.3,158c10.1-18.1,28.5-30.1,49.2-31.9 c20.7-1.8,40.9,6.8,53.9,22.9l123.7,152.3L883,32c16.9-30.1,55-40.9,85.1-24c30.1,16.9,40.9,55,24,85.1L796.3,442.6 c-10.1,18.1-28.5,30-49.2,31.7c-20.6,1.8-40.8-6.8-53.9-22.9L569.6,299.4l-140.9,253c-10,17.9-28.1,29.8-48.5,31.8 C378.2,584.4,376.2,584.5,374.1,584.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="date-time">
                  <path
                    d="M500,0C225,0,0,225,0,500s225,500,500,500s500-225,500-500S775,0,500,0z M500,875c-205,0-375-170-375-375s170-375,375-375 s375,170,375,375S705,875,500,875z"
                  ></path>
                  <path
                    d="M640.6,500H500V359.4c0-27.6-19.3-46.4-46.9-46.4h-25c-27.6,0-53.1,18.8-53.1,46.4v135.4v77.1c0,27.6,25.5,53.1,53.1,53.1 h75h137.5c27.6,0,47.4-25.5,47.4-53.1v-25C688,519.3,668.2,500,640.6,500z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="deadline">
                  <path
                    d="M950,0h-25c-27.6,0-50,22.4-50,50v100v5v10.2c0,12.6-10.2,22.8-22.8,22.8H584.8c-12.6,0-22.8-10.2-22.8-22.8V50 c0-27.6-22.4-50-50-50h-25c-27.6,0-50,22.4-50,50v115.2c0,12.6-10.2,22.8-22.7,22.8H147.8c-12.6,0-22.8-10.2-22.8-22.8V150V50 c0-27.6-22.4-50-50-50H50C22.4,0,0,22.4,0,50v138v125v637c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50V313V188V50 C1000,22.4,977.6,0,950,0z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V313h750V850z"
                  ></path>
                  <circle cx="281.8" cy="62.5" r="62.5"></circle>
                  <circle cx="718.5" cy="62.5" r="62.5"></circle>
                  <path
                    d="M395.9,771.5c27.6,27.6,72.2,27.6,99.8,0l253.8-253.8c27.6-27.6,27.6-72.2,0-99.8c-27.6-27.6-72.2-27.6-99.8,0L445.8,621.8 l-71.3-71.3c-27.6-27.6-72.2-27.6-99.8,0c-27.6,27.6-27.6,72.2,0,99.8L395.9,771.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 592.3" id="description-area">
                  <path
                    d="M351.3 0l217.6 582H436l-44-130H174.4l-45.6 130H0L220 0H351.3zM358.6 357l-73.3-214h-1.6l-75.8 214H358.6zM602.3 290c1.6-27 8.4-49.8 20.4-67.7 11.9-17.9 27.2-32.3 45.6-43.2 18.5-10.9 39.2-18.6 62.3-23.2 23.1-4.6 46.3-6.9 69.7-6.9 21.2 0 42.6 1.5 64.4 4.5 21.7 3 41.6 8.8 59.5 17.5 17.9 8.7 32.4 20.8 43.8 36.3 11.4 15.5 17 36 17 61.5v219.2c0 19 1.2 37.4 3.4 54.8 2.2 17.4 6.1 30.3 11.6 39.3H882.6c-2.2-7-3.9-13.3-5.3-20.1-1.4-6.8-2.3-13.8-2.9-20.9-18.5 19-40.2 32.3-65.2 39.9-25 7.6-50.5 11.4-76.6 11.4-20.1 0-38.9-2.5-56.2-7.3-17.4-4.9-32.6-12.5-45.6-22.8-13-10.3-23.2-23.4-30.6-39.1-7.3-15.8-11-34.5-11-56.2 0-23.9 4.2-43.6 12.6-59.1 8.4-15.5 19.3-27.8 32.6-37.1 13.3-9.2 28.5-16.2 45.6-20.8 17.1-4.6 34.4-8.3 51.8-11 17.4-2.7 34.5-4.9 51.3-6.5 16.8-1.6 31.8-4.1 44.8-7.3 13-3.3 23.4-8 31-14.3 7.6-6.2 11.1-15.3 10.6-27.3 0-12.5-2-22.4-6.1-29.7-4.1-7.3-9.5-13-16.3-17.1-6.8-4.1-14.7-6.8-23.6-8.1-9-1.4-18.6-2-28.9-2-22.8 0-40.7 4.9-53.8 14.7-13 9.8-20.7 26-22.8 49H602.3zM870 375.5c-5 4.4-11.2 7.7-18.5 10.2-7.3 2.4-15.3 4.5-23.7 6.1-8.4 1.6-17.3 3-26.5 4.1-9.2 1.1-18.5 2.4-27.7 4.1-8.7 1.6-17.3 3.8-25.7 6.5-8.4 2.7-15.8 6.4-22 11-6.3 4.6-11.3 10.5-15.1 17.5-3.8 7.1-5.7 16-5.7 26.9 0 10.3 1.9 19 5.7 26.1 3.8 7.1 9 12.6 15.5 16.7 6.5 4.1 14.1 6.9 22.8 8.6 8.7 1.6 17.6 2.4 26.9 2.4 22.8 0 40.5-3.8 53-11.4 12.5-7.6 21.7-16.7 27.7-27.3 6-10.6 9.8-21.3 11.2-32.2 1.4-10.9 2.2-19.6 2.2-26.1V375.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="dock-to-left">
                  <path
                    d="M1000,50c0-27.6-22.4-50-50-50H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50 h900c27.6,0,50-22.4,50-50V50z M375,150c0-13.8,11.2-25,25-25h450c13.8,0,25,11.2,25,25v700c0,13.8-11.2,25-25,25H400 c-13.8,0-25-11.2-25-25V150z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="dock-to-right">
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50 V50C1000,22.4,977.6,0,950,0z M625,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h450 c13.8,0,25,11.2,25,25V850z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="document">
                  <path
                    d="M686.6,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900 c27.6,0,50-22.4,50-50V313.4c0-13.3-5.3-26-14.6-35.4L721.9,14.6C712.6,5.3,699.9,0,686.6,0z M875,850c0,13.8-11.2,25-25,25H150 c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h487v188c0,27.6,22.4,50,50,50h188V850z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="download">
                  <path
                    d="M311.1,738.8l178.8,255.9c5,7.1,15.5,7.1,20.5,0L689,738.8c5.8-8.3-0.1-19.8-10.2-19.8h-91.2c-6.9,0-12.5-5.6-12.5-12.5 v-400c0-6.9-5.6-12.5-12.5-12.5h-125c-6.9,0-12.5,5.6-12.5,12.5v400c0,6.9-5.6,12.5-12.5,12.5h-91.2 C311.2,719,305.3,730.5,311.1,738.8z"
                  ></path>
                  <path
                    d="M950,1000c27.6,0,50-22.4,50-50V50c0-27.5-22.5-50-50-50H50C22.5,0,0,22.5,0,50v900c0,27.6,22.4,50,50,50h237 c13.8,0,25-11.2,25-25v-75c0-13.8-11.2-25-25-25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h700c13.8,0,25,11.2,25,25v700 c0,13.8-11.2,25-25,25H712c-13.8,0-25,11.2-25,25v75c0,13.8,11.2,25,25,25H950z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 875" id="drag-grip">
                  <path
                    d="M1000 25c0-13.8-11.2-25-25-25H25C11.2 0 0 11.2 0 25v75c0 13.8 11.2 25 25 25h950c13.8 0 25-11.2 25-25V25zM1000 275c0-13.8-11.2-25-25-25H25c-13.8 0-25 11.2-25 25v75c0 13.8 11.2 25 25 25h950c13.8 0 25-11.2 25-25V275zM1000 525c0-13.8-11.2-25-25-25H25c-13.8 0-25 11.2-25 25v75c0 13.8 11.2 25 25 25h950c13.8 0 25-11.2 25-25V525zM1000 775c0-13.8-11.2-25-25-25H25c-13.8 0-25 11.2-25 25v75c0 13.8 11.2 25 25 25h950c13.8 0 25-11.2 25-25V775z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 661.9" id="dropdown">
                  <path
                    d="M461.6,643.4L10.9,79.9C-14.9,47.7,8,0,49.3,0h901.5c41.2,0,64.1,47.7,38.4,79.9L538.4,643.4 C518.7,668,481.3,668,461.6,643.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="dropdown-square">
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50 V50C1000,22.4,977.6,0,950,0z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h700 c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M657.8,419H342.2c-14.4,0-22.4,16.8-13.4,28.1l157.8,197.3 c6.9,8.6,20,8.5,26.9-0.1l157.8-197.3C680.2,435.8,672.2,419,657.8,419z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 994.8 994.8" id="edit">
                  <path
                    d="M821.1,279.8L253.4,847.4c-9.8,9.8-25.6,9.8-35.4,0l-70.7-70.7c-9.8-9.8-9.8-25.6,0-35.4L715,173.7c9.8-9.8,25.6-9.8,35.4,0 l70.7,70.7C830.8,254.2,830.8,270,821.1,279.8z M697.3,14.6L14.6,697.3C3.5,708.5-1.8,724.3,0.5,740l27.3,184.9 c3.2,21.8,20.4,39,42.2,42.2l184.9,27.3c15.6,2.3,31.5-2.9,42.6-14.1l682.7-682.7c19.5-19.5,19.5-51.2,0-70.7L768,14.6 C748.5-4.9,716.8-4.9,697.3,14.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="edit-circle">
                  <path
                    d="M648.2,310.4c-5.7-5.7-15-5.7-20.7,0L294.9,642.9c-5.7,5.7-5.7,15,0,20.7l41.4,41.4c5.7,5.7,15,5.7,20.7,0l332.6-332.6 c5.7-5.7,5.7-15,0-20.7L648.2,310.4z"
                  ></path>
                  <path
                    d="M499.7,0C223.6,0,0,224,0,500c0,276,223.6,500,499.7,500c276.1,0,500.3-224,500.3-500C1000,224,776.4,0,499.7,0z M782.9,382.9l-400,400c-6.6,6.6-15.8,9.6-25,8.3l-108.3-16c-12.8-1.9-22.8-11.9-24.7-24.7l-16-108.3c-1.4-9.2,1.7-18.4,8.3-25 l400-400c11.4-11.4,30-11.4,41.4,0l124.3,124.3C794.3,352.9,794.3,371.4,782.9,382.9z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 660.7" id="education">
                  <path
                    d="M500,510.5c-17.5,0-34.5-3.3-50.7-9.8l-277-110.8v151.3c0,17.6,9.3,33.8,24.3,42.9c78.6,47.4,185.6,76.6,303.4,76.6 c117.9,0,224.8-29.2,303.4-76.6c15.1-9.1,24.3-25.3,24.3-42.9V389.9l-277,110.8C534.5,507.2,517.4,510.5,500,510.5z"
                  ></path>
                  <path
                    d="M982.8,188.9L520.3,3.9C513.8,1.3,506.9,0,500,0c-6.9,0-13.8,1.3-20.3,3.9l-462.5,185c-22.9,9.2-22.9,41.6,0,50.7l30.1,12 v188.4c-14.9,8.6-25,24.8-25,43.3v125c0,13.8,11.2,25,25,25h50c13.8,0,25-11.2,25-25v-125c0-18.5-10.1-34.6-25-43.3V271.7 l382.4,153c6.5,2.6,13.4,3.9,20.3,3.9s13.8-1.3,20.3-3.9l462.6-185C1005.7,230.5,1005.7,198.1,982.8,188.9z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="email">
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50V50C1000,22.4,977.6,0,950,0z M854,125 c0.7,0,1.3,0,2,0.1L517.7,463.4c-9.8,9.8-25.6,9.8-35.4,0L144.1,125.2c0.9-0.1,1.9-0.2,2.8-0.2H854z M875,850c0,13.8-11.2,25-25,25 H150c-13.8,0-25-11.2-25-25V282.9l286.6,286.6l53,53c19.5,19.5,51.2,19.5,70.7,0l53-53L875,282.9V850z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 685" id="equal">
                  <path
                    d="M859.3 402H143.5C65.8 402 0 464 0 541.7v1.7C0 621.1 65.8 685 143.5 685h715.8c77.7 0 140.7-63.8 140.7-141.5C1000 465.8 937 402 859.3 402zM143.5 283h715.8c77.7 0 140.7-63.8 140.7-141.5C1000 63.8 937 0 859.3 0H143.5C65.8 0 0 62 0 139.7v1.7C0 219.1 65.8 283 143.5 283z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="export">
                  <path
                    d="M738.8,688.9l255.9-178.8c7.1-5,7.1-15.5,0-20.5L738.8,311c-8.3-5.8-19.8,0.1-19.8,10.2v91.2c0,6.9-5.6,12.5-12.5,12.5 h-400c-6.9,0-12.5,5.6-12.5,12.5v125c0,6.9,5.6,12.5,12.5,12.5h400c6.9,0,12.5,5.6,12.5,12.5v91.2 C719,688.8,730.5,694.7,738.8,688.9z"
                  ></path>
                  <path
                    d="M1000,50c0-27.6-22.4-50-50-50H50C22.5,0,0,22.5,0,50v900c0,27.5,22.5,50,50,50h900c27.6,0,50-22.4,50-50V713 c0-13.8-11.2-25-25-25h-75c-13.8,0-25,11.2-25,25v137c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25 h700c13.8,0,25,11.2,25,25v138c0,13.8,11.2,25,25,25h75c13.8,0,25-11.2,25-25V50z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 875.1 1000" id="field-autofill">
                  <path
                    d="M824.8,0H50.1C22.5,0,0,22.3,0,50.1v899.8c0,27.6,22.3,50.1,50.1,50.1H825c27.6,0,50.1-22.3,50.1-50.1V50.1 C874.9,22.5,852.6,0,824.8,0z M750,850c0,13.8-11.2,24.9-24.9,24.9H150c-13.8,0-24.9-11.2-24.9-24.9V150 c0-13.8,11.2-24.9,24.9-24.9h575c13.8,0,24.9,11.2,24.9,24.9V850z"
                  ></path>
                  <path
                    d="M547.5 731.4H328.7c-6.8 0-12.2 5.5-12.2 12.2v30.4c0 6.8 5.5 12.2 12.2 12.2h218.7c6.8 0 12.2-5.5 12.2-12.2v-30.4C559.5 736.7 554 731.4 547.5 731.4zM661.1 530H212.9c-13.7 0-24.8 11.2-24.8 24.9v62.6c0 13.8 11.1 24.9 24.8 24.9h448.1c13.7 0 24.8-11.2 24.8-24.9v-62.6C686.1 541.1 674.8 530 661.1 530zM214.9 297.5h275.4c13.7 0 24.8-11.2 24.8-24.9V210c.2-13.8-10.9-24.9-24.8-24.9H214.9c-13.7 0-24.8 11.2-24.8 24.9v62.6C190.1 286.3 201.2 297.5 214.9 297.5zM214.9 470h275.4c13.7 0 24.8-11.2 24.8-24.9v-62.6c.2-13.8-10.9-24.9-24.8-24.9H214.9c-13.7 0-24.8 11.2-24.8 24.9v62.6C190.1 458.9 201.2 470 214.9 470zM598 282.5c6.4 6.4 16.8 6.4 23.3 0l59.2-59.1c6.4-6.4 6.4-16.8 0-23.3-6.4-6.4-16.8-6.4-23.3 0l-47.5 47.5L593 231c-6.4-6.4-16.8-6.4-23.3 0-6.4 6.4-6.4 16.8 0 23.3L598 282.5zM657.2 372.6l-47.5 47.5L593 403.5c-6.4-6.4-16.8-6.4-23.3 0-6.4 6.4-6.4 16.8 0 23.3L598 455c6.4 6.4 16.8 6.4 23.3 0l59.2-59.1c6.4-6.4 6.4-16.8 0-23.3C674 366.2 663.6 366.2 657.2 372.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 875.1 1000" id="field-bottleneck">
                  <path
                    d="M824.8,0H50.1C22.5,0,0,22.3,0,50.1v899.8c0,27.6,22.3,50.1,50.1,50.1H825c27.6,0,50.1-22.3,50.1-50.1V50.1 C874.9,22.5,852.6,0,824.8,0z M750,850c0,13.8-11.2,24.9-24.9,24.9H150c-13.8,0-24.9-11.2-24.9-24.9V150 c0-13.8,11.2-24.9,24.9-24.9h575c13.8,0,24.9,11.2,24.9,24.9V850z"
                  ></path>
                  <path
                    d="M547.5 731.4H328.7c-6.8 0-12.2 5.5-12.2 12.2v30.4c0 6.8 5.5 12.2 12.2 12.2h218.7c6.8 0 12.2-5.5 12.2-12.2v-30.4C559.5 736.7 554 731.4 547.5 731.4zM661 530H213c-13.8 0-24.9 11.2-24.9 24.9v62.6c0 13.8 11.2 24.9 24.9 24.9h448.2c13.8 0 24.9-11.2 24.9-24.9v-62.6C686.1 541.1 674.8 530 661 530zM215 297.5h275.4c13.8 0 24.9-11.2 24.9-24.9V210c0-13.8-11.2-24.9-25.2-24.9H215c-13.8 0-24.9 11.2-24.9 24.9v62.6C190.1 286.3 201.2 297.5 215 297.5zM215 470h275.4c13.8 0 24.9-11.2 24.9-24.9v-62.6c0-13.8-11.2-24.9-25.2-24.9H215c-13.8 0-24.9 11.2-24.9 24.9v62.6C190.1 458.9 201.2 470 215 470zM597.1 282.4c6.3 6.3 16.8 6.3 23.2 0l59.1-59.1c6.3-6.3 6.3-16.8-.2-23.2-6.3-6.3-16.8-6.3-23.2 0l-47.5 47.5L591.9 231c-6.3-6.3-16.8-6.3-23.2 0-6.3 6.3-6.3 16.8 0 23.2L597.1 282.4zM668 369.6c-7-6.8-18.2-6.8-24.9 0l-19.2 19.2-19.2-19.2c-7-6.8-18.2-6.8-24.9 0-6.8 7-6.8 18.2 0 24.9l19.2 19.2-19.2 19.2c-6.8 7-6.8 18.2 0 24.9 7 6.8 18.2 6.8 24.9 0l19.2-19.2L643 458c7 6.8 18.2 6.8 24.9 0 6.8-7 6.8-18.2 0-24.9l-19.2-19.2 19.2-19.2C674.8 387.6 674.8 376.4 668 369.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 625" id="fields">
                  <path
                    d="M1000 575c0 27.6-22.4 50-50 50H50c-27.6 0-50-22.4-50-50V425c0-27.6 22.4-50 50-50h900c27.6 0 50 22.4 50 50V575zM813 200c0 27.6-22.4 50-50 50H50c-27.6 0-50-22.4-50-50V50C0 22.4 22.4 0 50 0h713c27.6 0 50 22.4 50 50V200z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 982.1 1000" id="filter">
                  <path
                    d="M973.7,141.1c-8.3-15.2-20.7-29-34.5-40c-40-33.1-86.9-49.6-136.5-63.4C717.2,14.2,630.4,4.6,543.5,1.8 C434.6-3.7,327.1,3.2,220.9,25.2c-51,11-99.3,26.2-144.8,52.4C50,91.4,26.5,109.3,11.4,135.5C-1,159-5.2,183.8,8.6,207.2 c11,17.9,22.1,37.2,37.2,53.8c92.4,102,186,204,279.7,304.7c17.9,19.3,27.4,40,27.4,66.2c0,53.8,0,108.9,0,162.7 c0,57.9,0.4,114.5,0.4,173.7c0,34.8,33.7,36.8,49.8,25.9c30.3-26.2,64.7-54.8,95-81c35.8-30.3,73-62,108.8-92.4 c15.2-12.4,23.4-29,23.4-49.6c0-48.3,1.4-95.1,0-142c-1.4-23.4,6.9-40,22-56.5c93.7-102,188.9-205.4,282.6-308.8 c12.4-13.8,23.4-30.3,34.5-46.9C984.7,194.8,986.1,164.5,973.7,141.1z M492.8,279.5c-207.3,0-375.4-47.4-375.4-105.9 c0-58.5,168.1-105.9,375.4-105.9c207.3,0,375.4,47.4,375.4,105.9C868.2,232.1,700.1,279.5,492.8,279.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 864.7" id="finance">
                  <path
                    d="M990.5,316.4c-6.1-14.4-14.8-27.3-25.8-38.3c-11.1-11.1-23.9-19.7-38.3-25.8c-10.7-4.5-22-7.5-33.5-8.8 c-17.2-26.8-38.5-51.7-63.5-73.9V79.7c0-43.9-35.7-79.7-79.7-79.7c-19.5,0-38.4,3.8-56.2,11.4c-17.2,7.3-32.6,17.7-45.9,30.9 c-8.3,8.3-15.4,17.4-21.4,27.2c-2.3-0.5-4.6-0.9-6.8-1.4c-31.4-6.1-63.8-9.2-96.3-9.2c-54.7,0-107.9,8.6-158.1,25.6 c-49.3,16.7-93.8,40.7-132.3,71.5c-39.7,31.8-71.1,69.1-93.2,111.1c-17.3,32.8-28.4,67.2-33.1,102.7c-18.4-6.1-31.7-23.5-31.7-43.9 c0-18,10.4-33.6,25.4-41.3c12.7-6.4,20.8-19.3,20.8-33.4v0c0-27.7-29.2-45.9-54-33.4C27.3,237.6,0,278.6,0,325.9 c0,61.6,46.4,112.6,106,120c1.7,14.1,4.5,28,8.2,41.7c6.7,24.6,16.6,48.7,29.4,71.5c12.4,22,27.6,42.9,45.1,62.3 c8.5,9.4,17.6,18.4,27.2,27v116.7c0,54.9,44.7,99.6,99.6,99.6h74.7c54.9,0,99.6-44.7,99.6-99.6v-6.5c11,0.7,22.1,1.1,33.3,1.1 c8.2,0,16.4-0.2,24.5-0.6v6c0,54.9,44.7,99.6,99.6,99.6h74.7c54.9,0,99.6-44.7,99.6-99.6V656c28.4-23.9,52.4-51.2,71.4-80.8 c11.5-1.3,22.7-4.2,33.4-8.8c14.4-6.1,27.3-14.8,38.3-25.8c11.1-11.1,19.7-23.9,25.8-38.3c6.3-14.9,9.5-30.7,9.5-47v-91.9 C1000,347.1,996.8,331.3,990.5,316.4z M925.3,455.2c0,25.4-20.6,46-46,46h-31.2c-20.4,46.2-55.7,86.7-101.3,117.8v146.1 c0,13.7-11.1,24.9-24.9,24.9h-74.7c-13.7,0-24.9-11.1-24.9-24.9v-91.7c-31.4,7.5-64.7,11.6-99.2,11.6c-37.7,0-74-4.9-107.9-13.8 v93.9c0,13.7-11.1,24.9-24.9,24.9h-74.7c-13.7,0-24.9-11.1-24.9-24.9V612.9c-69-50.4-112.2-123-112.2-203.6 c0-152.3,154.3-275.7,344.7-275.7c56.5,0,109.9,10.9,157,30.2v-19.4c0-38.5,31.2-69.7,69.7-69.7c2.7,0,5,2.2,5,5v125.5 c41.8,30.4,74.2,68.8,93.4,112.2h31.2c25.4,0,46,20.6,46,46V455.2z"
                  ></path>
                  <circle cx="722.4" cy="322.2" r="37.3"></circle>
                  <path
                    d="M469.1,395.4c-9.2-6.5-19-11.5-29.5-15.1c-10.5-3.6-20.3-7.4-29.5-11.3c-9.2-3.9-16.8-8.5-22.8-13.9 c-6.1-5.4-9.1-12.8-9.1-22.2c0-6.2,1.9-11.9,5.7-17.2c3.8-5.2,9.7-7.9,17.8-7.9c7.3,0,12.6,3,16.1,9.1c3.5,6.1,5.2,13.1,5.2,21.2 c0,3.3,2.7,6.1,6.1,6.1h58c3.4,0,6.2-2.8,6.1-6.2c-0.9-24.6-6.9-43.2-18.1-55.7c-12.1-13.6-31.6-21.7-58.5-24.4v-9 c0-8-6.5-14.4-14.4-14.4h-8.3c-8,0-14.4,6.5-14.4,14.4v9c-49.3,8.1-73.9,37.3-73.9,87.6c0,16.4,2.9,29.7,8.7,40 c5.8,10.2,13.1,18.5,21.8,24.8c8.7,6.3,18.2,11.4,28.5,15.3c10.2,3.9,19.7,7.8,28.5,11.7c8.7,3.9,16,8.5,21.8,13.9 c5.8,5.4,8.7,12.7,8.7,21.8c0,7.3-2.1,13.5-6.3,18.6c-4.2,5.1-10.2,7.7-18,7.7c-7.5,0-13.6-2.3-18.2-6.9c-4.6-4.6-6.9-12.9-6.9-25 v-1.6c0-3.3-2.7-6.1-6.1-6.1h-60.6c-3.3,0-6.1,2.7-6.1,6.1v4.8c0,25.6,6.6,44.2,19.8,55.9c13.2,11.7,32.6,18.9,58.1,21.6v21.9 c0,8,6.5,14.4,14.4,14.4h8.3c8,0,14.4-6.5,14.4-14.4V548c27.7-3,48.7-11,63-24.2c14.3-13.2,21.4-33.5,21.4-61c0-17.5-3-31.5-9.1-42 C485.8,410.4,478.2,401.9,469.1,395.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="folder">
                  <path
                    d="M950,188H513c-13.8,0-25-11.2-25-25V50c0-27.6-22.4-50-50-50H50C22.5,0,0,22.5,0,50v900c0,27.5,22.5,50,50,50h900 c27.6,0,50-22.4,50-50V238C1000,210.4,977.6,188,950,188z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V475V150 c0-13.8,11.2-25,25-25h150.7H338c13.8,0,25,11.2,25,25v112.5c0,29.2,19.7,50.5,49.9,50.5H850c13.8,0,25,11.2,25,25V850z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="folder-move">
                  <path
                    d="M950,188H513c-13.8,0-25-11.2-25-25V50c0-27.6-22.4-50-50-50H50C22.5,0,0,22.5,0,50v900c0,27.5,22.5,50,50,50h900 c27.6,0,50-22.4,50-50V238C1000,210.4,977.6,188,950,188z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V475V150 c0-13.8,11.2-25,25-25h150.7H338c13.8,0,25,11.2,25,25v112.5c0,29.2,19.7,50.5,49.9,50.5H850c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M731.1,587.7L476.2,409c-8.3-5.8-18.2,0.1-18.2,10.2v91.2c0,6.9-6,12.5-12.9,12.5H276.5c-6.9,0-12.5,5.6-12.5,12.5v125 c0,6.9,5.6,12.5,12.5,12.5h168.6c6.9,0,12.9,5.7,12.9,12.5v91.2c0,10.1,10,16,18.3,10.2l254.5-178.8 C738,603.2,738.2,592.7,731.1,587.7z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="folder-open">
                  <path
                    d="M950,188H513c-13.8,0-25-11.2-25-25V50c0-27.6-22.4-50-50-50H50C22.5,0,0,22.5,0,50v325v125v450c0,27.5,22.5,50,50,50h900 c27.6,0,50-22.4,50-50V500V375V238C1000,210.4,977.6,188,950,188z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V500h750 V850z M125,375V150c0-13.8,11.2-25,25-25h150.7H338c13.8,0,25,11.2,25,25v112.5c0,29.2,19.7,50.5,49.9,50.5H850 c13.8,0,25,11.2,25,25v37H125z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="folder-uncategorized">
                  <path
                    d="M950.5,188H513c-13.8,0-25-11.2-25-25V50c0-27.6-22.4-50-50-50H50C22.5,0,0,22.5,0,50v899.6c0,27.7,22.7,50.4,50.4,50.4 H950c27.6,0,50-22.4,50-50V237.5C1000,210.2,977.8,188,950.5,188z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V475 V150c0-13.8,11.2-25,25-25h150.7H338c13.8,0,25,11.2,25,25v112.5c0,29.2,19.7,50.5,49.9,50.5H850c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M641,451c-5.1-13.5-13.4-26.1-25.2-37.9c-11.7-11.7-27.2-21.5-46.4-29.4c-19.2-7.9-43.2-11.8-71.9-11.8 c-22.2,0-42.3,3.8-60.3,11.3c-18,7.5-33.4,17.9-46.1,31.3c-12.7,13.3-22.6,29.2-29.7,47.4c-4.9,12.6-8.2,26.1-9.9,40.5 c-1.2,10.4,7.2,19.7,17.7,19.7H423c9,0,16.2-7.1,17.3-16c0.6-5.1,1.5-10.3,2.7-15.1c2.4-9.5,6.1-17.7,11.2-24.8 c5.1-7.1,11.5-12.7,19.4-17c7.9-4.2,17.3-6.4,28.2-6.4c16.2,0,28.8,4.5,37.9,13.4c9.1,8.9,13.6,22.7,13.6,41.2 c0.4,10.9-1.5,20-5.8,27.3c-4.2,7.3-9.8,13.9-16.7,20c-6.9,6.1-14.4,12.1-22.4,18.2c-8.1,6.1-15.8,13.2-23.1,21.5 c-7.3,8.3-13.7,18.3-19.2,30c-5.5,11.7-10.2,26.3-10.2,43.7v9.6c0,9.8,8.3,14.4,18.1,14.4h46.4c9.8,0,14.5-4.6,14.5-14.4v-5.3 c0-12.1,7.2-22.2,13.4-30.3c6.3-8.1,15.1-15.2,23.1-21.5c8.1-6.3,16.7-12.5,25.8-18.8c9.1-6.3,17.4-13.8,24.9-22.7 c7.5-8.9,13.7-19.6,18.8-32.1c5-12.5,7.6-28.5,7.6-47.9C648.6,477.2,646,464.5,641,451z"
                  ></path>
                  <circle cx="500" cy="766.4" r="48.8"></circle>
                </symbol>
                <symbol viewBox="0 0 875 1000" id="form-blank">
                  <path
                    d="M825,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h775c27.6,0,50-22.4,50-50V50C875,22.4,852.6,0,825,0z M750,850 c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h575c13.8,0,25,11.2,25,25V850z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1001 625.5" id="form-fields-2">
                  <path
                    d="M1001,63c0,34.5-28,62.5-62.5,62.5h-688c-34.5,0-62.5-28-62.5-62.5v0c0-34.5,28-62.5,62.5-62.5h688 C973,0.5,1001,28.5,1001,63L1001,63z"
                  ></path>
                  <circle cx="63.4" cy="62.5" r="62.5"></circle>
                  <path
                    d="M1000 313c0 34.5-28 62.5-62.5 62.5h-875C28 375.5 0 347.5 0 313v0c0-34.5 28-62.5 62.5-62.5h875C972 250.5 1000 278.5 1000 313L1000 313zM1001 563c0 34.5-28 62.5-62.5 62.5h-688c-34.5 0-62.5-28-62.5-62.5v0c0-34.5 28-62.5 62.5-62.5h688C973 500.5 1001 528.5 1001 563L1001 563zM125 600.5c0 13.8-11.2 25-25 25H25c-13.8 0-25-11.2-25-25v-75c0-13.8 11.2-25 25-25h75c13.8 0 25 11.2 25 25V600.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="form-share">
                  <path
                    d="M766.7,563c22.1,37.8,63.8,63.4,111.4,62.2c66.9-1.6,121-56.5,121.9-123.5 c0.9-69.8-55.4-126.4-125-126.4c-46.3,0-86.7,24.7-108.3,62.7H645V213c0-13.8,11.2-25,25-25h96.7c22.1,37.8,63.8,63.4,111.4,62.2 c66.9-1.6,121-56.5,121.9-123.5c0.9-69.8-55.4-126.4-125-126.4C828.7,0.3,788.3,25,766.7,63H569.5c-27.3,0-49.5,22.2-49.5,49.5v31 v44V438H400V270c0-27.6-22.4-50-50-50H50c-27.6,0-50,22.4-50,50v460c0,27.6,22.4,50,50,50h300c27.6,0,50-22.4,50-50V563h120v249.5 v44V888c0,27.6,22.4,50,50,50h196.7c22.1,37.8,63.8,63.4,111.4,62.2c66.9-1.6,121-56.5,121.9-123.5c0.9-69.8-55.4-126.4-125-126.4 c-46.3,0-86.7,24.7-108.3,62.7H670c-13.8,0-25-11.2-25-25V563H766.7z M275,630c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V370 c0-13.8,11.2-25,25-25h100c13.8,0,25,11.2,25,25V630z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 875 1000" id="forms">
                  <path
                    d="M675.5 500h-475c-6.9 0-12.5 5.6-12.5 12.5v100c0 6.9 5.6 12.5 12.5 12.5h475c6.9 0 12.5-5.6 12.5-12.5v-100C688 505.6 682.4 500 675.5 500zM675.5 688h-475c-6.9 0-12.5 5.6-12.5 12.5v100c0 6.9 5.6 12.5 12.5 12.5h475c6.9 0 12.5-5.6 12.5-12.5v-100C688 693.6 682.4 688 675.5 688z"
                  ></path>
                  <path
                    d="M825,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h775c27.6,0,50-22.4,50-50V50C875,22.4,852.6,0,825,0z M750,850 c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h575c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M675.5,188h-475c-6.9,0-12.5,5.6-12.5,12.5v225c0,6.9,5.6,12.5,12.5,12.5h475c6.9,0,12.5-5.6,12.5-12.5v-225 C688,193.6,682.4,188,675.5,188z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 50.7 48.2" id="formstack-logo">
                  <path
                    d="M43.9 6.1c.1-1.1-.6-1.9-1.6-1.8-1.4.1-1.6.1-2.8.2-1.3 13-1.3 26.2 0 39.2 1.2.1 1.4.1 2.8.2 1 .1 1.7-.8 1.6-1.8-1.7-14.4-1.7-21.7 0-36zm6.8 3.3c.1-.9-.5-1.6-1.4-1.6h-3.1c-1.4 12.6-1.4 19.9 0 32.5h3.1c.9 0 1.5-.7 1.4-1.6-1.3-11.6-1.3-17.6 0-29.3zM37.1 46.1c-1.7-14.6-1.7-29.4 0-43.9.1-1.3-.7-2.2-1.9-2.1C27.1.8 23 1.2 14.9 2c-1.2 3-2.5 6.4-3.5 9-.2.4-.4.8-.8 1.2-.4.3-.8.6-1.2.7-2.4.8-5.9 1.9-9.1 2.9-.5 10.8-.4 16.2.9 27 .1 1.1 1.2 2.1 2.4 2.2 12.7 1.3 19 1.9 31.7 3.2 1.1.1 2-.8 1.8-2.1zM5.4 41c-.3-3.4-.5-5.1-.6-8.5 5.4.2 8.1.3 13.4.5.2 3.6.3 5.4.7 9-5.4-.3-8.1-.5-13.5-1zM27 28.8c-9-.2-13.4-.3-22.4-.4-.1-3.4-.1-5.1 0-8.5l22.4-.5c-.1 3.8-.1 5.6 0 9.4zm4.6-14.3c-8.2.4-12.3.5-20.6.9.7 0 1.4-.3 1.9-.8.6-.5.9-1.2.9-1.9.2-2.5.3-3.7.5-6.2 7.2-.6 10.8-.9 18-1.4-.3 3.7-.5 5.6-.7 9.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1588 1000" id="group">
                  <path
                    d="M916.8 467.5c75.7-43 126.7-124.3 126.7-217.5 0-138.1-111.9-250-250-250s-250 111.9-250 250c0 93.4 51.2 174.8 127.1 217.7C510.1 519.7 394 670.5 394 848.3V950c0 27.6 22.4 50 50 50h25c27.6 0 50-22.4 50-50V848.3c0-37.2 7.3-73.2 21.6-107 13.8-32.7 33.7-62.2 59-87.5 25.3-25.3 54.7-45.1 87.5-59 33.8-14.3 69.8-21.6 107-21.6 37.2 0 73.2 7.3 107 21.6 32.7 13.8 62.2 33.7 87.5 59 25.3 25.3 45.1 54.7 59 87.5 14.3 33.8 21.6 69.8 21.6 107V950c0 27.6 22.4 50 50 50h25c27.6 0 50-22.4 50-50V848.3C1194 670.2 1077.6 519.3 916.8 467.5zM881.9 338.4c-23.6 23.6-55 36.6-88.4 36.6s-64.8-13-88.4-36.6c-23.6-23.6-36.6-55-36.6-88.4s13-64.8 36.6-88.4c23.6-23.6 55-36.6 88.4-36.6s64.8 13 88.4 36.6c23.6 23.6 36.6 55 36.6 88.4S905.5 314.8 881.9 338.4zM389.7 551.5c-16-9.4-33-17.1-50.9-22.9 48.9-27.9 81.9-80.5 81.9-140.8 0-89.5-72.5-162-162-162s-162 72.5-162 162c0 60.4 33.1 113.1 82.1 141C75 562.6 0 660.4 0 775.5V822c0 13.8 11.2 25 25 25h25c13.8 0 25-11.2 25-25v-46.5c0-49.2 19.1-95.5 53.8-130.3 34.8-34.8 81-54 130.2-54 32.8 0 64.3 8.5 92 24.5 11.7 6.8 26.7 3 33.8-8.5 4.4-7.1 9-14.3 13.1-20.7C405.6 574.7 402 558.6 389.7 551.5zM258.7 474.8c-48 0-87-39-87-87s39-87 87-87c48 0 87 39 87 87S306.7 474.8 258.7 474.8zM1408.8 528.6c48.9-27.9 81.9-80.5 81.9-140.8 0-89.5-72.5-162-162-162s-162 72.5-162 162c0 60.4 33.1 113.1 82.1 141-17.7 5.8-34.6 13.4-50.4 22.7-12.3 7.2-16 23.4-8.1 35.3 4.3 6.6 8.5 13.3 12.5 20 7 11.9 22.2 15.9 34.1 9 27.7-16 59.3-24.6 92.1-24.6 49.2 0 95.4 19.2 130.2 54 34.8 34.8 53.9 81.1 53.9 130.3V822c0 13.8 11.2 25 25 25h25c13.8 0 25-11.2 25-25v-46.5C1588 660.2 1512.8 562.4 1408.8 528.6zM1328.7 474.8c-48 0-87-39-87-87s39-87 87-87 87 39 87 87S1376.7 474.8 1328.7 474.8z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="healthcare">
                  <path
                    d="M949.6 1000h.4c27.6 0 50-22.4 50-50v-.4C1000 977.3 977.3 1000 949.6 1000zM0 949.6v.4c0 27.6 22.4 50 50 50h.4C22.7 1000 0 977.3 0 949.6z"
                  ></path>
                  <path
                    d="M950.5,188h-263V50c0-27.6-22.4-50-50-50h-275c-27.6,0-50,22.4-50,50v138h-263C22.2,188,0,210.2,0,237.5v712.1 c0,27.7,22.7,50.4,50.4,50.4h899.1c27.7,0,50.4-22.7,50.4-50.4V237.5C1000,210.2,977.8,188,950.5,188z M412.5,125 c0-13.8,11.2-25,25-25h125c13.8,0,25,11.2,25,25v63h-175V125z M875,850C875,850,875,850,875,850c0,13.7-11.1,24.9-24.7,25 c-0.1,0-0.2,0-0.3,0H150c-0.1,0-0.2,0-0.3,0c-13.6-0.1-24.7-11.3-24.7-25c0,0,0,0,0,0V338c0-13.8,11.2-25,25-25h700 c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M619.5,544.3H550v-69.6c0-26-24-47-50-47c-26,0-50,21-50,47v69.6h-69.6c-26,0-47,24-47,50c0,26,21,50,47,50H450v69.6 c0,26,23.3,47,49.2,47h2.2c26,0,48.5-21,48.5-47v-69.6h69.6c26,0,47-23.3,47-49.2v-2.2C666.5,566.8,645.5,544.3,619.5,544.3z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 871.4" id="heart">
                  <path
                    d="M734.8,0c68.1,0,136.1,25.8,187.8,77.5c103.3,103.3,103.3,272.3,0,375.6l-47,47L507.1,868.5c-3.9,3.9-10.2,3.9-14.1,0 L124.4,500l-47-47c-103.3-103.3-103.3-272.3,0-375.6C129.1,25.8,197.2,0,265.2,0S401.4,25.8,453,77.5l39.9,39.9 c3.9,3.9,10.2,3.9,14.1,0L547,77.5C598.6,25.8,666.7,0,734.8,0"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 871.4" id="heart-half-hollow">
                  <path
                    d="M922.5,77.5C870.9,25.8,802.8,0,734.8,0C666.7,0,598.6,25.8,547,77.5l-39.9,39.9c-3.9,3.9-10.2,3.9-14.1,0L453,77.5 C401.4,25.8,333.3,0,265.2,0S129.1,25.8,77.5,77.5C-25.8,180.7-25.8,349.7,77.5,453l47,47l368.5,368.5c3.9,3.9,10.2,3.9,14.1,0 L875.6,500l47-47C1025.8,349.7,1025.8,180.7,922.5,77.5z M869.5,400l-47,47L507.1,762.4c-2,2-4.5,2.9-7.1,2.9c0,0,0-523.4,0-529.1 c0-4.8,3-8.8,7.1-12.9l46-46l47-47C635.8,94.7,683.6,75,734.8,75c51.1,0,99,19.7,134.8,55.5S925,214.1,925,265.2 C925,316.4,905.3,364.2,869.5,400z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 871.4" id="heart-hollow">
                  <path
                    d="M734.8,75c51.1,0,99,19.7,134.8,55.5S925,214.1,925,265.2c0,51.1-19.7,99-55.5,134.8l-47,47L507.1,762.4 c-3.9,3.9-10.2,3.9-14.1,0L177.5,447l-47-47C94.7,364.2,75,316.4,75,265.2c0-51.1,19.7-99,55.5-134.8C166.3,94.7,214.1,75,265.2,75 s99,19.7,134.8,55.5l47,47l46,46c3.9,3.9,10.2,3.9,14.1,0l46-46l47-47C635.8,94.7,683.6,75,734.8,75 M734.8,0 C666.7,0,598.6,25.8,547,77.5l-39.9,39.9c-3.9,3.9-10.2,3.9-14.1,0L453,77.5C401.4,25.8,333.3,0,265.2,0S129.1,25.8,77.5,77.5 C-25.8,180.7-25.8,349.7,77.5,453l47,47l368.5,368.5c3.9,3.9,10.2,3.9,14.1,0L875.6,500l47-47c103.3-103.3,103.3-272.3,0-375.6 C870.9,25.8,802.8,0,734.8,0L734.8,0z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="help-circle">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M698.8,420.1 c-7.1,17.7-16,32.8-26.5,45.3c-10.6,12.6-22.2,23.2-35.1,32.1c-12.8,8.8-24.9,17.7-36.3,26.5c-11.4,8.8-23.5,18.9-32.3,30.3 c-8.8,11.4-18.6,25.6-18.6,42.8v7.5c0,13.8-7.3,20.5-21.1,20.5h-65.4c-13.8,0-25.5-6.7-25.5-20.5v-13.5c0-24.5,6.7-45,14.4-61.6 c7.7-16.5,16.8-30.6,27-42.3c10.3-11.7,21.1-21.8,32.5-30.4c11.4-8.5,21.9-17.1,31.7-25.6c9.7-8.6,17.5-18,23.5-28.2 c6-10.3,8.7-23.1,8.1-38.5c0-26.2-6.4-45.6-19.2-58.1c-12.8-12.5-30.6-18.8-53.4-18.8c-15.4,0-28.6,3-39.7,9 c-11.1,6-20.2,14-27.4,24c-7.1,10-12.4,21.6-15.8,35c-1.7,6.7-3,14.3-3.9,21.5c-1.5,12.6-11.7,23-24.4,23h-75.8 c-14.8,0-26.7-13.5-24.9-28.2c2.4-20.3,7-39.7,14-57.5c10-25.6,23.9-48,41.9-66.9c18-18.8,39.6-33.6,65-44.1 c25.4-10.5,53.7-15.9,85.1-15.9c40.5,0,74.2,5.5,101.3,16.6c27.1,11.1,48.8,24.9,65.4,41.5c16.5,16.6,28.4,34.3,35.5,53.4 c7.1,19.1,10.7,36.9,10.7,53.4C709.5,379.9,705.9,402.4,698.8,420.1z M562.4,743.8c0,38-30.8,68.8-68.7,68.8s-68.8-30.8-68.8-68.8 s30.8-68.8,68.8-68.8S562.4,705.8,562.4,743.8z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="help-hollow">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M500,937.5 C258.8,937.5,62.5,741.2,62.5,500S258.8,62.5,500,62.5S937.5,258.8,937.5,500S741.2,937.5,500,937.5z"
                  ></path>
                  <path
                    d="M663.3,245.6c-16.6-16.5-38.3-30.3-65.4-41.5c-27.1-11.1-60.8-16.6-101.3-16.6c-31.3,0-59.7,5.3-85.1,15.9 c-25.4,10.5-47,25.3-65,44.1c-18,18.8-31.9,41.2-41.9,66.9c-6.9,17.8-11.6,37.2-14,57.5c-1.7,14.7,10.1,28.2,24.9,28.2h75.8 c12.7,0,22.9-10.4,24.4-23c0.9-7.2,2.1-14.8,3.9-21.5c3.4-13.4,8.7-25.1,15.8-35c7.1-10,16.2-18,27.4-24c11.1-6,24.4-9,39.7-9 c22.8,0,40.6,6.3,53.4,18.8c12.8,12.6,19.2,31.9,19.2,58.1c0.6,15.4-2.1,28.2-8.1,38.5c-6,10.3-13.9,19.7-23.5,28.2 c-9.7,8.6-20.3,17.1-31.7,25.6c-11.4,8.6-22.3,18.7-32.5,30.4c-10.3,11.7-19.4,25.8-27,42.3c-7.7,16.6-14.4,37.1-14.4,61.6v13.5 c0,13.8,11.6,20.5,25.5,20.5h65.4c13.8,0,21.1-6.7,21.1-20.5V597c0-17.1,9.8-31.3,18.6-42.8c8.8-11.4,20.9-21.5,32.3-30.3 c11.4-8.8,23.5-17.7,36.3-26.5c12.8-8.8,24.5-19.5,35.1-32.1c10.5-12.5,19.4-27.6,26.5-45.3c7.1-17.7,10.7-40.2,10.7-67.6 c0-16.5-3.6-34.3-10.7-53.4C691.7,280,679.9,262.2,663.3,245.6z"
                  ></path>
                  <circle cx="500" cy="743.8" r="68.8"></circle>
                </symbol>
                <symbol viewBox="0 0 1000 996" id="hide">
                  <path
                    d="M982.5 29.6l-14.3-14.3C958 5.1 944.6 0 931.2 0c-13.4 0-26.8 5.1-37 15.3l-877 877c-20.5 20.5-20.5 53.6 0 74.1l14.3 14.3c10.2 10.2 23.6 15.3 37 15.3 13.4 0 26.8-5.1 37-15.3l877-877C1003 83.3 1003 50.1 982.5 29.6zM333.3 427.4c-7.6 18-12.2 36.9-13.6 56.4l166.3-166.3c-19.4 1.5-38.3 6-56.4 13.6-21.6 9.1-41 22.1-57.6 38.7S342.4 405.8 333.3 427.4zM627.7 625.6c16.6-16.6 29.6-36 38.7-57.6 7.5-17.8 12.1-36.5 13.6-55.7L514.5 677.9c19.2-1.5 37.9-6.1 55.7-13.6C591.8 655.2 611.1 642.2 627.7 625.6z"
                  ></path>
                  <path
                    d="M964.5 440.1c-26-46.1-54.9-88.5-86-126.3L789.4 403c23.4 29.6 45.5 62.6 65.9 98.8-95.9 163.7-226.9 260.7-356.1 260.7-20.5 0-41.2-2.6-61.8-7.5l-98.8 98.8c52.9 22.5 107.2 34.1 160.7 34.1 46.6 0 93.6-8.5 139.7-25.3 42.9-15.7 85-38.5 125.1-68 38-27.9 74.4-61.9 108.2-101 33-38.1 63.7-81.3 91.3-128.4l36.5-62.3L964.5 440.1zM118.8 684.6l89.1-89.1c-24-29.8-46.2-62.9-65.9-99C225.8 333.5 360.2 233 499.2 233c21.1 0 42.3 2.7 63.4 7.9l98.5-98.5c-7-3-14-5.9-21.1-8.5-46.4-17.4-93.8-26.3-140.8-26.3-95.1 0-189.8 32.9-273.9 95.3-39 28.9-75.6 64-108.6 104.2-32.4 39.5-61.5 84-86.2 132.2L0 498.4l32 58.4C57.4 603.2 86.6 646.1 118.8 684.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="hollow">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M500,937.5 C258.8,937.5,62.5,741.2,62.5,500S258.8,62.5,500,62.5S937.5,258.8,937.5,500S741.2,937.5,500,937.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="hollow-thick">
                  <path
                    d="M500,0C225,0,0,225,0,500s225,500,500,500s500-225,500-500S775,0,500,0z M500,875c-205,0-375-170-375-375s170-375,375-375 s375,170,375,375S705,875,500,875z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="hr">
                  <path
                    d="M950,675h-50V50c0-27.6-22.4-50-50-50H150c-27.6,0-50,22.4-50,50v625H50c-27.6,0-50,22.4-50,50v225c0,27.6,22.4,50,50,50 h900c27.6,0,50-22.4,50-50V725C1000,697.4,977.6,675,950,675z M687.1,691.7c-27.7,77.4-101,133.4-187.5,133.4 c-87.2,0-160.6-55.9-187.6-133.2c-3.5-10.1-13-16.9-23.6-16.9H175V100c0-13.8,11.2-25,25-25h600c13.8,0,25,11.2,25,25v575H710.7 C700.1,675,690.7,681.7,687.1,691.7z"
                  ></path>
                  <path
                    d="M564.8,368.8c39.4-22.4,65.9-64.8,65.9-113.3c0-71.9-60-131.2-131.9-130.4c-71.3,0.8-128.9,58.9-128.9,130.4 c0,48.6,26.6,91,66.1,113.4c-0.1,0-0.3,0.1-0.4,0.1l-0.3-0.2C351.5,396,291,474.7,291,567.5v37.4c0,11.1,9,20.1,20.1,20.1h377.7 c11.1,0,20.1-9,20.1-20.1v-37.4C709,474.7,648.5,396,564.8,368.8z M430.4,260c-2.7-42.2,32.2-77.2,74.5-74.5 c34.9,2.2,63.1,30.4,65.3,65.3c2.7,42.2-32.2,77.2-74.5,74.5C460.8,323.1,432.6,294.9,430.4,260z M351.4,565.1 c0.6-38.7,15.9-75,43.3-102.4c8.5-8.5,17.9-15.9,27.9-22c1.3-0.4,2.6-1,3.8-1.7c22.3-12.9,47.7-19.8,74.2-19.8 c39.6,0,76.8,15.4,104.8,43.4c27.4,27.4,42.7,63.7,43.3,102.4H351.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="id">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M160,775V499.6 c0-34.2,5.1-68,15.1-100.3c4.1-13.2-3.3-27.2-16.5-31.3c-13.2-4.1-27.2,3.3-31.3,16.5c-11.5,37.1-17.3,75.8-17.3,115.1v198.5 C79.6,638.6,62.5,571.3,62.5,500C62.5,258.8,258.8,62.5,500,62.5S937.5,258.8,937.5,500c0,34.3-4,67.6-11.5,99.7 c-3.6-5.5-7.1-11.5-10.4-18.1c-18.7-37.4-24.5-78.2-25.7-88.5c-0.8-50.2-11.1-99.1-30.7-145.3c-19.7-46.5-47.7-88.2-83.5-123.9 c-35.7-35.7-77.4-63.8-123.9-83.5c-48.2-20.4-99.3-30.7-151.9-30.7c-52.6,0-103.7,10.3-151.9,30.7c-46.5,19.7-88.2,47.7-123.9,83.5 c-21.5,21.5-40.4,45.4-56.2,71c-7.2,11.8-3.6,27.2,8.2,34.4c11.8,7.2,27.2,3.6,34.4-8.2c13.8-22.3,30.3-43.2,49-61.9 c31.2-31.2,67.5-55.7,108-72.8c42-17.8,86.6-26.8,132.4-26.8c45.8,0,90.4,9,132.4,26.8c40.5,17.1,76.9,41.6,108,72.8 c31.2,31.2,55.7,67.5,72.8,108c17.2,40.6,26.2,83.6,26.8,127.8l0,1.2l0.1,1.2c1.5,13.5,8,61.2,30.8,106.6 c10.7,21.4,23.4,38.9,37.8,52.2c-6.2,16.2-13.4,32-21.4,47.3c-14.9-11.5-28.4-25.7-40.4-42.5c-14.6-20.6-27-45.1-36.8-72.8 c-15.8-44.9-19.6-84-20.1-89.6c-0.1-38.7-7.8-76.4-22.8-111.9c-14.6-34.5-35.5-65.6-62.1-92.1c-21.3-21.3-45.6-39-72.1-52.7 c-12.3-6.3-27.3-1.5-33.7,10.8c-6.3,12.3-1.5,27.3,10.8,33.7c22,11.3,42.1,26,59.7,43.6c22,22,39.3,47.7,51.4,76.3 c12.5,29.6,18.9,61.1,18.9,93.4v0.9l0.1,0.9c0.1,1.9,3.4,47.7,22.4,102.2c11.3,32.4,25.8,61.2,43.2,85.8 c16.1,22.8,34.8,42,55.6,57.2c-10.3,15-21.4,29.3-33.4,42.9c-25.4-17.9-47.8-40.3-66.8-67c-20.4-28.8-36.9-62.7-49.2-100.7 C691,556.6,690,501.3,690,499.5c-0.1-104.7-85.3-189.9-190-189.9c-104.8,0-190,85.2-190,190V894c-17.3-8.4-34-17.9-50-28.4v-366 c0-32.4,6.4-63.8,18.9-93.4c12.1-28.6,29.4-54.2,51.4-76.3c22-22,47.7-39.3,76.3-51.4c29.6-12.5,61.1-18.9,93.4-18.9 c10.6,0,21.2,0.7,31.5,2c13.7,1.8,26.2-7.9,28-21.5c1.8-13.7-7.9-26.2-21.5-28c-12.5-1.6-25.3-2.5-38-2.5 c-39.1,0-77.1,7.7-112.9,22.8c-34.6,14.6-65.6,35.5-92.1,62.1c-26.6,26.6-47.5,57.6-62.1,92.1c-15.2,35.8-22.8,73.8-22.8,112.9 v327.6C191.9,811.3,175.2,793.8,160,775z M360,914.5V499.6c0-77.2,62.8-140,140-140c77.2,0,140,62.8,140,140l0,0.2 c0,2.5,0.7,62.8,23.9,135.6c13.7,43.1,32.5,81.8,55.9,115c20.7,29.4,45,54.4,72.5,74.9c-13.5,12.2-27.8,23.5-42.8,34 c-29.8-22-55.2-50.5-75.8-85c-7.1-11.9-22.4-15.8-34.3-8.7c-11.9,7.1-15.8,22.4-8.7,34.3c20.3,34.1,44.8,63.3,73.2,87.2 c-60.9,32.2-130.3,50.5-203.9,50.5C451.1,937.5,404,929.4,360,914.5z"
                  ></path>
                  <path
                    d="M500,413.5c-49.8,0-90.3,40.5-90.3,90.3v328c0,49.8,40.5,90.3,90.3,90.3s90.3-40.5,90.3-90.3v-328 C590.3,454,549.8,413.5,500,413.5z M540.3,831.9c0,22.2-18.1,40.3-40.3,40.3c-22.2,0-40.3-18.1-40.3-40.3v-328 c0-22.2,18.1-40.3,40.3-40.3c22.2,0,40.3,18.1,40.3,40.3V831.9z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="image">
                  <circle cx="312.5" cy="314.3" r="93.5"></circle>
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50 V50C1000,22.4,977.6,0,950,0z M875,850c0,13.8-11.2,25-25,25h-70.8L596.5,378.1c-8-21.8-38.9-21.8-46.9,0L366.8,875H150 c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h700c13.8,0,25,11.2,25,25V850z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="import">
                  <path
                    d="M12.5,575h400c6.9,0,12.5,5.6,12.5,12.5v91.2c0,10.1,10.2,16,18.5,10.2l254.6-178.8c7.1-5,7.5-15.5,0.3-20.5L443.3,311 c-8.3-5.8-18.3,0.1-18.3,10.2v91.2c0,6.9-5.6,12.5-12.5,12.5h-400C5.6,425,0,430.6,0,437.5v125C0,569.4,5.6,575,12.5,575z"
                  ></path>
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v238c0,13.8,11.2,25,25,25h75c13.8,0,25-11.2,25-25V150c0-13.8,11.2-25,25-25h700 c13.8,0,25,11.2,25,25v700c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V713c0-13.8-11.2-25-25-25H25c-13.8,0-25,11.2-25,25v237 c0,27.5,22.5,50,50,50h900c27.6,0,50-22.4,50-50V50C1000,22.4,977.6,0,950,0z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 675.9" id="increasing">
                  <path
                    d="M999.9,348.9L965.3,12.5c-1-9.4-10.8-15.2-19.3-11.1L641.3,148.9c-9.9,4.8-9.7,17.6-0.1,23L761,238.8L659,421L547.6,283.9 c-11.8-14.5-30-22.2-48.6-20.6c-18.6,1.6-35.2,12.4-44.3,28.7L327.1,521.3L217.8,392.6c-11.1-13.1-27.6-20.4-44.7-19.8 c-17.2,0.6-33.1,8.9-43.3,22.7l-118.7,160c-18.5,25-13.3,60.2,11.7,78.7c25,18.5,60.2,13.3,78.7-11.7l76.5-103.1l116,136.6 c10.7,12.7,26.5,19.8,42.9,19.8c1.8,0,3.7-0.1,5.5-0.3c18.4-1.8,34.7-12.5,43.6-28.6l126.8-227.7l111.2,136.9 c11.8,14.5,29.9,22.2,48.5,20.6c18.6-1.6,35.1-12.3,44.3-28.6l142.6-254.6l121.1,67.6C989.9,366.6,1001,359.9,999.9,348.9z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 803.8" id="info-bubble">
                  <path
                    d="M499.7 237.2c23 0 41.5-18.5 41.5-41.5 0-23-18.5-41.5-41.5-41.5s-41.5 18.5-41.5 41.5C458.2 218.7 476.7 237.2 499.7 237.2zM500 275L500 275c-24.3 0-44 19.7-44 44v125c0 24.3 19.7 44 44 44h0c24.3 0 44-19.7 44-44V319C544 294.7 524.3 275 500 275z"
                  ></path>
                  <path
                    d="M695.6,0H305.3H305C136.9,0,0,136.2,0,303.4v27.9C0,462.1,82.2,574,197.2,617.8l-1.2,16.9l-11.7,155.5 c-0.6,7.7,5.7,13.6,12.6,13.6c1.6,0,3.3-0.3,4.9-1c0.5-0.2,1-0.5,1.4-0.8L462,638h233.6c168.1,0,304.4-137.8,304.4-306.7v-27.9 C1000,136.2,863.7,0,695.6,0z M925,331.3C925,459.1,822.1,563,695.6,563H462h-21.8l-18.4,11.6l-132.4,83.9 c-8.7,5.5-19.9-1.2-19.2-11.5l0.5-6.7l0-0.2l0-0.2L272,623l3.8-55.4l-51.9-19.8c-21.5-8.2-41.6-19.6-59.8-33.9 c-18.1-14.2-34-31-47.2-49.8C89.5,425,75,379.1,75,331.3v-27.9c0-30.7,6.1-60.5,18-88.6c11.6-27.2,28.2-51.7,49.4-72.7 c21.2-21.1,45.8-37.6,73.2-49.2C243.9,81.1,274,75,305,75h0.2h390.5C822.3,75,925,177.5,925,303.4V331.3z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="info-circle">
                  <path
                    d="M500.3,1000c276.1,0,499.7-223.6,499.7-499.7S776.4,0,500.3,0S0,223.6,0,500.3C0,776.4,223.6,1000,500.3,1000z M499.7,225 c41.6,0,75,33.4,75,75s-33.4,75-75,75s-75-33.4-75-75S458.1,225,499.7,225z M575,738c0,41.4-33.6,75-75,75h0c-41.4,0-75-33.6-75-75 V513c0-41.4,33.6-75,75-75h0c41.4,0,75,33.6,75,75V738z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="info-circle-hollow">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M500,937.5 C258.8,937.5,62.5,741.2,62.5,500S258.8,62.5,500,62.5S937.5,258.8,937.5,500S741.2,937.5,500,937.5z"
                  ></path>
                  <path
                    d="M499.7 225c41.6 0 75 33.4 75 75s-33.4 75-75 75-75-33.4-75-75S458.1 225 499.7 225zM575 738c0 41.4-33.6 75-75 75h0c-41.4 0-75-33.6-75-75V513c0-41.4 33.6-75 75-75h0c41.4 0 75 33.6 75 75V738z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="info-hollow">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M500,937.5 C258.8,937.5,62.5,741.2,62.5,500S258.8,62.5,500,62.5S937.5,258.8,937.5,500S741.2,937.5,500,937.5z"
                  ></path>
                  <path
                    d="M500.3 775c-41.6 0-75-33.4-75-75s33.4-75 75-75 75 33.4 75 75S541.9 775 500.3 775zM574 488c0 41.4-33.6 75-75 75h0c-41.4 0-75-33.6-75-75V263c0-41.4 33.6-75 75-75h0c41.4 0 75 33.6 75 75V488z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 875.1" id="it">
                  <path
                    d="M312.3,311.8l16.6,6.9c4.1,1.7,6.7,6,6.1,10.4c-1.8,13.8-1.8,28,0,42.2c0.6,4.5-1.9,8.8-6.1,10.5l-16.4,6.8 c-10.2,4.2-15,15.9-10.8,26.1l12.6,30.3c4.2,10.2,15.9,15,26.1,10.8l16.5-6.8c4.1-1.7,8.9-0.5,11.7,3.1 c8.7,11.1,18.7,21.1,29.7,29.6c3.6,2.8,4.8,7.6,3.1,11.7l-6.8,16.4c-4.2,10.2,0.6,21.9,10.8,26.1l30.3,12.5 c10.2,4.2,21.9-0.6,26.1-10.9l6.7-16.4c1.7-4.1,6-6.7,10.4-6.1c13.8,1.8,28.1,1.8,42.1,0c4.4-0.6,8.7,2,10.4,6.1l6.8,16.5 c4.2,10.2,15.9,15,26.1,10.8l30.3-12.6c10.2-4.2,15-15.9,10.8-26.1l-6.8-16.4c-1.7-4.2-0.5-9,3.1-11.7 c11.4-8.8,21.3-18.8,29.8-29.9c2.7-3.5,7.5-4.8,11.7-3.1l16.5,6.8c10.2,4.2,21.9-0.6,26.1-10.8l12.6-30.4 c4.2-10.2-0.6-21.9-10.9-26.1l-16.4-6.7c-4.1-1.7-6.7-6-6.1-10.4c1.8-13.9,1.8-28.1,0-42.1c-0.6-4.4,2-8.7,6.1-10.4l16.5-6.8 c10.2-4.2,15-15.9,10.8-26.1l-12.6-30.3c-4.2-10.2-15.9-15-26.1-10.8l-16.4,6.8c-4.2,1.7-9,0.5-11.7-3.1 c-8.8-11.4-18.8-21.3-29.9-29.8c-3.5-2.7-4.8-7.5-3.1-11.7l6.8-16.5c4.2-10.2-0.6-21.9-10.8-26.1l-30.4-12.6 c-10.2-4.2-21.9,0.6-26.1,10.8l-6.9,16.6c-1.7,4.1-6,6.7-10.4,6.1c-13.8-1.8-28-1.8-42.2,0c-4.5,0.6-8.8-1.9-10.5-6.1l-6.8-16.4 c-4.2-10.2-15.9-15-26.1-10.8L405,164.2c-10.2,4.2-15,15.9-10.8,26.1l6.8,16.5c1.7,4.1,0.5,8.9-3.1,11.7 c-11.1,8.7-21.1,18.7-29.6,29.7c-2.8,3.6-7.6,4.8-11.7,3.1l-16.4-6.8c-10.2-4.2-21.9,0.6-26.1,10.8l-12.5,30.3 C297.3,295.9,302.1,307.6,312.3,311.8z M416.8,348.4c0.8-44.5,37.1-80.8,81.6-81.6c47.2-0.9,85.6,37.6,84.7,84.8 c-0.8,44.5-37.1,80.8-81.6,81.6C454.4,434,416,395.6,416.8,348.4z"
                  ></path>
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v600c0,27.6,22.4,50,50,50h350v75.1c0,13.8-11.2,25-25,25h-50c-13.8,0-25,11.2-25,25v25 c0,13.8,11.2,25,25,25h350c13.8,0,25-11.2,25-25v-25c0-13.8-11.2-25-25-25h-50c-13.8,0-25-11.2-25-25V700h350c27.6,0,50-22.4,50-50 V50C1000,22.4,977.6,0,950,0z M925,625H75V75h850V625z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 929.7" id="lead-gen">
                  <path
                    d="M577.3 594.4c47.6-27.1 79.8-78.3 79.8-137 0-86.9-70.5-157.4-157.4-157.4s-157.4 70.5-157.4 157.4c0 58.8 32.2 110.1 80 137.1-101.1 32.8-174.2 127.7-174.2 239.7v64c0 17.4 14.1 31.5 31.5 31.5h15.7c17.4 0 31.5-14.1 31.5-31.5v-64c0-23.4 4.6-46.1 13.6-67.4 8.7-20.6 21.2-39.1 37.1-55.1 15.9-15.9 34.5-28.4 55.1-37.1 21.3-9 44-13.6 67.4-13.6 23.4 0 46.1 4.6 67.4 13.6 20.6 8.7 39.1 21.2 55.1 37.1s28.4 34.5 37.1 55.1c9 21.3 13.6 44 13.6 67.4v64c0 17.4 14.1 31.5 31.5 31.5h15.7c17.4 0 31.5-14.1 31.5-31.5v-64C751.9 722.1 678.6 627.1 577.3 594.4zM555.3 513.1c-14.9 14.9-34.6 23.1-55.7 23.1-21 0-40.8-8.2-55.7-23.1-14.9-14.9-23.1-34.6-23.1-55.7 0-21 8.2-40.8 23.1-55.7 14.9-14.9 34.6-23.1 55.7-23.1 21 0 40.8 8.2 55.7 23.1 14.9 14.9 23.1 34.6 23.1 55.7C578.4 478.5 570.2 498.2 555.3 513.1zM245.4 647.3c-10.1-5.9-20.8-10.7-32.1-14.4 30.8-17.6 51.6-50.7 51.6-88.7 0-56.3-45.7-102-102-102-56.3 0-102 45.7-102 102 0 38.1 20.8 71.2 51.7 88.8C47.2 654.3 0 715.9 0 788.3v29.3c0 8.7 7 15.7 15.7 15.7h15.7c8.7 0 15.7-7 15.7-15.7v-29.3c0-31 12-60.1 33.9-82 21.9-21.9 51-34 82-34 20.7 0 40.5 5.4 57.9 15.4 7.4 4.3 16.8 1.9 21.3-5.4 2.8-4.5 5.7-9 8.3-13.1C255.4 661.9 253.1 651.8 245.4 647.3zM162.9 599c-30.2 0-54.8-24.6-54.8-54.8s24.6-54.8 54.8-54.8c30.2 0 54.8 24.6 54.8 54.8S193.1 599 162.9 599zM887.2 632.9c30.8-17.6 51.6-50.7 51.6-88.7 0-56.3-45.7-102-102-102s-102 45.7-102 102c0 38 20.8 71.2 51.7 88.8-11.2 3.6-21.8 8.5-31.8 14.3-7.8 4.6-10.1 14.7-5.1 22.2 2.7 4.1 5.4 8.4 7.9 12.6 4.4 7.5 14 10 21.5 5.7 17.4-10.1 37.3-15.5 58-15.5 31 0 60.1 12.1 82 34 21.9 21.9 33.9 51.1 33.9 82v29.3c0 8.7 7 15.7 15.7 15.7h15.7c8.7 0 15.7-7 15.7-15.7v-29.3C1000 715.8 952.7 654.1 887.2 632.9zM836.7 599c-30.2 0-54.8-24.6-54.8-54.8s24.6-54.8 54.8-54.8 54.8 24.6 54.8 54.8S866.9 599 836.7 599zM354 104.5C400.3 84.9 449.4 75 500 75s99.7 9.9 146 29.5c33.3 14.1 64.1 32.8 91.9 55.6 9.9 8.1 24.4 7.4 33.5-1.7l17.8-17.8c10.4-10.4 9.7-27.5-1.6-36.8C753.6 75.6 716 52.7 675.2 35.4 619.6 11.9 560.7 0 500 0S380.4 11.9 324.8 35.4c-40.8 17.3-78.4 40.2-112.3 68.4-11.3 9.4-12 26.5-1.6 36.8l17.8 17.8c9.1 9.1 23.6 9.9 33.5 1.7C289.9 137.2 320.7 118.6 354 104.5z"
                  ></path>
                  <path
                    d="M317.6,247.4l17.9,17.9c8.7,8.7,22.4,9.8,32.3,2.6C406,240,451.8,225,500,225c48.2,0,94,15,132.2,42.9 c9.9,7.2,23.6,6.1,32.3-2.6l17.9-17.9c10.8-10.8,9.4-28.6-2.8-37.7C628,170.9,565.6,150,500,150s-128,20.9-179.6,59.6 C308.2,218.8,306.9,236.6,317.6,247.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="leads">
                  <path
                    d="M500,250c-140,0-250,110-250,250s110,250,250,250s250-110,250-250S640,250,500,250z M500,625c-70,0-125-55-125-125 s55-125,125-125s125,55,125,125S570,625,500,625z"
                  ></path>
                  <path
                    d="M500,0C225,0,0,225,0,500s225,500,500,500s500-225,500-500S775,0,500,0z M500,875c-205,0-375-170-375-375s170-375,375-375 s375,170,375,375S705,875,500,875z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 976.4" id="learn">
                  <path
                    d="M938.2,2L499.1,113.4L59.7,2C26.7-6.9,0,14.7,0,50.1v686.1c0,35.4,26.8,73.4,59.7,87.3l382.4,144.3 c32.9,11.4,86.1,11.4,116.5,0l382.1-144.3c32.9-11.4,59.3-51.9,59.3-87.3V50.1C999,14.7,971.1-6.9,938.2,2z M438,831.1l-313-119 V147.6L438,226V831.1z M875,712.1L563,828.6V227.3l312-79.7v565.6l0,0V712.1z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 998.3 1000" id="link">
                  <path
                    d="M942.6,55.4C905.6,18.5,857.6,0,809.7,0s-95.9,18.5-132.9,55.4L554.9,179.3c-57.4,57.4-70.2,141.2-38.6,210.4L389.6,516.5 c-24.8-11.3-51.6-17-78.2-17c-48.2,0-96.1,18.5-132.1,55.4L55.4,678.8c-73.9,73.9-73.9,191.8,0,265.7c37,37,84.9,55.4,132.9,55.4 c48,0,95.9-18.5,132.9-55.4l123.9-123.9c58.6-58.6,70.7-144.7,36.5-214.7L606,481.6c25.8,12.6,53.8,18.9,81.9,18.9 c48,0,95.9-18.5,132.9-55.4l123.9-123.9C1016.5,247.3,1016.5,127.4,942.6,55.4z M232.8,856.2c-12.1,12.1-27.9,18.8-44.5,18.8 s-32.3-6.7-44.5-18.8S125,828.2,125,811.7c0-16.5,6.7-32.3,18.8-44.5l123.9-123.9l0.6-0.6l0.6-0.6c5.1-5.2,10.5-8.9,15.8-11.5 c-11.6,23.4-7.7,52.5,11.8,72l0,0c19.8,19.8,49.6,23.5,73.2,11.2c-2.8,6-6.9,12.4-13,18.5L232.8,856.2z M855.4,233.6L732.3,356.7 c-5.6,5.6-12.1,10.1-19,13.3c12-23.5,8.1-52.9-11.5-72.6l0,0c-19.2-19.2-47.7-23.3-70.9-12.3c3.1-6.3,7.3-12.2,12.5-17.3l0.4-0.4 l0.4-0.4l121.4-123.4c12.1-12,27.8-18.6,44.2-18.6c16.5,0,32.3,6.7,44.5,18.8l0.6,0.6l0.6,0.6c15.4,15,17.8,33.5,17.9,43.2 C873.3,198.1,871,217.2,855.4,233.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 750 1000" id="lock-closed">
                  <path
                    d="M688,375v-62.2C688,140.8,547.2,0,375.2,0h-0.1C203.4,0,63,140.4,63,312.1V375H50c-27.5,0-50,22.5-50,50v525 c0,27.6,22.4,50,50,50h650c27.6,0,50-22.4,50-50V425c0-27.6-22.4-50-50-50H688z M188,312.5c0-106.8,89.8-193,197.8-187.2 c99.7,5.4,177.2,88.9,177.2,188.7V375H188V312.5z M600,875H150c-13.8,0-25-11.2-25-25V525c0-13.8,11.2-25,25-25h450 c13.8,0,25,11.2,25,25v325C625,863.8,613.8,875,600,875z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 750 1000" id="lock-open">
                  <path
                    d="M669.1,206 M608.6,230.5c35.8-14.5,49.1-56.8,28.6-88.2C581.3,56.8,484.7,0,375.4,0h-0.2C203.5,0,63,140.5,63,312.2V375H50 c-27.5,0-50,22.5-50,50v525c0,27.6,22.4,50,50,50h650c27.6,0,50-22.4,50-50V425c0-27.6-22.4-50-50-50H188v-62.5 c0-106.5,89.3-192.6,196.9-187.3c60.9,3,113.2,36,145.1,83.8c16,24.1,46,34.6,72.9,23.8L608.6,230.5z M600,875H150 c-13.8,0-25-11.2-25-25V525c0-13.8,11.2-25,25-25h450c13.8,0,25,11.2,25,25v325C625,863.8,613.8,875,600,875z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1001.3 860.2" id="logic">
                  <path
                    d="M996,659.2L740.5,480c-8.3-5.8-19.7,0.1-19.7,10.2l-0.2,115.2c-23.4-2.1-47.2-7.2-75-23.1c-45.5-26.1-92.7-77.1-140.7-152 c48-74.8,95.2-125.9,140.7-152c27.8-15.9,51.6-21,75-23.1l0.2,114.7c0,10.1,11.4,16,19.7,10.2L996,201c7.1-5,7.1-15.5,0-20.5 L739.8,2.3c-8.3-5.8-19.7,0.2-19.6,10.3l0.2,117.4c-36.1,2.4-83.7,9.5-136.9,40c-55,31.5-107.3,82.8-158.9,155.9 c-23.3-21.2-49.8-39.7-79.3-55.4c-47.1-24.9-101.5-45.1-163-51.6c-72.9-7.7-152.1-7-152.1-7h-6.4c-1.8,0-3.5-0.3-5.2,0.1 c-0.2,0-0.9-0.2-1.1-0.2C7.7,214.3,0,222.8,0,233.4v42.8v36.7c0,8.5,5.1,15.8,12,19.7c0.1,0.1,0.4,0.2,0.5,0.3 c3.3,1.8,7.1,2.9,11.1,2.9c0,0,57.5-1.2,80.7-0.1c76.4,4.2,181.5,24.1,248.3,94.7c-66.7,70.6-171.8,90.4-248.2,94.7 c-23.2,1-80.6-0.1-80.6-0.1c-4,0-7.7,1.1-11,2.9c-0.1,0.1-0.7,0.2-0.8,0.3C5.1,532,0,539.4,0,547.8v36.7v42.8 c0,10.6,7.7,19.4,17.5,21.9c0.2,0,0.6,0.5,0.8,0.5c1.7,0.4,3.7,1.1,5.5,1.1h6.4c0,0,79.2-0.4,152.1-8c61.4-6.5,115.8-27.5,163-52.4 c29.6-15.6,56.1-34.3,79.4-55.5c51.6,73.1,103.9,124.3,158.9,155.9c53.2,30.5,100.8,37.6,136.9,40l-0.2,116.8 c0,10.1,11.3,16,19.6,10.3L996,679.7C1003.1,674.7,1003.1,664.2,996,659.2z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="long-answer">
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50 V50C1000,22.4,977.6,0,950,0z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h700 c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M775 625H225c-13.8 0-25 11.2-25 25v75c0 13.8 11.2 25 25 25h550c13.8 0 25-11.2 25-25v-75C800 636.2 788.8 625 775 625zM800 463c0-13.8-11.2-25-25-25H225c-13.8 0-25 11.2-25 25v75c0 13.8 11.2 25 25 25h550c13.8 0 25-11.2 25-25V463zM775 250H225c-13.8 0-25 11.2-25 25v75c0 13.8 11.2 25 25 25h550c13.8 0 25-11.2 25-25v-75C800 261.2 788.8 250 775 250z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1125" id="mark-as">
                  <path
                    d="M813 637.5c0-6.9-5.6-12.5-12.5-12.5h-475c-6.9 0-12.5 5.6-12.5 12.5v100c0 6.9 5.6 12.5 12.5 12.5h475c6.9 0 12.5-5.6 12.5-12.5V637.5zM800.5 813h-475c-6.9 0-12.5 5.6-12.5 12.5v100c0 6.9 5.6 12.5 12.5 12.5h475c6.9 0 12.5-5.6 12.5-12.5v-100C813 818.6 807.4 813 800.5 813z"
                  ></path>
                  <path
                    d="M950,125H450.3c5.3,21.1,8,42.8,8,65c0,20.4-2.4,40.5-7.1,60H850c13.8,0,25,11.2,25,25v700c0,13.8-11.2,25-25,25H275 c-13.8,0-25-11.2-25-25V447.7c-17.7,4.2-35.9,6.6-54.3,7.2l-1.2,0h-1.2c-23.3,0-46.1-3-68.3-8.8V1075c0,27.6,22.4,50,50,50h775 c27.6,0,50-22.4,50-50V175C1000,147.4,977.6,125,950,125z"
                  ></path>
                  <path
                    d="M813 325.5c0-6.9-5.6-12.5-12.5-12.5H427c-12.4 23-28.3 44.1-47.3 62.8-19.8 19.5-42.2 35.8-66.8 48.5v126.2c0 6.9 5.6 12.5 12.5 12.5h475c6.9 0 12.5-5.6 12.5-12.5V325.5zM383.3 190c0-106.7-86.7-190-190-190C86.7 0 0 83.3 0 190c0 103.3 86.7 190 193.3 190C296.7 376.7 383.3 293.3 383.3 190zM171.7 264.2c-6.7 0-13.3-2.5-18.3-7.5L106.7 210c-13.3-10-13.3-26.7 0-36.7 5-5 11.7-7.5 18.3-7.5 6.7 0 13.3 2.5 18.3 7.5L170 200l76.7-76.7c5-5 11.7-7.5 18.3-7.5 6.7 0 13.3 2.5 18.3 7.5 10 10 10 26.7 0 36.7L190 256.7C185 261.7 178.3 264.2 171.7 264.2z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="matrix">
                  <path
                    d="M175 0H25C11.2 0 0 11.2 0 25v150c0 13.8 11.2 25 25 25h150c13.8 0 25-11.2 25-25V25C200 11.2 188.8 0 175 0zM975 0H825c-13.8 0-25 11.2-25 25v150c0 13.8 11.2 25 25 25h150c13.8 0 25-11.2 25-25V25C1000 11.2 988.8 0 975 0zM575 0H425c-13.8 0-25 11.2-25 25v150c0 13.8 11.2 25 25 25h150c13.8 0 25-11.2 25-25V25C600 11.2 588.8 0 575 0zM175 800H25c-13.8 0-25 11.2-25 25v150c0 13.8 11.2 25 25 25h150c13.8 0 25-11.2 25-25V825C200 811.2 188.8 800 175 800zM975 800H825c-13.8 0-25 11.2-25 25v150c0 13.8 11.2 25 25 25h150c13.8 0 25-11.2 25-25V825C1000 811.2 988.8 800 975 800zM575 800H425c-13.8 0-25 11.2-25 25v150c0 13.8 11.2 25 25 25h150c13.8 0 25-11.2 25-25V825C600 811.2 588.8 800 575 800zM175 400H25c-13.8 0-25 11.2-25 25v150c0 13.8 11.2 25 25 25h150c13.8 0 25-11.2 25-25V425C200 411.2 188.8 400 175 400zM975 400H825c-13.8 0-25 11.2-25 25v150c0 13.8 11.2 25 25 25h150c13.8 0 25-11.2 25-25V425C1000 411.2 988.8 400 975 400zM575 400H425c-13.8 0-25 11.2-25 25v150c0 13.8 11.2 25 25 25h150c13.8 0 25-11.2 25-25V425C600 411.2 588.8 400 575 400z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="merge">
                  <path
                    d="M499.7,0C223.6,0,0,224,0,500c0,276,223.6,500,499.7,500c276.1,0,500.3-224,500.3-500C1000,224,776.4,0,499.7,0z M939,562.5 c0,6.9-5.6,12.5-12.5,12.5h-96.7c-6.9,0-12.8,5.6-12.8,12.5v91.2c0,10.1-9.9,16-18.2,10.2L543.7,510.3c-7.1-5-6.8-15.5,0.4-20.5 l254.5-178.8c8.3-5.8,18.4,0.1,18.4,10.2v91.2c0,6.9,5.9,12.5,12.8,12.5h96.7c6.9,0,12.5,5.6,12.5,12.5V562.5z M57,437.6 c0-6.9,5.6-12.6,12.5-12.6h96.7c6.9,0,12.8-5.6,12.8-12.4v-91.2c0-10.1,9.9-16,18.2-10.2l255.1,178.7c7.1,5,6.8,15.5-0.4,20.5 L197.4,689c-8.3,5.8-18.4-0.1-18.4-10.2v-91.2c0-6.9-5.9-12.6-12.8-12.6H69.5c-6.9,0-12.5-5.5-12.5-12.4V437.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 283" id="minus">
                  <path
                    d="M859.3,283c77.7,0,140.7-63.8,140.7-141.5C1000,63.8,937,0,859.3,0H143.5C65.8,0,0,62.5,0,140.2v1.7 C0,219.6,65.8,283,143.5,283H859.3z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="minus-circle">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M679.4,425 c39,0,70.6,33.8,70.6,72.8v3.3c0,39-31.6,73.9-70.6,73.9H320.6c-39,0-70.6-36-70.6-75c0-39,31.6-75,70.6-75H679.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 21 5" id="more">
                  <path
                    d="M10.5,5 C9.11928813,5 8,3.88071187 8,2.5 C8,1.11928813 9.11928813,0 10.5,0 C11.8807119,0 13,1.11928813 13,2.5 C13,3.88071187 11.8807119,5 10.5,5 Z M2.5,5 C1.11928813,5 0,3.88071187 0,2.5 C0,1.11928813 1.11928813,0 2.5,0 C3.88071187,0 5,1.11928813 5,2.5 C5,3.88071187 3.88071187,5 2.5,5 Z M18.5,5 C17.1192881,5 16,3.88071187 16,2.5 C16,1.11928813 17.1192881,0 18.5,0 C19.8807119,0 21,1.11928813 21,2.5 C21,3.88071187 19.8807119,5 18.5,5 Z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 923.8" id="non-profit">
                  <path
                    d="M388.2,170.8c-25.5,25.5-25.5,67,0,92.6c12.4,12.4,28.8,19.2,46.3,19.2c17.5,0,33.9-6.8,46.3-19.2l118.6-118.6 c6.6-6.6,15.3-10.2,24.6-10.2c9.3,0,18.1,3.6,24.6,10.2l282.5,282.5c0.2,0.2,0.4,0.4,0.7,0.7c6,6.3,14.1,9.8,22.8,9.8 c14,0,26.2-8.9,30.4-22c17.5-54.9,19.8-113.5,6.7-169.7c-13.5-57.7-42.9-110.5-85-152.6C846.4,33.2,766.4,0,681.3,0 C627,0,573.3,13.9,526.2,40.2c-0.3,0.2-0.6,0.4-1,0.6l-0.2,0.1l-0.5,0.3l-0.5,0.2l-0.2,0.1c-7.5,3.3-14.2,7.9-19.9,13.6 L388.2,170.8z"
                  ></path>
                  <path
                    d="M923.7,503.5c0.9-18.8-5.9-36.4-19.1-49.6L641.9,191.2c-9.9-9.9-25.9-9.9-35.8,0L507.4,290c-19.4,19.4-45.3,30.1-72.9,30.1 c-27.5,0-53.4-10.7-72.8-30.1c-19.4-19.4-30.1-45.3-30.1-72.9c0-27.5,10.7-53.4,30.1-72.9l87.6-87.6c4.6-4.6,6.6-11,5.3-17.5 c-1.2-6.4-5.4-11.5-11.3-14C403.7,8.5,361.8,0,318.7,0c-48.5,0-95,10.5-138.1,31.3c-43.3,20.9-80.9,50.9-111.7,89.4 C31.8,167.1,8.6,223.1,2,282.2C-3.4,331.1,2,379,17.8,424.3c15.8,45.2,41.2,85.5,75.5,119.8l359.8,359.8 c12.3,12.3,28.2,19.3,45,19.8c0.7,0,1.3,0,2,0c17.5,0,33.9-6.8,46.3-19.2c25.5-25.5,25.5-67,0-92.6L312,577.6 c-4.7-4.7-6.6-11.3-5-18c0.4-1.5,0.9-3,1.7-4.4c3.5-6.3,9.9-10,16.7-10c5.1,0,9.8,2,13.4,5.6l234.4,234.4 c12.4,12.4,28.8,19.2,46.3,19.2c17.5,0,33.9-6.8,46.3-19.2c25.5-25.5,25.5-67,0-92.6L431.5,458.3c-7.1-7.1-7.1-18.7,0-25.9l0.7-0.7 l0.1-0.1c3-3,6.8-5,10.9-5.5c5.7-0.7,11.2,1.3,15.1,5.2l234.3,234.3c12.4,12.4,28.8,19.2,46.3,19.2c1.1,0,2.2,0,3.4-0.1 c15.4-0.8,30-7,41.3-17.5c14.2-13.2,21.5-31.2,20.7-50.6c-0.7-16.4-7.7-32.1-19.8-44.2L550.8,338.8c-7.9-7.9-7.4-21,1.7-28.3 c2.4-2,5.4-3.3,8.4-3.8c6.3-1.1,12.4,0.9,16.7,5.3l233.8,233.8c12.1,12.1,27.8,19.1,44.2,19.8c0.9,0,1.8,0.1,2.8,0.1 c18.3,0,35.3-7.4,47.9-20.8C916.7,533.5,922.9,518.8,923.7,503.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="notification">
                  <path
                    d="M999.9,820.9c0-0.5-0.1-0.9-0.1-1.3c-0.1-0.9-0.1-1.8-0.2-2.7c0-0.5-0.1-1.1-0.2-1.6c-0.1-0.8-0.2-1.6-0.3-2.4 c-0.1-0.6-0.2-1.1-0.3-1.7c-0.1-0.7-0.2-1.5-0.4-2.2c-0.1-0.6-0.2-1.1-0.3-1.7c-0.1-0.7-0.3-1.4-0.5-2.1c-0.1-0.6-0.3-1.1-0.4-1.7 c-0.2-0.7-0.3-1.4-0.5-2.1c-0.2-0.6-0.3-1.1-0.5-1.7c-0.2-0.7-0.4-1.4-0.6-2c-0.2-0.6-0.4-1.1-0.6-1.6c-0.2-0.7-0.5-1.3-0.7-2 c-0.2-0.5-0.4-1.1-0.6-1.6c-0.3-0.7-0.5-1.3-0.8-2c-0.2-0.5-0.5-1.1-0.7-1.6c-0.3-0.6-0.6-1.3-0.9-1.9c-0.2-0.5-0.5-1-0.8-1.5 c-0.3-0.6-0.6-1.3-1-1.9c-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.6-0.7-1.3-1.1-1.9c-0.3-0.5-0.6-1-0.9-1.5c-0.4-0.6-0.8-1.2-1.1-1.9 c-0.3-0.5-0.6-0.9-0.9-1.4c-0.4-0.6-0.8-1.2-1.2-1.8c-0.3-0.5-0.6-0.9-1-1.4c-0.4-0.6-0.9-1.2-1.3-1.8c-0.3-0.4-0.7-0.9-1-1.3 c-0.5-0.6-0.9-1.2-1.4-1.8c-0.3-0.4-0.7-0.8-1-1.3c-0.5-0.6-1-1.2-1.5-1.8c-0.3-0.4-0.7-0.8-1-1.2c-0.5-0.6-1.1-1.2-1.6-1.8 c-0.3-0.4-0.7-0.8-1-1.1c-0.6-0.6-1.2-1.2-1.7-1.9c-0.3-0.4-0.7-0.7-1-1.1c-0.6-0.6-1.2-1.3-1.9-1.9c-0.3-0.3-0.7-0.7-1-1 c-0.7-0.6-1.3-1.3-2-1.9c-0.3-0.3-0.6-0.6-0.9-0.9c-0.7-0.7-1.5-1.3-2.2-2c-0.3-0.3-0.6-0.5-0.9-0.8c-0.8-0.7-1.6-1.4-2.4-2.1 c-0.2-0.2-0.5-0.4-0.7-0.6c-0.9-0.7-1.8-1.5-2.7-2.2c-0.2-0.1-0.4-0.3-0.6-0.4c-1-0.8-2-1.6-3.1-2.4c-0.1-0.1-0.2-0.1-0.3-0.2 c-8-6.1-16.7-11.6-25.9-16.8c-15.7-8.9-25.4-25.5-25.4-43.5V524c0-54.3-10.2-106.6-30.8-155.5c-20.2-47.8-48.6-90.5-85-126.9 c-36.5-36.5-79.2-65.1-126.9-85.3c-1-0.4-2-0.8-3-1.2c-2.6-1.1-4.3-3.6-4.3-6.5V87.5C650,39.2,610.8,0,562.5,0H437.5 C389.2,0,350,39.2,350,87.5v62.4c0,2.8-1.7,5.3-4.2,6.4l-0.1,0c-48.1,20.3-91,48.7-127.5,85c-37,36.8-66,79.5-86.2,127 c-21.1,49.7-32,102.1-32,155.7v156.5c0,18-9.7,34.7-25.4,43.5c-9.1,5.1-17.9,10.7-25.9,16.8c-0.1,0.1-0.2,0.1-0.3,0.2 c-1,0.8-2.1,1.6-3.1,2.4c-0.2,0.1-0.4,0.3-0.6,0.4c-0.9,0.7-1.8,1.4-2.7,2.2c-0.2,0.2-0.5,0.4-0.7,0.6c-0.8,0.7-1.6,1.4-2.4,2.1 c-0.3,0.3-0.6,0.5-0.9,0.8c-0.7,0.7-1.5,1.3-2.2,2c-0.3,0.3-0.6,0.6-0.9,0.9c-0.7,0.6-1.4,1.3-2,1.9c-0.3,0.3-0.7,0.7-1,1 c-0.6,0.6-1.3,1.2-1.9,1.9c-0.3,0.4-0.7,0.7-1,1.1c-0.6,0.6-1.2,1.2-1.7,1.8c-0.3,0.4-0.7,0.8-1,1.1c-0.5,0.6-1.1,1.2-1.6,1.8 c-0.3,0.4-0.7,0.8-1,1.2c-0.5,0.6-1,1.2-1.5,1.8c-0.3,0.4-0.7,0.8-1,1.3c-0.5,0.6-1,1.2-1.4,1.8c-0.3,0.4-0.7,0.9-1,1.3 c-0.4,0.6-0.9,1.2-1.3,1.8c-0.3,0.5-0.6,0.9-1,1.4c-0.4,0.6-0.8,1.2-1.2,1.8c-0.3,0.5-0.6,0.9-0.9,1.4c-0.4,0.6-0.8,1.2-1.1,1.9 c-0.3,0.5-0.6,1-0.9,1.5c-0.4,0.6-0.7,1.2-1.1,1.9c-0.3,0.5-0.6,1-0.8,1.5c-0.3,0.6-0.7,1.3-1,1.9c-0.3,0.5-0.5,1-0.8,1.5 c-0.3,0.6-0.6,1.3-0.9,1.9c-0.2,0.5-0.5,1.1-0.7,1.6c-0.3,0.6-0.5,1.3-0.8,2c-0.2,0.5-0.4,1.1-0.6,1.6c-0.2,0.7-0.5,1.3-0.7,2 c-0.2,0.5-0.4,1.1-0.6,1.6c-0.2,0.7-0.4,1.4-0.6,2c-0.2,0.6-0.3,1.1-0.5,1.7c-0.2,0.7-0.4,1.4-0.5,2.1c-0.1,0.6-0.3,1.1-0.4,1.7 c-0.2,0.7-0.3,1.4-0.5,2.1c-0.1,0.6-0.2,1.1-0.3,1.7c-0.1,0.7-0.2,1.5-0.4,2.2c-0.1,0.6-0.2,1.1-0.3,1.7c-0.1,0.8-0.2,1.6-0.3,2.4 c-0.1,0.5-0.1,1-0.2,1.6c-0.1,0.9-0.1,1.8-0.2,2.7c0,0.5-0.1,0.9-0.1,1.3C0,822.3,0,823.6,0,825c0,86.4,122.4,127.9,195.3,144.9 c83.2,19.4,191.4,30.1,304.7,30.1s221.5-10.7,304.7-30.1c72.9-17,195.3-58.5,195.3-144.9C1000,823.6,1000,822.3,999.9,820.9z M920.4,835.8c-4,5.1-12.2,13.3-28.7,23c-25.5,15-61.5,28.1-104.1,38.1C709.8,915,607.7,925,500,925s-209.8-10-287.7-28.2 c-42.6-9.9-78.6-23.1-104.1-38.1c-16.5-9.7-24.7-17.8-28.7-23C75,829.9,75,826.7,75,825c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.4c0,0,0-0.1,0-0.1c0-0.1,0-0.3,0.1-0.4c0,0,0,0,0-0.1 c0-0.2,0.1-0.3,0.1-0.5c0,0,0,0,0-0.1c0-0.2,0.1-0.3,0.1-0.5c0,0,0,0,0-0.1c0-0.2,0.1-0.4,0.2-0.6c0,0,0-0.1,0-0.1 c0.1-0.2,0.1-0.4,0.2-0.6c0,0,0-0.1,0-0.1c0.1-0.2,0.2-0.4,0.3-0.6c0,0,0-0.1,0.1-0.1c0.1-0.2,0.2-0.4,0.3-0.6 c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.1,0.1-0.2,0.2-0.4 c0.1-0.2,0.2-0.4,0.3-0.5c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.2-0.3,0.3-0.4 c0.2-0.3,0.4-0.5,0.6-0.8c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.3,0.4-0.5,0.7-0.8c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.3,0.5-0.6,0.8-0.9 c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.6-0.7,0.9-1c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.4,0.7-0.7,1.1-1.1c0.1-0.1,0.1-0.1,0.2-0.2 c0.4-0.4,0.8-0.8,1.2-1.2c0.1,0,0.1-0.1,0.1-0.1c0.4-0.4,0.9-0.8,1.4-1.2c0,0,0.1-0.1,0.1-0.1c0.5-0.4,1-0.9,1.5-1.3 c0,0,0.1-0.1,0.1-0.1c0.5-0.5,1.1-0.9,1.7-1.4c0,0,0.1-0.1,0.1-0.1c0.6-0.5,1.2-1,1.8-1.4c0,0,0.1-0.1,0.1-0.1c0.6-0.5,1.3-1,2-1.5 c0,0,0.1-0.1,0.1-0.1c0.7-0.5,1.4-1,2.2-1.6c0,0,0.1,0,0.1-0.1c0.8-0.6,1.6-1.1,2.5-1.7h0c3.4-2.3,7.3-4.7,11.8-7.2 c0,0,0.1,0,0.1-0.1c25.3-14.2,60.1-26.8,101-36.3C290.2,735,392.3,725,500,725s209.8,10,287.7,28.2c40.9,9.5,75.7,22.1,101,36.3 c0,0,0.1,0,0.1,0.1c5.6,3.1,10.3,6.1,14.3,8.9c0,0,0.1,0,0.1,0.1c0.8,0.5,1.5,1.1,2.2,1.6c0,0,0.1,0.1,0.1,0.1c0.7,0.5,1.4,1,2,1.5 c0,0,0.1,0.1,0.1,0.1c0.6,0.5,1.2,1,1.8,1.4c0,0,0.1,0.1,0.1,0.1c0.6,0.5,1.1,0.9,1.7,1.4c0,0,0.1,0.1,0.1,0.1 c0.5,0.4,1,0.9,1.5,1.3c0,0,0.1,0.1,0.1,0.1c0.5,0.4,0.9,0.8,1.4,1.2c0.1,0,0.1,0.1,0.2,0.1c0.4,0.4,0.8,0.8,1.2,1.2 c0.1,0.1,0.1,0.1,0.2,0.2c0.4,0.4,0.7,0.7,1.1,1.1c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.6,0.7,0.9,1c0.1,0.1,0.1,0.1,0.2,0.2 c0.3,0.3,0.5,0.6,0.8,0.9c0.1,0.1,0.1,0.2,0.2,0.2c0.2,0.3,0.5,0.6,0.7,0.8c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.3,0.4,0.6,0.6,0.8 c0.1,0.1,0.2,0.3,0.3,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.2,0.4,0.3,0.5 c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.3,0.6c0,0.1,0.1,0.1,0.1,0.2 c0.1,0.2,0.2,0.4,0.3,0.6c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.4,0.3,0.6c0,0,0,0.1,0,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0,0,0,0,0,0.1 c0.1,0.2,0.1,0.4,0.2,0.6c0,0,0,0,0,0.1c0,0.2,0.1,0.4,0.1,0.5c0,0,0,0,0,0.1c0,0.2,0.1,0.3,0.1,0.5c0,0,0,0,0,0.1 c0,0.1,0,0.3,0.1,0.4c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2 c0,0.1,0,0.2,0,0.3C925,826.7,925,829.9,920.4,835.8z"
                  ></path>
                  <path
                    d="M378.5,804.6c13.3,54.7,62.6,95.4,121.5,95.4s108.1-40.6,121.5-95.4c-38.7-3-79.5-4.6-121.5-4.6 C458.1,800,417.2,801.6,378.5,804.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="notification-hollow">
                  <path
                    d="M999.9,820.9c0-0.5-0.1-0.9-0.1-1.3c-0.1-0.9-0.1-1.8-0.2-2.7c0-0.5-0.1-1.1-0.2-1.6c-0.1-0.8-0.2-1.6-0.3-2.4 c-0.1-0.6-0.2-1.1-0.3-1.7c-0.1-0.7-0.2-1.5-0.4-2.2c-0.1-0.6-0.2-1.1-0.3-1.7c-0.1-0.7-0.3-1.4-0.5-2.1c-0.1-0.6-0.3-1.1-0.4-1.7 c-0.2-0.7-0.3-1.4-0.5-2.1c-0.2-0.6-0.3-1.1-0.5-1.7c-0.2-0.7-0.4-1.4-0.6-2c-0.2-0.6-0.4-1.1-0.6-1.6c-0.2-0.7-0.5-1.3-0.7-2 c-0.2-0.5-0.4-1.1-0.6-1.6c-0.3-0.7-0.5-1.3-0.8-2c-0.2-0.5-0.5-1.1-0.7-1.6c-0.3-0.6-0.6-1.3-0.9-1.9c-0.2-0.5-0.5-1-0.8-1.5 c-0.3-0.6-0.6-1.3-1-1.9c-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.6-0.7-1.3-1.1-1.9c-0.3-0.5-0.6-1-0.9-1.5c-0.4-0.6-0.8-1.2-1.1-1.9 c-0.3-0.5-0.6-0.9-0.9-1.4c-0.4-0.6-0.8-1.2-1.2-1.8c-0.3-0.5-0.6-0.9-1-1.4c-0.4-0.6-0.9-1.2-1.3-1.8c-0.3-0.4-0.7-0.9-1-1.3 c-0.5-0.6-0.9-1.2-1.4-1.8c-0.3-0.4-0.7-0.8-1-1.3c-0.5-0.6-1-1.2-1.5-1.8c-0.3-0.4-0.7-0.8-1-1.2c-0.5-0.6-1.1-1.2-1.6-1.8 c-0.3-0.4-0.7-0.8-1-1.1c-0.6-0.6-1.2-1.2-1.7-1.9c-0.3-0.4-0.7-0.7-1-1.1c-0.6-0.6-1.2-1.3-1.9-1.9c-0.3-0.3-0.7-0.7-1-1 c-0.7-0.6-1.3-1.3-2-1.9c-0.3-0.3-0.6-0.6-0.9-0.9c-0.7-0.7-1.5-1.3-2.2-2c-0.3-0.3-0.6-0.5-0.9-0.8c-0.8-0.7-1.6-1.4-2.4-2.1 c-0.2-0.2-0.5-0.4-0.7-0.6c-0.9-0.7-1.8-1.5-2.7-2.2c-0.2-0.1-0.4-0.3-0.6-0.4c-1-0.8-2-1.6-3.1-2.4c-0.1-0.1-0.2-0.1-0.3-0.2 c-8-6.1-16.7-11.6-25.9-16.8c-15.7-8.9-25.4-25.5-25.4-43.5V524c0-54.3-10.2-106.6-30.8-155.5c-20.2-47.8-48.6-90.5-85-126.9 c-36.5-36.5-79.2-65.1-126.9-85.3c-1-0.4-2-0.8-3-1.2c-2.6-1.1-4.3-3.6-4.3-6.5V87.5C650,39.2,610.8,0,562.5,0H437.5 C389.2,0,350,39.2,350,87.5v62.4c0,2.8-1.7,5.3-4.2,6.4l-0.1,0c-48.1,20.3-91,48.7-127.5,85c-37,36.8-66,79.5-86.2,127 c-21.1,49.7-32,102.1-32,155.7v156.5c0,18-9.7,34.7-25.4,43.5c-9.1,5.1-17.9,10.7-25.9,16.8c-0.1,0.1-0.2,0.1-0.3,0.2 c-1,0.8-2.1,1.6-3.1,2.4c-0.2,0.1-0.4,0.3-0.6,0.4c-0.9,0.7-1.8,1.4-2.7,2.2c-0.2,0.2-0.5,0.4-0.7,0.6c-0.8,0.7-1.6,1.4-2.4,2.1 c-0.3,0.3-0.6,0.5-0.9,0.8c-0.7,0.7-1.5,1.3-2.2,2c-0.3,0.3-0.6,0.6-0.9,0.9c-0.7,0.6-1.4,1.3-2,1.9c-0.3,0.3-0.7,0.7-1,1 c-0.6,0.6-1.3,1.2-1.9,1.9c-0.3,0.4-0.7,0.7-1,1.1c-0.6,0.6-1.2,1.2-1.7,1.8c-0.3,0.4-0.7,0.8-1,1.1c-0.5,0.6-1.1,1.2-1.6,1.8 c-0.3,0.4-0.7,0.8-1,1.2c-0.5,0.6-1,1.2-1.5,1.8c-0.3,0.4-0.7,0.8-1,1.3c-0.5,0.6-1,1.2-1.4,1.8c-0.3,0.4-0.7,0.9-1,1.3 c-0.4,0.6-0.9,1.2-1.3,1.8c-0.3,0.5-0.6,0.9-1,1.4c-0.4,0.6-0.8,1.2-1.2,1.8c-0.3,0.5-0.6,0.9-0.9,1.4c-0.4,0.6-0.8,1.2-1.1,1.9 c-0.3,0.5-0.6,1-0.9,1.5c-0.4,0.6-0.7,1.2-1.1,1.9c-0.3,0.5-0.6,1-0.8,1.5c-0.3,0.6-0.7,1.3-1,1.9c-0.3,0.5-0.5,1-0.8,1.5 c-0.3,0.6-0.6,1.3-0.9,1.9c-0.2,0.5-0.5,1.1-0.7,1.6c-0.3,0.6-0.5,1.3-0.8,2c-0.2,0.5-0.4,1.1-0.6,1.6c-0.2,0.7-0.5,1.3-0.7,2 c-0.2,0.5-0.4,1.1-0.6,1.6c-0.2,0.7-0.4,1.4-0.6,2c-0.2,0.6-0.3,1.1-0.5,1.7c-0.2,0.7-0.4,1.4-0.5,2.1c-0.1,0.6-0.3,1.1-0.4,1.7 c-0.2,0.7-0.3,1.4-0.5,2.1c-0.1,0.6-0.2,1.1-0.3,1.7c-0.1,0.7-0.2,1.5-0.4,2.2c-0.1,0.6-0.2,1.1-0.3,1.7c-0.1,0.8-0.2,1.6-0.3,2.4 c-0.1,0.5-0.1,1-0.2,1.6c-0.1,0.9-0.1,1.8-0.2,2.7c0,0.5-0.1,0.9-0.1,1.3C0,822.3,0,823.6,0,825c0,86.4,122.4,127.9,195.3,144.9 c83.2,19.4,191.4,30.1,304.7,30.1s221.5-10.7,304.7-30.1c72.9-17,195.3-58.5,195.3-144.9C1000,823.6,1000,822.3,999.9,820.9z M175,680.6V524c0-43.1,8.8-85.6,26.1-126.4c16.3-38.3,39.9-73,70.1-103.2c29.3-29.2,64.2-52.4,103.7-69.1c1.2-0.5,2.3-1,3.5-1.4 l15.6-6.3c18.8-7.7,31.1-26,31.1-46.3v-16.8V100c0-13.8,11.2-25,25-25h100c13.8,0,25,11.2,25,25v53.4v16.9 c0,20.5,12.5,38.9,31.5,46.4l15.7,6.3c2.2,0.9,4.2,1.7,5.9,2.4c38.9,16.4,73.6,39.7,103.1,69.2c29.3,29.3,52.4,63.9,68.9,103 C816.6,436.9,825,479.4,825,524v156.5c0,1.6,0,3.1,0.1,4.7c-7.1-1.9-13.9-3.6-20.4-5.1C721.5,660.7,613.2,650,500,650 s-221.5,10.7-304.7,30.1c-6.5,1.5-13.3,3.2-20.4,5.1C175,683.7,175,682.1,175,680.6z M920.4,835.8c-4,5.1-12.2,13.3-28.7,23 c-25.5,15-61.5,28.1-104.1,38.1C709.8,915,607.7,925,500,925s-209.8-10-287.7-28.2c-42.6-9.9-78.6-23.1-104.1-38.1 c-16.5-9.7-24.7-17.8-28.7-23C75,829.9,75,826.7,75,825c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3 c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.4c0,0,0-0.1,0-0.1c0-0.1,0-0.3,0.1-0.4c0,0,0,0,0-0.1c0-0.2,0.1-0.3,0.1-0.5c0,0,0,0,0-0.1 c0-0.2,0.1-0.3,0.1-0.5c0,0,0,0,0-0.1c0-0.2,0.1-0.4,0.2-0.6c0,0,0-0.1,0-0.1c0.1-0.2,0.1-0.4,0.2-0.6c0,0,0-0.1,0-0.1 c0.1-0.2,0.2-0.4,0.3-0.6c0,0,0-0.1,0.1-0.1c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.2-0.4,0.3-0.6 c0-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.2,0.2-0.4,0.3-0.5c0.1-0.2,0.2-0.3,0.3-0.5 c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.2-0.3,0.3-0.4c0.2-0.3,0.4-0.5,0.6-0.8c0.1-0.1,0.1-0.1,0.2-0.2 c0.2-0.3,0.4-0.5,0.7-0.8c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.3,0.5-0.6,0.8-0.9c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.6-0.7,0.9-1 c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.4,0.7-0.7,1.1-1.1c0.1-0.1,0.1-0.1,0.2-0.2c0.4-0.4,0.8-0.8,1.2-1.2c0.1,0,0.1-0.1,0.1-0.1 c0.4-0.4,0.9-0.8,1.4-1.2c0,0,0.1-0.1,0.1-0.1c0.5-0.4,1-0.9,1.5-1.3c0,0,0.1-0.1,0.1-0.1c0.5-0.5,1.1-0.9,1.7-1.4 c0,0,0.1-0.1,0.1-0.1c0.6-0.5,1.2-1,1.8-1.4c0,0,0.1-0.1,0.1-0.1c0.6-0.5,1.3-1,2-1.5c0,0,0.1-0.1,0.1-0.1c0.7-0.5,1.4-1,2.2-1.6 c0,0,0.1,0,0.1-0.1c0.8-0.6,1.6-1.1,2.5-1.7h0c3.4-2.3,7.3-4.7,11.8-7.2c0,0,0.1,0,0.1-0.1c25.3-14.2,60.1-26.8,101-36.3 C290.2,735,392.3,725,500,725s209.8,10,287.7,28.2c40.9,9.5,75.7,22.1,101,36.3c0,0,0.1,0,0.1,0.1c5.6,3.1,10.3,6.1,14.3,8.9 c0,0,0.1,0,0.1,0.1c0.8,0.5,1.5,1.1,2.2,1.6c0,0,0.1,0.1,0.1,0.1c0.7,0.5,1.4,1,2,1.5c0,0,0.1,0.1,0.1,0.1c0.6,0.5,1.2,1,1.8,1.4 c0,0,0.1,0.1,0.1,0.1c0.6,0.5,1.1,0.9,1.7,1.4c0,0,0.1,0.1,0.1,0.1c0.5,0.4,1,0.9,1.5,1.3c0,0,0.1,0.1,0.1,0.1 c0.5,0.4,0.9,0.8,1.4,1.2c0.1,0,0.1,0.1,0.2,0.1c0.4,0.4,0.8,0.8,1.2,1.2c0.1,0.1,0.1,0.1,0.2,0.2c0.4,0.4,0.7,0.7,1.1,1.1 c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.6,0.7,0.9,1c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.5,0.6,0.8,0.9c0.1,0.1,0.1,0.2,0.2,0.2 c0.2,0.3,0.5,0.6,0.7,0.8c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.3,0.4,0.6,0.6,0.8c0.1,0.1,0.2,0.3,0.3,0.4c0.2,0.2,0.3,0.4,0.4,0.6 c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.2,0.2,0.4,0.3,0.6 c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.3,0.6c0,0.1,0.1,0.1,0.1,0.2c0.1,0.2,0.2,0.4,0.3,0.6c0,0,0,0.1,0.1,0.1 c0.1,0.2,0.2,0.4,0.3,0.6c0,0,0,0.1,0,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0,0,0,0,0,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0,0,0,0,0,0.1 c0,0.2,0.1,0.4,0.1,0.5c0,0,0,0,0,0.1c0,0.2,0.1,0.3,0.1,0.5c0,0,0,0,0,0.1c0,0.1,0,0.3,0.1,0.4c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4 c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3C925,826.7,925,829.9,920.4,835.8z"
                  ></path>
                  <path
                    d="M378.5,804.6c13.3,54.7,62.6,95.4,121.5,95.4s108.1-40.6,121.5-95.4c-38.7-3-79.5-4.6-121.5-4.6 C458.1,800,417.2,801.6,378.5,804.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 499.3" id="number">
                  <path
                    d="M121 490.6v-312H0v-73.6c16.9.5 33.3-.8 49.1-3.8 15.8-3 30-8.2 42.6-15.8 12.6-7.6 23.2-17.5 31.9-29.9 8.7-12.4 14.4-28 17.2-46H218v481H121zM283.7 117.9c7.3-23.6 18.3-44.3 33-61.9 14.6-17.6 33.1-31.4 55.3-41.2C394.1 4.9 419.6 0 448.5 0c22 0 42.9 3.4 62.8 10.3 19.9 6.9 37.4 16.7 52.5 29.5C579 52.6 591 68.4 599.9 87.2c8.9 18.8 13.4 39.8 13.4 63.2 0 24.3-3.9 45.1-11.7 62.5-7.8 17.4-18.1 32.9-30.9 46.4-12.8 13.5-27.4 25.8-43.6 36.7-16.3 11-32.6 21.9-49.1 32.6-16.5 10.8-32.5 22.4-48.1 34.7-15.6 12.4-29.3 26.3-41.2 43.3H616v84H263c0-28 4-52.3 12-72.9 8-20.6 18.9-39.1 32.6-55.4 13.7-16.2 29.9-31.3 48.4-45 18.5-13.7 38.1-27.7 58.7-41.9 10.5-7.3 21.7-14.8 33.7-22.3 11.9-7.6 22.8-15.9 32.6-25.1 9.8-9.2 18.1-19.5 24.7-30.9 6.6-11.4 10-24.5 10-39.1 0-23.4-6.8-41.6-20.3-54.6-13.5-13-30.8-19.6-51.9-19.6-14.2 0-26.2 3.3-36.1 10-9.9 6.6-17.7 15.3-23.7 26.1-6 10.8-10.2 22.8-12.7 35.9-2.5 13-3.8 25.9-3.8 38.9H274C273.1 166.6 276.3 141.5 283.7 117.9zM820.7 204c11.9-.9 23-3.5 33.3-7.9 10.3-4.3 18.8-10.6 25.4-18.9 6.6-8.2 10-19.2 10-33 0-20.6-6.9-36.4-20.6-47.4-13.7-11-29.5-16.5-47.4-16.5-24.7 0-43.4 8.4-56 24.6-12.6 16.3-18.7 36.7-18.2 61.7h-92.7c.9-25 5.4-47.5 13.4-67.9 8-20.4 19.2-38 33.7-52.7 14.4-14.6 31.7-26 51.9-34.1 20.1-8 42.6-12 67.3-12 19.2 0 38.5 2.9 57.7 8.6 19.2 5.7 36.5 14.3 51.9 25.7 15.3 11.5 27.8 25.4 37.4 41.9 9.6 16.5 14.4 35.5 14.4 57 0 23.4-5.5 44-16.7 61.8-11.2 17.9-28.4 30-50.4 36.4v1.4c26 6 47.3 18.8 62.4 38.5 15.1 19.7 22.6 43.3 22.6 70.7 0 25.2-4.9 47.6-14.8 67.3-9.9 19.7-23 36.2-39.5 49.5-16.5 13.3-35.5 23.4-57 30.2-21.5 6.9-44 10.3-67.3 10.3-27 0-51.6-3.9-73.8-11.7-22.2-7.8-41.1-19.1-56.7-34-15.6-14.9-27.6-33.2-36.1-54.7-8.5-21.5-12.5-46.3-12-74.3h92.7c.5 13 2.5 25.2 6.2 36.8 3.7 11.7 8.9 21.8 15.8 30.3 6.9 8.5 15.5 15.3 25.8 20.3 10.3 5 22.5 7.6 36.7 7.6 22 0 40.5-6.7 55.6-20.3 15.1-13.5 22.7-31.9 22.7-55.3 0-18.3-3.6-32.3-10.6-41.9-7.1-9.6-16.1-16.6-27.1-20.9-11-4.3-23.1-6.9-36.1-7.6-13-.7-25.5-1-37.5-1V204C798 204.9 808.8 204.9 820.7 204z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1214" id="open-in-browser">
                  <path
                    d="M950,107H485.7L318.7,7.2c-8.2-4.9-17-7.2-25.6-7.2C267,0,243,20.8,243,50.1V107H50c-27.6,0-50,22.4-50,50v900 c0,27.6,22.4,50,50,50h193v56.9c0,29.2,24,50.1,50.1,50.1c8.6,0,17.3-2.2,25.6-7.2l166.9-99.8H950c27.5,0,50-22.5,50-50V157 C1000,129.5,977.5,107,950,107z M243,982h-93c-13.8,0-25-11.2-25-25V257c0-13.8,11.2-25,25-25h93V982z M875,957 c0,13.8-11.2,25-25,25H451v0l-45.2,27c-16.7,10-37.8-2-37.8-21.5V982V232v-5.6c0-19.4,21.2-31.4,37.8-21.5l45.2,27v0h399 c13.8,0,25,11.2,25,25V957z"
                  ></path>
                  <path
                    d="M817.3,596.7L562.2,418c-8.3-5.8-18.2,0.1-18.2,10.2v91.2c0,6.9-5.9,12.5-12.8,12.5h-96.7c-6.9,0-12.5,5.6-12.5,12.5v125 c0,6.9,5.6,12.5,12.5,12.5h96.7c6.9,0,12.8,5.7,12.8,12.5v91.2c0,10.1,10.1,16,18.4,10.2l254.5-178.8 C824,612.2,824.4,601.6,817.3,596.7z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 25 25" id="palette">
                  <g>
                    <path
                      d="M15.3125,24.45 C12.8515,24.45 10.5705,23.343 8.7145,21.247 C6.6355,18.9 5.6815,15.998 5.8165,14.889 C5.8655,14.489 5.9645,14.107 6.1125,13.756 C6.2185,13.501 6.5095,13.379 6.7665,13.488 C7.0215,13.595 7.1415,13.888 7.0345,14.142 C6.9225,14.409 6.8465,14.701 6.8085,15.011 C6.7145,15.779 7.5675,18.444 9.4635,20.584 C10.6215,21.892 12.5765,23.45 15.3125,23.45 C20.6645,23.45 23.6825,20.782 23.8125,15.937 C23.8915,13.009 22.6465,9.768 20.6415,7.68 C18.9335,5.902 16.8015,4.984 14.3055,4.95 L14.2625,4.95 C12.9455,4.95 12.0235,5.771 11.4435,7.46 C11.3535,7.721 11.0715,7.858 10.8085,7.771 C10.5465,7.681 10.4085,7.397 10.4985,7.136 C11.4115,4.472 13.0615,3.937 14.3195,3.95 C17.0535,3.987 19.4895,5.037 21.3625,6.988 C23.5435,9.258 24.8975,12.782 24.8125,15.963 C24.6675,21.357 21.2055,24.45 15.3125,24.45"
                    ></path>
                    <path
                      d="M16.3125 6.95C15.7605 6.95 15.3125 7.399 15.3125 7.95 15.3125 8.501 15.7605 8.95 16.3125 8.95 16.8645 8.95 17.3125 8.501 17.3125 7.95 17.3125 7.399 16.8645 6.95 16.3125 6.95M16.3125 9.95C15.2095 9.95 14.3125 9.053 14.3125 7.95 14.3125 6.847 15.2095 5.95 16.3125 5.95 17.4155 5.95 18.3125 6.847 18.3125 7.95 18.3125 9.053 17.4155 9.95 16.3125 9.95M19.8125 10.45C19.2605 10.45 18.8125 10.899 18.8125 11.45 18.8125 12.001 19.2605 12.45 19.8125 12.45 20.3645 12.45 20.8125 12.001 20.8125 11.45 20.8125 10.899 20.3645 10.45 19.8125 10.45M19.8125 13.45C18.7095 13.45 17.8125 12.553 17.8125 11.45 17.8125 10.347 18.7095 9.45 19.8125 9.45 20.9155 9.45 21.8125 10.347 21.8125 11.45 21.8125 12.553 20.9155 13.45 19.8125 13.45M20.8125 15.45C20.2605 15.45 19.8125 15.899 19.8125 16.45 19.8125 17.001 20.2605 17.45 20.8125 17.45 21.3645 17.45 21.8125 17.001 21.8125 16.45 21.8125 15.899 21.3645 15.45 20.8125 15.45M20.8125 18.45C19.7095 18.45 18.8125 17.553 18.8125 16.45 18.8125 15.347 19.7095 14.45 20.8125 14.45 21.9155 14.45 22.8125 15.347 22.8125 16.45 22.8125 17.553 21.9155 18.45 20.8125 18.45M2.2744 1.45C2.1504 1.45 2.0354 1.497 1.9474 1.583 1.7924 1.736 1.7684 1.976 1.8904 2.154L8.4174 12.245C8.6044 12.536 8.8904 12.735 9.2264 12.815 9.6044 12.198 10.2144 11.744 10.9204 11.556 10.9284 11.226 10.8134 10.902 10.5904 10.648L2.6354 1.618C2.5454 1.513 2.4264 1.456 2.2954 1.45L2.2744 1.45M9.5074 13.855L9.4924 13.855C8.7084 13.83 7.9924 13.431 7.5774 12.788L1.0584 2.708C.6694 2.141.7454 1.363 1.2464.87 1.5344.587 1.9014.431 2.3384.451 2.7444.469 3.1284.655 3.3904.962L11.3404 9.987C11.8504 10.565 12.0404 11.356 11.8474 12.103 11.7954 12.303 11.6284 12.45 11.4244 12.475 10.7804 12.555 10.2204 12.969 9.9664 13.554 9.8864 13.737 9.7064 13.855 9.5074 13.855"
                    ></path>
                    <path
                      d="M11.6514,12.45 C10.6374,12.45 9.8124,13.273 9.8124,14.284 C9.8124,15.28 11.1284,16.771 12.7604,17.13 C13.8744,17.374 14.4324,17.443 14.7124,17.451 C14.6424,17.323 14.5494,17.169 14.4734,17.042 C14.0574,16.352 13.4894,15.407 13.4894,14.284 C13.4894,13.273 12.6654,12.45 11.6514,12.45 M14.7644,18.449 C14.2854,18.449 13.5884,18.335 12.5464,18.106 C10.5914,17.678 8.8124,15.856 8.8124,14.284 C8.8124,12.721 10.0864,11.45 11.6514,11.45 C13.2154,11.45 14.4894,12.721 14.4894,14.284 C14.4894,15.129 14.9554,15.904 15.3304,16.527 C15.6914,17.127 16.0034,17.645 15.6784,18.098 C15.5094,18.332 15.2494,18.449 14.7644,18.449"
                    ></path>
                  </g>
                </symbol>
                <symbol viewBox="0 0 875.1 1000" id="partial-submissions">
                  <path
                    d="M824.8,0H50.1C22.5,0,0,22.3,0,50.1v899.8c0,27.6,22.3,50.1,50.1,50.1H825c27.6,0,50.1-22.3,50.1-50.1V50.1 C874.9,22.5,852.6,0,824.8,0z M750,849.9c0,13.8-11.2,25-25,25H150.1c-13.8,0-25-11.2-25-25V150.1c0-13.8,11.2-25,25-25H725 c13.8,0,25,11.2,25,25V849.9z"
                  ></path>
                  <path
                    d="M547.5,731.4H328.7c-6.8,0-12.2,5.5-12.2,12.2v30.4c0,6.8,5.5,12.2,12.2,12.2h218.7c6.8,0,12.2-5.5,12.2-12.2v-30.4 C559.5,736.7,554,731.4,547.5,731.4z"
                  ></path>
                  <path
                    opacity=".4"
                    d="M662.9 530H213.1c-13.8 0-25 11.2-25 25v62.4c0 13.8 11.2 25 25 25h449.8c13.8 0 25-11.2 25-25v-62.5C688.1 541.1 676.7 530 662.9 530zM662.9 357.6H213.1c-13.8 0-25 11.2-25 25V445c0 13.8 11.2 25 25 25h449.8c13.8 0 25-11.2 25-25v-62.5C688.1 368.8 676.7 357.6 662.9 357.6z"
                  ></path>
                  <path
                    d="M664.9,185H215.1c-13.8,0-25,11.2-25,25v62.4c0,13.8,11.2,25,25,25h449.8c13.8,0,25-11.2,25-25V210 C690.1,196.2,678.9,185,664.9,185z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="pending">
                  <path
                    d="M453.1,313h-25c-27.6,0-53.1,18.8-53.1,46.4v135.4v77.1c0,27.6,25.5,53.1,53.1,53.1h75h137.5c27.6,0,47.4-25.5,47.4-53.1 v-25c0-27.6-19.8-46.9-47.4-46.9H500V359.4C500,331.8,480.7,313,453.1,313z"
                  ></path>
                  <path
                    d="M976.7,500h-79.6c-12.1,0-22,9.4-22.7,21.4C863,716.7,697.8,875,500,875c-205,0-375-170-375-375s170-375,375-375 c109.1,0,208.4,48.5,277.3,124.3l-90.4,62.8c-8.3,5.8-6.7,18.5,2.8,22l292.8,108.1c8.1,3,16.8-3,16.8-11.7l0.7-312 c0-10.1-11.3-16.1-19.6-10.3l-99.3,69C789.2,68.8,652.3,0,500,0C225,0,0,225,0,500s225,500,500,500c267,0,486.8-212.1,499.4-476.1 C1000.1,510.9,989.7,500,976.7,500z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="personal">
                  <path
                    d="M622.8,467.5c75.7-43,126.7-124.3,126.7-217.5c0-138.1-111.9-250-250-250s-250,111.9-250,250 c0,93.4,51.2,174.8,127.1,217.7C216.1,519.7,100,670.5,100,848.3V950c0,27.6,22.4,50,50,50h25c27.6,0,50-22.4,50-50V848.3 c0-37.2,7.3-73.2,21.6-107c13.8-32.7,33.7-62.2,59-87.5c25.3-25.3,54.7-45.1,87.5-59c33.8-14.3,69.8-21.6,107-21.6 c37.2,0,73.2,7.3,107,21.6c32.7,13.8,62.2,33.7,87.5,59c25.3,25.3,45.1,54.7,59,87.5c14.3,33.8,21.6,69.8,21.6,107V950 c0,27.6,22.4,50,50,50h25c27.6,0,50-22.4,50-50V848.3C900,670.2,783.6,519.3,622.8,467.5z M587.9,338.4 c-23.6,23.6-55,36.6-88.4,36.6s-64.8-13-88.4-36.6c-23.6-23.6-36.6-55-36.6-88.4s13-64.8,36.6-88.4c23.6-23.6,55-36.6,88.4-36.6 s64.8,13,88.4,36.6c23.6,23.6,36.6,55,36.6,88.4S611.5,314.8,587.9,338.4z"
                  ></path>
                  <path
                    d="M570.4,682.2c-20.4,0-40.8,7.7-56.3,23.2l-12,12c-1.2,1.2-3.1,1.2-4.2,0l-12-12c-15.5-15.5-35.9-23.2-56.3-23.2 c-20.4,0-40.8,7.7-56.3,23.2c-31,31-31,81.7,0,112.7l14.1,14.1l110.5,110.5c1.2,1.2,3.1,1.2,4.2,0l110.5-110.5l14.1-14.1 c31-31,31-81.7,0-112.7C611.3,690,590.8,682.2,570.4,682.2z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 999.9 468.7" id="phish">
                  <path
                    d="M692.6,150.1C638.9,62.3,503.5,0,345.1,0C189,0,55.3,60.5,0,146.2l88.1,88.1L0,322.4c55.3,85.8,189,146.2,345.1,146.2 c158.4,0,293.8-62.3,347.6-150.1l307.3,150.1V0L692.6,150.1z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="phone">
                  <path
                    d="M802.4,618.6c-11.8-10.3-29.5-10-41,0.6l-90,82.6c-0.9,0.8-1.7,1.6-2.5,2.5l0,0c-13.6,15.7-37.4,17.4-53.2,3.8 c0,0-120-86.4-178.8-145.1c-59.8-59.8-145.1-178.8-145.1-178.8c-13.6-15.7-11.9-39.5,3.8-53.2l0,0c0.9-0.8,1.7-1.6,2.5-2.5l82.6-90 c10.6-11.5,10.8-29.2,0.6-41L219.5,10.6C209.3-1.1,191.9-3.4,179,5.2L78.7,72.6c-1.9,1.3-3.7,2.8-5.2,4.4 C4.9,149.8-40,220.1,51.8,385.7c61.9,111.6,173.9,244.4,247,315.5c71,73.1,203.9,185.1,315.5,247c165.6,91.8,235.9,47,308.7-21.7 c1.7-1.6,3.1-3.3,4.4-5.2L994.8,821c8.7-12.9,6.4-30.3-5.4-40.5L802.4,618.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="pin">
                  <path
                    d="M658.7,383.1l12.3-277.2c27.6,0,50.1-22.4,50.1-50V21.2C721,9.5,711.4,0,699.7,0H304.1C290.3,0,279,11.2,279,25v30.8 c0,27.6,22.5,50,50.1,50l12.2,277.2c-53.1,2.8-95.3,46.8-95.3,100.6v43.6c0,13.8,11.2,24.7,25,24.7h77.8h93.8l47.5,439.6 c2,11.1,17.9,11,19.9-0.1L557.4,552h93.8H729c13.8,0,25-10.9,25-24.7v-43.6C754,429.9,711.8,385.9,658.7,383.1z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="pin-tilt">
                  <path
                    d="M992.7,340.9L659.1,7.3c-9.8-9.8-25.6-9.8-35.4,0l-35.4,35.4c-19.5,19.5-19.5,51.2,0,70.7l10.5,10.5L354.1,386 c-46.8-41-117.9-39.2-162.5,5.4l-39.9,39.9c-9.6,9.6-9.6,25.1,0,34.7l148,148L1.9,984.1c-6.4,9.2,4.8,20.4,14,14l370-297.9l155,155 c9.8,9.8,25.6,9.8,35.4,0l39.6-39.6c44.6-44.6,46.4-115.8,5.4-162.5l262.1-244.8l3.2,3.2c19.5,19.5,51.2,19.5,70.7,0l35.4-35.4 C1002.4,366.5,1002.4,350.6,992.7,340.9z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1003.5" id="plus">
                  <path
                    d="M643,643.5h216.3c77.7,0,140.7-63.8,140.7-141.5c0-77.7-63-141.5-140.7-141.5H643V140.7C643,63,579.2,0,501.5,0 C423.8,0,360,63,360,140.7v219.8H143.5C65.8,360.5,0,423,0,500.7v1.7c0,77.7,65.8,141.1,143.5,141.1H360v213 c0,77.7,63.3,147,141,147h0.5c77.7,0,141.4-69.2,141.4-147V643.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="plus-circle">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M679.4,425 c39,0,70.6,33.8,70.6,72.8v3.3c0,39-31.6,73.9-70.6,73.9H575v104.4c0,39-33.8,70.6-72.8,70.6h-3.3c-39,0-73.9-31.6-73.9-70.6V575 H320.6c-39,0-70.6-36-70.6-75c0-39,31.6-75,70.6-75H425V320.6c0-39,36-70.6,75-70.6c39,0,75,31.6,75,70.6V425H679.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="pop-out">
                  <path
                    d="M950,0H300c-27.6,0-50,22.4-50,50v200H50c-27.6,0-50,22.4-50,50v650c0,27.6,22.4,50,50,50h650c27.6,0,50-22.4,50-50V750 h200c27.6,0,50-22.4,50-50V50C1000,22.4,977.6,0,950,0z M625,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V399 c0-13.8,11.2-24,25-24h100v325c0,27.6,22.4,50,50,50h325V850z M875,599.5c0,13.8-11.7,25.5-25.5,25.5h-450 c-13.8,0-24.5-11.7-24.5-25.5v-451c0-13.8,10.8-23.5,24.5-23.5h450c13.8,0,25.5,9.7,25.5,23.5V599.5z"
                  ></path>
                  <path
                    d="M777.3,207.3l-306.7,54c-10,1.8-12.8,13-5.6,20.1l64.5,64.5c4.9,4.9,4.7,13-0.2,17.8l-68.4,68.4c-4.9,4.9-4.9,12.8,0,17.7 l88.4,88.4c4.9,4.9,12.8,4.9,17.7,0l68.4-68.4c4.9-4.9,13-5,17.9-0.2l64.5,64.5c7.1,7.1,18.5,4.2,20.2-5.8L791.6,222 C793.1,213.5,785.9,205.8,777.3,207.3z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="publish">
                  <path
                    d="M12.5,639h400c6.9,0,12.5,5.6,12.5,12.5v91.2c0,10.1,10.2,16,18.5,10.2l254.6-178.8c7.1-5,7.5-15.5,0.3-20.5L443.3,375 c-8.3-5.8-18.3,0.1-18.3,10.2v91.2c0,6.9-5.6,12.5-12.5,12.5h-400C5.6,489,0,494.6,0,501.5v125C0,633.4,5.6,639,12.5,639z"
                  ></path>
                  <path
                    d="M950,0h-73.2H106.5H50C22.4,0,0,22.4,0,50v301c0,13.8,11.2,25,25,25h75c13.8,0,25-11.2,25-25v-76c0-13.8,11.2-25,25-25h700 c13.8,0,25,11.2,25,25v575c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25v-74c0-13.8-11.2-25-25-25H25c-13.8,0-25,11.2-25,25v174 c0,27.5,22.5,50,50,50h900c27.6,0,50-22.4,50-50V50C1000,22.4,977.6,0,950,0z M200,125.5c0,20.7-16.8,37.5-37.5,37.5 S125,146.2,125,125.5v0c0-20.7,16.8-37.5,37.5-37.5S200,104.8,200,125.5L200,125.5z M325,125.5c0,20.7-16.8,37.5-37.5,37.5h0 c-20.7,0-37.5-16.8-37.5-37.5v0c0-20.7,16.8-37.5,37.5-37.5h0C308.2,88,325,104.8,325,125.5L325,125.5z M875,138 c0,13.8-11.2,25-25,25H400c-13.8,0-25-11.2-25-25v-25c0-13.8,11.2-25,25-25h450c13.8,0,25,11.2,25,25V138z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="published">
                  <path
                    d="M950,0h-73.2H106.5H50C22.4,0,0,22.4,0,50v900c0,27.5,22.5,50,50,50h900 c27.6,0,50-22.4,50-50V50C1000,22.4,977.6,0,950,0z M250,125.5c0-20.7,16.8-37.5,37.5-37.5h0c20.7,0,37.5,16.8,37.5,37.5v0 c0,20.7-16.8,37.5-37.5,37.5h0C266.8,163,250,146.2,250,125.5L250,125.5z M125,125.5c0-20.7,16.8-37.5,37.5-37.5 s37.5,16.8,37.5,37.5v0c0,20.7-16.8,37.5-37.5,37.5S125,146.2,125,125.5L125,125.5z M875,850c0,13.8-11.2,25-25,25H150 c-13.8,0-25-11.2-25-25V275c0-13.8,11.2-25,25-25h700c13.8,0,25,11.2,25,25V850z M875,138c0,13.8-11.2,25-25,25H400 c-13.8,0-25-11.2-25-25v-25c0-13.8,11.2-25,25-25h450c13.8,0,25,11.2,25,25V138z"
                  ></path>
                  <path
                    d="M649.6,379.2L445.8,583.1l-71.3-71.3c-27.6-27.6-72.2-27.6-99.8,0 c-27.6,27.6-27.6,72.2,0,99.8l121.2,121.2c27.6,27.6,72.2,27.6,99.8,0L749.4,479c27.6-27.6,27.6-72.2,0-99.8 C721.9,351.7,677.2,351.7,649.6,379.2z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="question">
                  <path
                    d="M818.1,178.5c-11.4-30.6-30.3-59-56.8-85.5C734.9,66.5,700,44.5,656.7,26.7C613.3,8.9,559.3,0,494.5,0 C444.4,0,399,8.5,358.4,25.4c-40.6,16.9-75.3,40.5-104,70.6c-28.7,30.1-51,66-67,107c-11.1,28.5-18.5,59.5-22.4,92 c-2.8,23.5,16.2,45.1,39.9,45.1h121.3c20.3,0,36.6-16.6,39-36.8c1.4-11.5,3.4-23.7,6.2-34.4c5.5-21.4,13.9-40.1,25.3-56.1 c11.4-16,26-28.8,43.8-38.4c17.8-9.6,39-14.4,63.6-14.4c36.5,0,65,10.1,85.5,30.1c20.5,20.1,30.8,51.1,30.8,93 c0.9,24.7-3.4,45.1-13,61.6c-9.6,16.4-22.2,31.5-37.7,45.1c-15.5,13.7-32.4,27.4-50.6,41c-18.3,13.7-35.7,29.9-52.1,48.6 c-16.4,18.7-31,41.3-43.3,67.7c-12.3,26.5-23,59.3-23,98.5v21.6c0,22.1,18.6,32.7,40.7,32.7h104.7c22.1,0,33.8-10.6,33.8-32.7v-12 c0-27.4,15.6-50.2,29.8-68.4c14.1-18.3,33.4-34.4,51.7-48.5c18.2-14.1,37.6-28.3,58.1-42.4c20.5-14.1,39.2-31.2,56.1-51.3 c16.9-20,31-44.2,42.4-72.5c11.4-28.3,17.1-64.3,17.1-108.1C835.2,237.5,829.5,209,818.1,178.5z"
                  ></path>
                  <circle cx="500" cy="890" r="110"></circle>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="radio">
                  <path
                    d="M500,250c-140,0-250,110-250,250s110,250,250,250s250-110,250-250S640,250,500,250z"
                  ></path>
                  <path
                    d="M500,0C225,0,0,225,0,500s225,500,500,500s500-225,500-500S775,0,500,0z M500,875c-205,0-375-170-375-375s170-375,375-375 s375,170,375,375S705,875,500,875z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="redo">
                  <path
                    d="M500,0c152.3,0,289.2,68.8,381.1,177.1l99.3-69c8.3-5.8,19.7,0.2,19.6,10.3l-0.7,312c0,8.7-8.7,14.7-16.8,11.7L689.7,334.1 c-9.5-3.5-11.1-16.2-2.8-22l90.4-62.8C708.4,173.5,609.1,125,500,125c-205,0-375,170-375,375c0,197.8,158.3,363,353.6,374.4 c12,0.7,21.4,10.7,21.4,22.7v79.6c0,13-10.9,23.4-23.9,22.7C212.1,986.8,0,767,0,500C0,225,225,0,500,0z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="refresh">
                  <path
                    d="M22.6 523h79.7c12.6 0 22.6-10.2 22.6-22.8 0-.1 0-.2 0-.2 0-205 170-375 375-375 109.2 0 208.4 48.2 277.3 124.3l-90.5 62.9c-8.3 5.8-6.7 18.5 2.8 22l292.8 108.1c8.1 3 16.8-3 16.8-11.7l.7-312c0-10.1-11.3-16.1-19.6-10.3l-99.3 69C789.1 69 652.2 0 500 0 225 0 0 225 0 500c0 .2 0 .3 0 .5C0 513 10.2 523 22.6 523zM977.4 477h-79.7c-12.6 0-22.6 10.2-22.6 22.8 0 .1 0 .2 0 .2 0 205-170 375-375 375-109.5 0-209-48.5-278-124.9l91.1-63.3c8.3-5.8 6.7-18.5-2.8-22L17.6 556.7c-8.2-3-16.8 3-16.8 11.7L0 880.4c0 10.1 11.3 16.1 19.6 10.3l98.7-68.6C210.3 930.7 347.4 1000 500 1000c275 0 500-225 500-500 0-.2 0-.3 0-.5C1000 487 989.8 477 977.4 477z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 999.8 914.1" id="resend-email">
                  <path
                    d="M409.8,205.8c0-0.3,0-0.6,0-0.8c0-112.9-91.2-204.5-204-205C92.6-0.5,0.5,90.9,0,204.2C-0.5,317.4,90.9,409.5,204.1,410 C317.3,410.4,409.8,319,409.8,205.8z M198.7,334.1c-68.2-3.3-123-60.1-123-129.1C75.7,134,133.9,75.8,205,75.8 c39.3,0,74.7,17.8,98.5,45.8l25.7-17.8c2.1-1.5,5.1,0,5.1,2.7l-0.2,80.6c0,2.2-2.2,3.8-4.3,3L254,162.2c-2.5-0.9-2.9-4.2-0.7-5.7 l23.4-16.2c-17.8-19.6-43.5-32.1-71.7-32.1c-53,0-96.9,43.9-96.9,96.9c0,51.1,40.8,93.8,91.3,96.8c3.1,0.2,5.5,2.8,5.5,5.9v20.6 C204.8,331.6,202.1,334.3,198.7,334.1z"
                  ></path>
                  <path
                    d="M959.8,114.1H468c9.9,29.2,14.8,59.7,14.8,90.9v0.8c0,2.7,0,5.5-0.1,8.2h400.8c0.5,0,1.1-0.2,1.6-0.2L614.4,484.4 c-7.8,7.8-20.5,7.7-28.3-0.1L446.3,344.6c-12.2,21.4-27.1,41.1-44.8,58.7c-6.3,6.2-12.8,12.2-19.5,17.7l147.9,148.1l42.3,42.4 c15.6,15.6,40.9,15.6,56.5,0l42.1-42.4l229-229.3v453.7c0,11-8.5,19.5-19.5,19.5h-560c-11,0-19.5-8.5-19.5-19.5V467.7 C269.9,479.2,237.3,485,204,485l-1.2,0c-1,0-2,0-3,0v389.1c0,22.1,17.9,40,40,40h720c22.1,0,40-17.9,40-40v-720 C999.8,132,981.9,114.1,959.8,114.1z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="return">
                  <path
                    d="M23.3,500h79.6c12.1,0,22,9.4,22.7,21.4C137,716.7,302.2,875,500,875c205,0,375-170,375-375S705,125,500,125 c-109.1,0-208.4,48.5-277.3,124.3l90.4,62.8c8.3,5.8,6.7,18.5-2.8,22L17.6,442.2c-8.1,3-16.8-3-16.8-11.7L0,118.5 c0-10.1,11.3-16.1,19.6-10.3l99.3,69C210.8,68.8,347.7,0,500,0c275,0,500,225,500,500s-225,500-500,500 C233,1000,13.2,787.9,0.6,523.9C-0.1,510.9,10.3,500,23.3,500z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 999.9" id="roi">
                  <path
                    d="M968,423.4c-30.1-16.9-68.2-6.1-85.1,24L732.2,716.7L608.4,564.4c-13.1-16.1-33.3-24.7-53.9-22.9 c-20.7,1.8-39.1,13.7-49.2,31.9L363.4,828.2L242,685.2c-12.3-14.5-30.7-22.6-49.7-22c-19.1,0.6-36.8,9.9-48.1,25.2L12.3,866.2 c-20.6,27.7-14.8,66.9,13,87.4c27.7,20.6,66.9,14.8,87.4-13l85-114.6l128.8,151.7c11.9,14.1,29.4,22,47.6,22c2,0,4.1-0.1,6.1-0.3 c20.4-2,38.5-13.9,48.5-31.8l140.9-253L693.2,867c13.1,16.1,33.2,24.6,53.9,22.9c20.6-1.8,39-13.7,49.2-31.7L992,508.5 C1008.9,478.4,998.2,440.3,968,423.4z"
                  ></path>
                  <path
                    d="M512.7,278.9h91.2c6.9,0,12.1,5.3,12.1,12.1v168.6c0,6.9,6,12.2,12.9,12.2h125c6.9,0,12.1-5.3,12.1-12.2V291.1 c0-6.9,6-12.1,12.9-12.1h91.2c10.1,0,16-10.4,10.2-18.7L701.6,5.5c-5-7.1-15.5-7.4-20.5-0.3L502.4,260.4 C496.6,268.7,502.6,278.9,512.7,278.9z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="sales">
                  <path
                    d="M999.9,673.1l-34.7-336.5c-1-9.4-10.8-15.2-19.3-11.1L641.3,473c-9.9,4.8-9.7,17.6-0.1,23L761,562.9L659,745.1L547.6,608 c-11.8-14.5-30-22.2-48.6-20.6c-18.6,1.6-35.2,12.4-44.3,28.7L327.1,845.5L217.8,716.8c-11.1-13.1-27.6-20.4-44.7-19.8 c-17.2,0.6-33.1,8.9-43.3,22.7l-118.7,160c-18.5,25-13.3,60.2,11.7,78.7c25,18.5,60.2,13.3,78.7-11.7l76.5-103.1l116,136.6 c10.7,12.7,26.5,19.8,42.9,19.8c1.8,0,3.7-0.1,5.5-0.3c18.4-1.8,34.7-12.5,43.6-28.6l126.8-227.7l111.2,136.9 c11.8,14.5,29.9,22.2,48.5,20.6c18.6-1.6,35.1-12.3,44.3-28.6l142.6-254.6l121.1,67.6C989.9,690.7,1001,684,999.9,673.1z"
                  ></path>
                  <path
                    d="M136.4,537.4c24.3,21.5,59.9,34.8,107,39.7v40.3c0,14.6,11.9,26.5,26.5,26.5h15.3c14.6,0,26.5-11.9,26.5-26.5v-40.3 c51-5.5,89.6-20.3,115.9-44.6c26.2-24.3,39.4-61.6,39.4-112.1c0-32.2-5.6-57.9-16.7-77.2c-11.1-19.3-25.1-34.9-42-46.8 c-16.8-11.9-34.9-21.2-54.2-27.9c-19.3-6.7-37.4-13.6-54.2-20.8c-16.8-7.2-30.8-15.7-42-25.6c-11.1-9.9-16.7-23.5-16.7-40.8 c0-11.4,3.5-21.9,10.4-31.6c6.9-9.7,17.8-14.5,32.7-14.5c13.4,0,23.3,5.6,29.7,16.7c6.4,11.1,9.7,24.1,9.7,39 c0,6.2,5,11.1,11.1,11.1h106.8c6.3,0,11.4-5.2,11.1-11.5C451,145.3,440,111.1,419.4,88c-22.3-25-58.2-40-107.7-44.9V26.5 c0-14.6-11.9-26.5-26.5-26.5h-15.3c-14.6,0-26.5,11.9-26.5,26.5v16.6c-90.6,14.9-135.9,68.6-135.9,161.2c0,30.2,5.3,54.7,16,73.5 c10.6,18.8,24,34,40.1,45.7c16.1,11.6,33.5,21.1,52.4,28.2c18.8,7.2,36.3,14.4,52.4,21.5c16.1,7.2,29.5,15.7,40.1,25.6 c10.6,9.9,16,23.3,16,40.1c0,13.4-3.8,24.8-11.5,34.2c-7.7,9.4-18.7,14.1-33.1,14.1c-13.9,0-25-4.2-33.4-12.6 c-8.4-8.4-12.6-23.8-12.6-46v-3c0-6.2-5-11.1-11.1-11.1H111.2c-6.2,0-11.1,5-11.1,11.1v8.9C100,481.5,112.2,515.8,136.4,537.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="save">
                  <path
                    d="M920,0H50C22.4,0,0,22.4,0,50v900c0,27.5,22.5,50,50,50h900c27.6,0,50-22.4,50-50 V80L920,0z M825,25v250c0,13.8-11.2,25-25,25H200c-13.8,0-25-11.2-25-25V25H825z M874,849.6c0,13.8-11,25.4-24.8,25.4H150.8 c-13.7,0-24.8-11.7-24.8-25.4V449.4c0-13.8,11-24.4,24.8-24.4h698.4c13.8,0,24.8,10.7,24.8,24.4V849.6z"
                  ></path>
                  <rect x="676" y="63" width="100" height="200"></rect>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="save-off">
                  <path
                    d="M982.7 31.6l-14.3-14.3C958.2 7.1 944.7 2 931.3 2c-13.4 0-26.8 5.1-37 15.3l-877 877c-20.5 20.5-20.5 53.6 0 74.1l14.3 14.3c10.2 10.2 23.6 15.3 37 15.3 13.4 0 26.8-5.1 37-15.3l877-877C1003.1 85.3 1003.1 52.1 982.7 31.6zM769.5 425h79.8c13.8 0 24.8 10.7 24.8 24.4v400.1c0 13.8-11 25.4-24.8 25.4H319.5l-125 125H950c27.6 0 50-22.4 50-50V194.5L769.5 425zM126 449.4c0-13.8 11-24.4 24.8-24.4h229.8l125-125H200c-13.8 0-25-11.2-25-25V25h605.5l25-25H50C22.4 0 0 22.4 0 50v755.5l126-126V449.4z"
                  ></path>
                  <polygon points="742.5 63 676 63 676 129.5"></polygon>
                </symbol>
                <symbol viewBox="0 0 1000.3 1000.3" id="search">
                  <path
                    d="M971,829.6L657.9,516.5C684.8,467,700,410.3,700,350C700,156.7,543.3,0,350,0S0,156.7,0,350s156.7,350,350,350 c60.3,0,117-15.2,166.5-42.1L829.6,971c39.1,39.1,102.4,39.1,141.4,0l0,0C1010.1,931.9,1010.1,868.6,971,829.6z M190.9,509.1 c-42.5-42.5-65.9-99-65.9-159.1s23.4-116.6,65.9-159.1c42.5-42.5,99-65.9,159.1-65.9c60.1,0,116.6,23.4,159.1,65.9 c42.5,42.5,65.9,99,65.9,159.1s-23.4,116.6-65.9,159.1c-42.5,42.5-99,65.9-159.1,65.9C289.9,575,233.4,551.6,190.9,509.1z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="section">
                  <path
                    d="M975 0h-75c-13.8 0-25 11.2-25 25v285c0 13.8-11.2 25-25 25H150c-13.8 0-25-11.2-25-25V25c0-13.8-11.2-25-25-25H25C11.2 0 0 11.2 0 25v385c0 27.5 22.5 50 50 50h900c27.5 0 50-22.5 50-50V25C1000 11.2 988.8 0 975 0zM950 540H50c-27.5 0-50 22.5-50 50v385c0 13.8 11.2 25 25 25h75c13.8 0 25-11.2 25-25V690c0-13.8 11.2-25 25-25h700c13.8 0 25 11.2 25 25v285c0 13.8 11.2 25 25 25h75c13.8 0 25-11.2 25-25V590C1000 562.5 977.5 540 950 540z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 853.6 1000" id="share">
                  <path
                    d="M691.1,675c-36.1,0-69.5,11.8-96.5,31.7L318.1,547c4.5-14.9,6.9-30.7,6.9-47s-2.4-32.2-6.9-47l276.6-159.7 c27,19.9,60.3,31.7,96.5,31.7c89.7,0,162.5-72.8,162.5-162.5S780.9,0,691.1,0S528.6,72.8,528.6,162.5c0,8,0.6,15.9,1.7,23.6 L236.9,355.5c-22.3-11.5-47.6-18-74.4-18C72.8,337.5,0,410.3,0,500s72.8,162.5,162.5,162.5c26.8,0,52.1-6.5,74.4-18l293.4,169.4 c-1.1,7.7-1.7,15.6-1.7,23.6c0,89.7,72.8,162.5,162.5,162.5s162.5-72.8,162.5-162.5S780.9,675,691.1,675z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="short-answer">
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50 V50C1000,22.4,977.6,0,950,0z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h700 c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M350,200h-75c-13.8,0-25,11.2-25,25v550c0,13.8,11.2,25,25,25h75 c13.8,0,25-11.2,25-25V225C375,211.2,363.8,200,350,200z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000.4" id="signature">
                  <path
                    d="M975 875.4H25c-13.8 0-25 11.2-25 25v75c0 13.8 11.2 25 25 25h950c13.8 0 25-11.2 25-25v-75C1000 886.6 988.8 875.4 975 875.4zM172.4 791.5c2.8 18.7 17.4 33.3 36.1 36.1l158.2 23.3c13.4 2 26.9-2.5 36.5-12.1l584.2-584.2c16.7-16.7 16.7-43.8 0-60.5L805.9 12.5c-16.7-16.7-43.8-16.7-60.5 0L161.2 596.8c-9.6 9.6-14 23.1-12.1 36.5L172.4 791.5zM274.8 634.5l485.8-485.8c8.4-8.4 21.9-8.4 30.3 0l60.5 60.5c8.4 8.4 8.4 21.9 0 30.3L365.5 725.2c-8.4 8.4-21.9 8.4-30.3 0l-60.5-60.5C266.4 656.4 266.4 642.8 274.8 634.5z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 871.4 1000" id="social">
                  <path
                    d="M499 743.7c39.4-22.4 65.9-64.8 65.9-113.3 0-72-58.4-130.4-130.4-130.4s-130.4 58.4-130.4 130.4c0 48.6 26.6 91 66.1 113.4-.1 0-.3.1-.4.1l-.3-.2c-83.7 27.2-144.2 105.9-144.2 198.7v37.4c0 11.1 9 20.1 20.1 20.1h377.7c11.1 0 20.1-9 20.1-20.1v-37.4C643.3 849.7 582.8 770.9 499 743.7zM364.5 630.4c0-38.6 31.4-70 70-70 38.6 0 70 31.4 70 70 0 38.6-31.4 70-70 70C395.9 700.4 364.5 669 364.5 630.4zM285.7 940c.6-38.7 15.9-75 43.3-102.4 8.5-8.5 17.9-15.9 27.9-22 1.3-.4 2.6-1 3.8-1.7 22.3-12.9 47.7-19.8 74.2-19.8 39.6 0 76.8 15.4 104.8 43.4C567 865 582.3 901.3 582.9 940H285.7zM404.3 117.3v291.2c0 21.2 11.2 38.5 25 38.5h10c13.8 0 25-17.2 25-38.5V117.3c19.4-10.6 32.5-31.2 32.5-54.8 0-34.5-28-62.5-62.5-62.5s-62.5 28-62.5 62.5C371.8 86.1 384.9 106.7 404.3 117.3zM853.1 154.6c-24.4-24.4-64-24.4-88.4 0-16.7 16.7-22 40.6-15.8 61.8L543 422.3c-15 15-19.3 35.1-9.5 44.9l7.1 7.1c9.8 9.8 29.9 5.5 44.9-9.5l205.9-205.9c21.2 6.2 45 .9 61.8-15.8C877.5 218.6 877.5 179 853.1 154.6zM286 464.7c15 15 35.1 19.3 44.9 9.5l7.1-7.1c9.8-9.8 5.5-29.9-9.5-44.9L122.5 216.3c6.2-21.2.9-45-15.8-61.8-24.4-24.4-64-24.4-88.4 0-24.4 24.4-24.4 64 0 88.4 16.7 16.7 40.6 22 61.8 15.8L286 464.7z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="sort">
                  <path
                    d="M940.4 0H60.5C28 0 0 27.6 0 60.1v4.9C0 96.9 28 125 60.5 125h879.9c32.5 0 59.6-27.6 59.6-60.1v-4.9C1000 27.6 972.8 0 940.4 0zM60.5 300h665.8c32.5 0 61.7-27.6 61.7-60.1v-4.9c0-32.5-29.2-60.1-61.7-60.1H60.5C28 175 0 202.6 0 235.1v4.9C0 271.9 28 300 60.5 300zM940.4 350H60.5C28 350 0 377.6 0 410.1v4.9C0 446.9 28 475 60.5 475h879.9c32.5 0 59.6-27.6 59.6-60.1v-4.9C1000 377.6 972.8 350 940.4 350zM510.2 533.2c-5-7.1-15.5-7.5-20.5-.4L311 787.8c-5.8 8.3.1 18.2 10.2 18.2h91.2c6.9 0 12.5 5.6 12.5 12.5v169c0 6.9 5.6 12.5 12.5 12.5h125c6.9 0 12.5-5.6 12.5-12.5v-169c0-6.9 5.6-12.5 12.5-12.5h91.2c10.1 0 16-10.1 10.2-18.3L510.2 533.2z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 640.6 1000" id="sorting">
                  <path
                    d="M609.1 576H31.6C5.1 576-9.5 606.6 7 627.2l288.8 361c12.6 15.8 36.6 15.8 49.2 0l288.8-361C650.2 606.6 635.5 576 609.1 576zM31.6 424h577.5c26.4 0 41.1-30.6 24.6-51.2l-288.8-361c-12.6-15.8-36.6-15.7-49.2 0L7 372.8C-9.5 393.4 5.1 424 31.6 424z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000.6" id="star">
                  <path
                    d="M972.2,351h-314c-11.9,0-22.5-5-26.3-16.3l-105.8-316c-8.4-25.3-44.2-24.6-52.6,0.7l-105.8,315 c-3.8,11.3-14.4,16.7-26.3,16.7H27.8c-26.5,0-37.9,36.2-16.9,52.3l261.7,202.6c9.2,7.1,13,19.8,9.6,30.9L179.9,964.4 c-8.1,25.8,21.9,46.9,43.3,30.4l260.2-199.5c10-7.6,23.8-7.6,33.8,0.1l259.3,199.3c21.5,16.5,51.5-4.4,43.4-30.3l-102-326 c-3.5-11.1,0.3-23.1,9.5-30.2l261.7-205C1010.1,387.1,998.7,351,972.2,351z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000.6" id="star-half-hollow">
                  <path
                    d="M972.2,351h-314c-11.9,0-22.5-5-26.3-16.3l-105.8-316c-8.4-25.3-44.2-24.6-52.6,0.7l-105.8,315 c-3.8,11.3-14.4,16.7-26.3,16.7H27.8c-26.5,0-37.9,36.2-16.9,52.3l261.7,202.6c9.2,7.1,13,19.8,9.6,30.9L179.9,964.4 c-8.1,25.8,21.9,46.9,43.3,30.4l260.2-199.4c10-7.6,23.8-7.6,33.8,0.1l259.3,199.3c21.5,16.5,51.5-4.4,43.4-30.3l-102-326 c-3.5-11.1,0.3-23.1,9.5-30.2l261.7-205C1010.1,387.1,998.7,351,972.2,351z M802.2,450.7L633.8,582.1c-4.1,3.2-5.8,9.2-4.3,14.2 l65.8,210.6c3.6,11.6-9.8,21.2-19.5,13.8l-168-129.1c-2.3-1.8-7.8-6.5-7.8-17.2c0-10.7-0.1-466-0.1-466c4.9,0.2,9.9,3.2,11.7,8.8 l68.1,202.4c1.7,5.1,6.5,6.5,11.8,6.5h202.9C806.5,426,811.6,443.4,802.2,450.7z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000.6" id="star-hollow">
                  <path
                    d="M972.2,351h-314c-11.9,0-22.5-5-26.3-16.3l-105.8-316c-8.4-25.3-44.2-24.6-52.6,0.7l-105.8,315 c-3.8,11.3-14.4,16.7-26.3,16.7H27.8c-26.5,0-37.9,36.2-16.9,52.3l261.7,202.6c9.2,7.1,13,19.8,9.6,30.9L179.9,964.4 c-8.1,25.8,21.9,46.9,43.3,30.4l260.2-199.4c10-7.6,23.8-7.6,33.8,0.1l259.3,199.3c21.5,16.5,51.5-4.4,43.4-30.3l-102-326 c-3.5-11.1,0.3-23.1,9.5-30.2l261.7-205C1010.1,387.1,998.7,351,972.2,351z M794.6,426c11.9,0,17,17.4,7.6,24.7L633.8,582.1 c-4.1,3.2-5.8,9.2-4.3,14.2l65.8,210.6c3.6,11.6-9.8,21.2-19.5,13.8l-168-129.1c-4.5-3.4-10.7-3.4-15.2,0L324,820.8 c-9.7,7.4-23.1-2-19.5-13.6l65.9-211c1.6-5-0.2-10.4-4.3-13.6L197.7,450.7c-9.4-7.3-4.3-24.7,7.6-24.7H408c5.4,0,10.1-1.1,11.8-6.2 L488,216.6c3.8-11.4,19.9-10.8,23.7,0.6l68.1,202.4c1.7,5.1,6.5,6.5,11.8,6.5"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 875 1000" id="submissions">
                  <path
                    d="M825,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h775c27.6,0,50-22.4,50-50V50C875,22.4,852.6,0,825,0z M750,850 c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h575c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M675.5 500h-475c-6.9 0-12.5 5.6-12.5 12.5v100c0 6.9 5.6 12.5 12.5 12.5h475c6.9 0 12.5-5.6 12.5-12.5v-100C688 505.6 682.4 500 675.5 500zM675.5 688h-475c-6.9 0-12.5 5.6-12.5 12.5v100c0 6.9 5.6 12.5 12.5 12.5h475c6.9 0 12.5-5.6 12.5-12.5v-100C688 693.6 682.4 688 675.5 688zM438 437c69 0 125-56 125-125 0-69-56-125-125-125s-125 56-125 125C313 381 369 437 438 437zM381.7 301c6.9-6.9 18.1-6.9 24.9 0l17.8 17.8 51-51c6.9-6.9 18.1-6.9 24.9 0 6.9 6.9 6.9 18.1 0 24.9l-63.4 63.4c-6.9 6.9-18.1 6.9-24.9 0l-30.3-30.3C374.8 319 374.8 307.8 381.7 301z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 875 1000" id="submissions-2">
                  <path
                    d="M825,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h775c27.6,0,50-22.4,50-50V50C875,22.4,852.6,0,825,0z M750,850 c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h575c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M675.5 688h-475c-6.9 0-12.5 5.6-12.5 12.5v100c0 6.9 5.6 12.5 12.5 12.5h475c6.9 0 12.5-5.6 12.5-12.5v-100C688 693.6 682.4 688 675.5 688zM438 658.4c134.2 0 243-105.3 243-235.2C681 293.3 572.2 188 438 188S195 293.3 195 423.2C195 553.1 303.8 658.4 438 658.4zM328.5 402.4c13.4-13 35.1-13 48.5 0l34.7 33.5 99.1-95.9c13.4-13 35.1-13 48.5 0 13.4 13 13.4 34 0 46.9L435.9 506.4c-13.4 13-35.1 13-48.5 0l-58.9-57C315.1 436.4 315.1 415.4 328.5 402.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="tag">
                  <path
                    d="M981.8,77.6c-0.1-32.8-26.6-59.3-59.4-59.4L569.5,0c-0.1,0-0.2,0-0.2,0c-15.8,0-31,6.3-42.2,17.5L17.5,527.1 c-23.3,23.3-23.3,61.1,0,84.3l371.1,371.1c11.6,11.6,26.9,17.5,42.2,17.5c15.3,0,30.5-5.8,42.2-17.5l509.6-509.6 c11.2-11.2,17.5-26.5,17.5-42.4L981.8,77.6z M865.7,413L448.4,830.3c-9.8,9.8-25.6,9.8-35.4,0L169.7,586.9 c-9.8-9.8-9.8-25.6,0-35.4L587,134.3c5-5,11.9-7.7,19-7.3L837.3,139c12.8,0.7,23,10.9,23.7,23.7L873,394.1 C873.3,401.1,870.7,408,865.7,413z"
                  ></path>
                  <ellipse
                    transform="matrix(0.7071 -0.7071 0.7071 0.7071 -30.4743 573.1636)"
                    cx="676.6"
                    cy="323.4"
                    rx="74.6"
                    ry="74.6"
                  ></ellipse>
                </symbol>
                <symbol viewBox="0 0 694.6 1000" id="themes">
                  <path
                    d="M372.4,24.8C368,14.6,366.2,0,347.3,0s-20.7,14.5-25.1,24.8C254.3,183,0,417.6,0,652.7C0,844.5,155.5,1000,347.3,1000 s347.3-155.5,347.3-347.3C694.6,416.5,440.4,183,372.4,24.8z M284,862.6c-2.3,0-4.6-0.3-6.7-0.7c-1.4-0.3-2.7-0.7-4-1.2 c-106.4-31.8-184-130.5-184-247.3c0-34.1,7.2-68.1,19.1-101.7c7.5,1.4,5.6,1,13.1,2.4c0,1.5,0,3,0,4.4c0,124.1,71,231.6,174.5,284.2 c1.2,0.5,2.4,1.1,3.5,1.7c9.3,5.4,15.6,15.4,15.6,27C315.1,848.7,301.2,862.6,284,862.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="trash">
                  <path
                    d="M500,0C223.9,0,0,81,0,180.9c0,32.1,23.1,62.2,63.5,88.3C70.6,273.7,75,281.6,75,290v529.1C75,919,265.3,1000,500,1000 s425-81,425-180.9V290c0-8.5,4.4-16.3,11.5-20.9c40.5-26.1,63.5-56.2,63.5-88.3C1000,81,776.1,0,500,0z M325,850 c0,1.1,0,2.2-2.6,5.7c-2.3,3.1-6.2,4.7-10,3.9c-35.1-7.1-67.6-21.7-96.7-33.4c-9.5-3.8-15.7-13-15.7-23.2V338.6 c0-6.6,6.2-11.4,12.6-9.8c32,8.2,66.8,15,103.8,20.3c5,0.7,8.7,5,8.7,10V850z M562,866.2c0,5.4-4,9.9-9.4,10.1 c-14.9,0.6-29.9,1-45.2,1c-20.5,0-40.9-0.6-60.7-1.8c-5.3-0.3-9.7-4.7-9.7-10.1v-495c0-5.7,5-10.3,10.8-10.1 c19.6,0.9,39.7,1.3,60,1.3c14.9,0,29.4-0.2,44-0.7c5.7-0.2,10.2,4.4,10.2,10.1V866.2z M800,803c0,10.2-6.3,19.4-15.8,23.2 c-29.3,11.7-62,26.4-97.3,33.5c-6.2,1.2-11.9-3.4-11.9-9.7l0,0V359.1c0-5,3.7-9.3,8.7-10c37-5.3,71.8-12.1,103.8-20.3 c6.4-1.6,12.6,3.2,12.6,9.8V803z M500,216.6c-185.8,0-336.4-25-336.4-55.7S314.2,95.1,500,95.1s336.4,35,336.4,65.7 S685.8,216.6,500,216.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 925" id="uncategorized">
                  <path
                    d="M350 0H50C22.4 0 0 22.4 0 50v300c0 27.6 22.4 50 50 50h300c27.6 0 50-22.4 50-50V50C400 22.4 377.6 0 350 0zM275 250c0 13.8-11.2 25-25 25H150c-13.8 0-25-11.2-25-25V150c0-13.8 11.2-25 25-25h100c13.8 0 25 11.2 25 25V250zM975 0H550c-13.8 0-25 11.2-25 25v75c0 13.8 11.2 25 25 25h425c13.8 0 25-11.2 25-25V25C1000 11.2 988.8 0 975 0zM550 325h300c13.8 0 25-11.2 25-25v-75c0-13.8-11.2-25-25-25H550c-13.8 0-25 11.2-25 25v75C525 313.8 536.2 325 550 325zM350 525H50c-27.6 0-50 22.4-50 50v300c0 27.6 22.4 50 50 50h300c27.6 0 50-22.4 50-50V575C400 547.4 377.6 525 350 525zM275 775c0 13.8-11.2 25-25 25H150c-13.8 0-25-11.2-25-25V675c0-13.8 11.2-25 25-25h100c13.8 0 25 11.2 25 25V775zM975 525H550c-13.8 0-25 11.2-25 25v75c0 13.8 11.2 25 25 25h425c13.8 0 25-11.2 25-25v-75C1000 536.2 988.8 525 975 525zM850 725H550c-13.8 0-25 11.2-25 25v75c0 13.8 11.2 25 25 25h300c13.8 0 25-11.2 25-25v-75C875 736.2 863.8 725 850 725z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="undo">
                  <path
                    d="M500,0C347.7,0,210.8,68.8,118.9,177.1l-99.3-69C11.3,102.4,0,108.3,0,118.5l0.7,312c0,8.7,8.7,14.7,16.8,11.7l292.8-108.1 c9.5-3.5,11.1-16.2,2.8-22l-90.4-62.8C291.6,173.5,390.9,125,500,125c205,0,375,170,375,375c0,197.8-158.3,363-353.6,374.4 c-12,0.7-21.4,10.7-21.4,22.7v79.6c0,13,10.9,23.4,23.9,22.7C787.9,986.8,1000,767,1000,500C1000,225,775,0,500,0z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="unpublish">
                  <path
                    d="M691.1 488.9h-400c-6.9 0-12.5-5.6-12.5-12.5v-91.2c0-10.1-10.2-16-18.5-10.2L5.5 553.8c-7.1 5-7.5 15.5-0.3 20.5l255.1 178.6c8.3 5.8 18.3-0.1 18.3-10.2v-91.2c0-6.9 5.6-12.5 12.5-12.5h400c6.9-0.1 12.5-5.7 12.5-12.6v-125C703.6 494.5 698 488.9 691.1 488.9z"
                  ></path>
                  <path
                    d="M950 0h-73.2H106.5 50C22.4 0 0 22.4 0 50v301c0 13.8 11.2 25 25 25h75c13.8 0 25-11.2 25-25v-76c0-13.8 11.2-25 25-25h700c13.8 0 25 11.2 25 25v575c0 13.8-11.2 25-25 25H150c-13.8 0-25-11.2-25-25v-74c0-13.8-11.2-25-25-25H25c-13.8 0-25 11.2-25 25v174c0 27.5 22.5 50 50 50h900c27.6 0 50-22.4 50-50V50C1000 22.4 977.6 0 950 0zM200 125.5c0 20.7-16.8 37.5-37.5 37.5S125 146.2 125 125.5l0 0c0-20.7 16.8-37.5 37.5-37.5S200 104.8 200 125.5L200 125.5zM325 125.5c0 20.7-16.8 37.5-37.5 37.5l0 0c-20.7 0-37.5-16.8-37.5-37.5l0 0c0-20.7 16.8-37.5 37.5-37.5l0 0C308.2 88 325 104.8 325 125.5L325 125.5zM875 138c0 13.8-11.2 25-25 25H400c-13.8 0-25-11.2-25-25v-25c0-13.8 11.2-25 25-25h450c13.8 0 25 11.2 25 25V138z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="upload">
                  <path
                    d="M688.9,556.5L510.2,301.9c-5-7.1-15.5-7.5-20.5-0.3L311,556.7c-5.8,8.3,0.1,18.3,10.2,18.3h91.2c6.9,0,12.5,5.6,12.5,12.5 v400c0,6.9,5.6,12.5,12.5,12.5h125c6.9,0,12.5-5.6,12.5-12.5v-400c0-6.9,5.6-12.5,12.5-12.5h91.2 C688.8,575,694.7,564.8,688.9,556.5z"
                  ></path>
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h238c13.8,0,25-11.2,25-25v-75c0-13.8-11.2-25-25-25H150 c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h700c13.8,0,25,11.2,25,25v700c0,13.8-11.2,25-25,25H713c-13.8,0-25,11.2-25,25v75 c0,13.8,11.2,25,25,25h237c27.6,0,50-22.4,50-50V50C1000,22.4,977.6,0,950,0z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 800 1000" id="user">
                  <path
                    d="M522.8,467.5c75.7-43,126.7-124.3,126.7-217.5c0-138.1-111.9-250-250-250s-250,111.9-250,250c0,93.4,51.2,174.8,127.1,217.7 C116.1,519.7,0,670.5,0,848.3V950c0,27.6,22.4,50,50,50h25c27.6,0,50-22.4,50-50V848.3c0-37.2,7.3-73.2,21.6-107 c13.8-32.7,33.7-62.2,59-87.5c25.3-25.3,54.7-45.1,87.5-59c33.8-14.3,69.8-21.6,107-21.6c37.2,0,73.2,7.3,107,21.6 c32.7,13.8,62.2,33.7,87.5,59c25.3,25.3,45.1,54.7,59,87.5c14.3,33.8,21.6,69.8,21.6,107V950c0,27.6,22.4,50,50,50h25 c27.6,0,50-22.4,50-50V848.3C800,670.2,683.6,519.3,522.8,467.5z M311.1,161.6c23.6-23.6,55-36.6,88.4-36.6s64.8,13,88.4,36.6 c23.6,23.6,36.6,55,36.6,88.4s-13,64.8-36.6,88.4c-23.6,23.6-55,36.6-88.4,36.6s-64.8-13-88.4-36.6c-23.6-23.6-36.6-55-36.6-88.4 S287.5,185.2,311.1,161.6z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="user-circle">
                  <path
                    d="M500,0C223.9,0,0,223.9,0,500c0,276.1,223.9,500,500,500s500-223.9,500-500C1000,223.9,776.1,0,500,0z M750,726.5 c-19.6,21.6-41.9,40.6-66.4,56.6c-14,9.1-33.5-0.4-33.6-17.1c0-0.1,0-0.2,0-0.4V720c0-78.1-57.8-146.4-135.5-153.7 C425.3,557.9,350,628.1,350,715.6v50c0,0.1,0,0.2,0,0.4c-0.1,16.7-19.6,26.2-33.6,17.1c-24.5-16-46.8-35-66.4-56.6v-10.9 c0-111.2,73.3-206,174.1-238.2c-48.1-26.6-80.9-77.9-80.9-136.8c0-92.4,80.3-166.1,174.9-155.2c71.4,8.3,129,66.3,136.7,137.7 c7.1,66.1-26.8,125-79.6,154.2C676.1,509.6,750,604.4,750,715.6V726.5z"
                  ></path>
                  <circle cx="500" cy="340.6" r="56.2"></circle>
                </symbol>
                <symbol viewBox="0 0 1476 1000" id="users">
                  <path
                    d="M522.8 467.5c75.7-43 126.7-124.3 126.7-217.5 0-138.1-111.9-250-250-250s-250 111.9-250 250c0 93.4 51.2 174.8 127.1 217.7C116.1 519.7 0 670.5 0 848.3V950c0 27.6 22.4 50 50 50h25c27.6 0 50-22.4 50-50V848.3c0-37.2 7.3-73.2 21.6-107 13.8-32.7 33.7-62.2 59-87.5 25.3-25.3 54.7-45.1 87.5-59 33.8-14.3 69.8-21.6 107-21.6 37.2 0 73.2 7.3 107 21.6 32.7 13.8 62.2 33.7 87.5 59 25.3 25.3 45.1 54.7 59 87.5 14.3 33.8 21.6 69.8 21.6 107V950c0 27.6 22.4 50 50 50h25c27.6 0 50-22.4 50-50V848.3C800 670.2 683.6 519.3 522.8 467.5zM487.9 338.4c-23.6 23.6-55 36.6-88.4 36.6s-64.8-13-88.4-36.6c-23.6-23.6-36.6-55-36.6-88.4s13-64.8 36.6-88.4c23.6-23.6 55-36.6 88.4-36.6s64.8 13 88.4 36.6c23.6 23.6 36.6 55 36.6 88.4S511.5 314.8 487.9 338.4zM1199.1 467.5c76-43.2 127.2-124.9 126.8-218.6C1325.3 111.3 1212.5-.5 1074.9 0 937.3.5 826 112.3 826 250c0 93.4 51 174.8 126.8 217.7-57.2 18.5-108.7 49.6-151.4 89.9-8.7 8.3-10.2 21.6-3.7 31.7 13.6 20.9 25.4 42.8 35.5 65.5 7.3 16.4 29 20 41.2 6.8 2.4-2.6 4.9-5.2 7.5-7.8 25.3-25.3 54.8-45.1 87.5-59 33.8-14.3 69.9-21.6 107-21.6 37.2 0 73.2 7.3 107 21.6 32.7 13.8 62.2 33.7 87.5 59 25.3 25.3 44.9 54.7 58.7 87.5 14.3 33.8 21.3 69.8 21.3 107v101.2c0 27.9 22.6 50.5 50.5 50.5h25c27.3 0 49.5-22.2 49.5-49.5V848.3C1476 670.2 1359.9 519.3 1199.1 467.5zM1164.4 338.4c-23.6 23.6-55 36.6-88.4 36.6s-64.8-13-88.4-36.6C964 314.8 951 283.4 951 250s13-64.8 36.6-88.4c23.6-23.6 55-36.6 88.4-36.6s64.8 13 88.4 36.6c23.6 23.6 36.6 55 36.6 88.4S1188 314.8 1164.4 338.4z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="verified">
                  <path
                    d="M906,500c0-41.3,103.4-95.7,93.2-133.8c-10.5-39.4-127.6-34.7-147.6-69.3c-20.3-35,42.1-134,13.7-162.4 C837,106.2,738,168.5,703,148.3c-34.5-20-29.8-137-69.3-147.6C595.7-9.5,541.3,94,500,94C458.7,94,404.3-9.5,366.2,0.7 c-39.4,10.5-34.7,127.6-69.3,147.6c-35,20.3-134-42.1-162.4-13.7C106.2,163,168.5,262,148.3,297c-20,34.5-137,29.8-147.6,69.3 C-9.5,404.3,94,458.7,94,500S-9.5,595.7,0.7,633.8c10.5,39.4,127.6,34.7,147.6,69.3c20.3,35-42.1,134-13.7,162.4 S262,831.5,297,851.7c34.5,20,29.8,137,69.3,147.6c38.1,10.2,92.4-93.2,133.8-93.2s95.7,103.4,133.8,93.2 c39.4-10.5,34.7-127.6,69.3-147.6c35-20.3,134,42.1,162.4,13.7S831.5,738,851.7,703c20-34.5,137-29.8,147.6-69.3 C1009.5,595.7,906,541.3,906,500z M749.4,423L495.6,676.8c-27.6,27.6-72.2,27.6-99.8,0L274.7,555.6c-27.6-27.6-27.6-72.2,0-99.8 c27.6-27.6,72.2-27.6,99.8,0l71.3,71.3l203.9-203.9c27.6-27.6,72.2-27.6,99.8,0C777,350.8,777,395.5,749.4,423z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="video">
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50 V50C1000,22.4,977.6,0,950,0z M875,850c0,13.8-11.2,25-25,25H150c-13.8,0-25-11.2-25-25V150c0-13.8,11.2-25,25-25h700 c13.8,0,25,11.2,25,25V850z"
                  ></path>
                  <path
                    d="M699.2,480.8L417.3,255.4c-16.1-12.9-40.3-1.4-40.3,19.2v450.7 c0,20.6,24.2,32.1,40.3,19.2l282.1-225.4C711.7,509.4,711.5,490.6,699.2,480.8z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="video-2">
                  <path
                    d="M950,0H50C22.4,0,0,22.4,0,50v900c0,27.6,22.4,50,50,50h900c27.6,0,50-22.4,50-50 V50C1000,22.4,977.6,0,950,0z M699.4,519.2L417.3,744.6c-16.1,12.9-40.3,1.4-40.3-19.2V274.6c0-20.6,24.2-32.1,40.3-19.2 l281.9,225.4C711.5,490.6,711.7,509.4,699.4,519.2z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 780.4" id="view">
                  <path
                    d="M627.7,262.3c-16.6-16.6-36-29.6-57.6-38.7c-22.3-9.4-46-14.2-70.3-14.2s-48,4.8-70.3,14.2c-21.6,9.1-41,22.1-57.6,38.7 s-29.6,36-38.7,57.6c-9.4,22.3-14.2,46-14.2,70.3c0,24.3,4.8,48,14.2,70.3c9.1,21.6,22.1,41,38.7,57.6s36,29.6,57.6,38.7 c22.3,9.4,46,14.2,70.3,14.2s48-4.8,70.3-14.2c21.6-9.1,41-22.1,57.6-38.7s29.6-36,38.7-57.6c9.4-22.3,14.2-46,14.2-70.3 c0-24.3-4.8-48-14.2-70.3C657.3,298.3,644.3,278.9,627.7,262.3z M499.9,446c-30.9,0-55.8-24.8-55.8-55.8s24.8-55.8,55.8-55.8 s55.8,24.8,55.8,55.8S530.8,446,499.9,446z"
                  ></path>
                  <path
                    d="M964.5,332.5c-27.4-48.5-57.9-92.9-90.8-132.1c-33.7-40.2-70.1-75.2-108.1-104c-40.2-30.4-82.4-54-125.6-70.2 C593.6,8.8,546.3,0,499.2,0c-95.1,0-189.8,32.9-273.9,95.3c-39,28.9-75.6,64-108.6,104.2c-32.4,39.5-61.5,84-86.2,132.2L0,390.9 l32,58.4c52.3,95.5,120.9,176.5,198.4,234.2c85,63.4,178,96.9,268.8,96.9c46.6,0,93.6-8.5,139.7-25.3c42.9-15.7,85-38.5,125.1-68 c38-27.9,74.4-61.9,108.2-101c33-38.1,63.7-81.3,91.3-128.4l36.5-62.3L964.5,332.5z M499.2,655C369.4,655,231,551.6,142,389 c83.9-163.1,218.2-263.6,357.2-263.6c129.2,0,260.7,99.9,356.1,268.8C759.4,557.9,628.4,655,499.2,655z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 999.9 934.8" id="webhook">
                  <path
                    d="M657.5,722.3c14.8,36.6,50.8,62.5,92.7,62.5c55.2,0,100-44.8,100-100c0-55.2-44.8-100-100-100c-42,0-77.9,25.9-92.7,62.5 l-160.3,0c0,0,0-0.1,0-0.1h-47.6c-14.4,0-25.8,12.2-24.9,26.6c0.2,3.7,0.3,7.3,0.3,11c0,46.7-18.2,90.7-51.3,123.7 c-33.1,33.1-77,51.3-123.7,51.3c-46.7,0-90.7-18.2-123.7-51.3C93.2,775.5,75,731.5,75,684.8s18.2-90.7,51.3-123.7 c27.8-27.8,63.4-45.2,101.9-49.9c12.5-1.5,21.8-12.2,21.8-24.8v-25.2c0-14.9-12.9-26.5-27.7-24.9C97.2,450.1,0,556.1,0,684.8 c0,137.6,112.1,249.9,249.7,250c124.9,0.1,229.2-92.2,247.4-212.5L657.5,722.3z"
                  ></path>
                  <path
                    d="M966.6,560c-62.3-108.2-194.5-152.4-307.7-108l-80.2-138.8c24.3-31.2,28.7-75.2,7.8-111.6c-27.6-47.8-88.8-64.2-136.6-36.6 c-47.8,27.6-64.2,88.8-36.6,136.6c21,36.3,61.3,54.5,100.5,49.1l80.1,138.8c0,0-0.1,0-0.1,0.1l23.8,41.2 c7.2,12.5,23.5,16.3,35.5,8.3c3.1-2,6.2-4,9.4-5.8c40.5-23.4,87.6-29.6,132.8-17.5c45.2,12.1,82.9,41.1,106.3,81.5 c23.4,40.5,29.6,87.6,17.5,132.8c-12.1,45.2-41.1,82.9-81.5,106.3c-40.5,23.4-87.6,29.6-132.8,17.5c-35-9.4-65.6-28.9-88.5-56.1 c-11.6-13.8-31.4-17.5-47-8.5l-0.9,0.5c-20,11.5-24.6,38.2-9.8,55.9C635,936.9,768.2,962.9,875,901.3 C994.2,832.4,1035.3,679.2,966.6,560z"
                  ></path>
                  <path
                    d="M344,445.2l-80.1,138.8c-39.2-5.5-79.5,12.7-100.5,49.1c-27.6,47.8-11.2,109,36.6,136.6s109,11.2,136.6-36.6 c21-36.3,16.6-80.4-7.8-111.6l80.1-138.8c0,0,0.1,0,0.1,0l23.8-41.2c7.2-12.5,2.4-28.5-10.5-34.9c-3.3-1.6-6.5-3.4-9.7-5.2 c-40.5-23.4-69.4-61.1-81.5-106.3c-12.1-45.2-5.9-92.3,17.5-132.8c23.4-40.5,61.1-69.4,106.3-81.5c45.2-12.1,92.3-5.9,132.8,17.5 c40.5,23.4,69.4,61.1,81.5,106.3c10.2,38,7.4,77.5-7.7,113.2c-4.9,11.6-0.3,25,10.6,31.3l21.8,12.6c12.8,7.4,29.4,2.1,35.3-11.5 c50.6-115.2,7.5-252.5-104-316.8C505.8-35.5,352.4,5.6,283.6,124.9C220.9,233.4,248.9,369.4,344,445.2z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="window-resize">
                  <path
                    d="M887.8 29.6L887.8 29.6c-39.5-39.5-103.5-39.5-143 0L29.6 744.8c-39.5 39.5-39.5 103.5 0 143l0 0c39.5 39.5 103.5 39.5 143 0l715.2-715.2C927.3 133.2 927.3 69.1 887.8 29.6zM970.4 516.7L970.4 516.7c-39.5-39.5-103.5-39.5-143 0L516.7 827.3c-39.5 39.5-39.5 103.5 0 143l0 0c39.5 39.5 103.5 39.5 143 0l310.6-310.6C1009.9 620.3 1009.9 556.2 970.4 516.7z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 1000" id="workflow">
                  <path
                    d="M862.8,610.1V400H975c18.6,0,30.7-19.6,22.4-36.2l-175-350c-9.2-18.4-35.5-18.4-44.7,0l-62.3,124.6h-325 C364.4,58.1,289,0,200,0C89.5,0,0,89.5,0,200c0,88.5,57.5,163.6,137.3,190v210H25c-13.8,0-25,11.2-25,25v350c0,13.8,11.2,25,25,25 h350c13.8,0,25-11.2,25-25V625c0-13.8-11.2-25-25-25H262.3V390.1c60-19.6,107.5-66.9,127.5-126.7h263.1l-50.2,100.4 c-8.3,16.6,3.8,36.2,22.4,36.2h112.9v209.9C657.8,636,600,711.2,600,800c0,110.5,89.5,200,200,200s200-89.5,200-200 C1000,711.5,942.5,636.4,862.8,610.1z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 30 25" id="workflow-email-logic">
                  <path
                    d="M29.2,11.2c-7-3.1-12.2-5.4-15.9-7C5.9,0.9,3.9,0,2.6,0C1.4,0,0.8,0.7,0.6,1c-0.7,0.9-0.8,2.2-0.2,3.1l5,8.4 l-5,8.4c-0.6,1-0.5,2.2,0.2,3.1c0.2,0.2,0.8,1,1.9,1h0c1.4,0,3.3-0.9,10.6-4.1c3.8-1.7,8.9-4,16-7.1c0.5-0.2,0.8-0.7,0.8-1.3 C30,11.9,29.6,11.5,29.2,11.2z M2.9,2.8c1.1,0.2,4,1.5,9.3,3.9c2.6,1.2,5.9,2.6,10,4.4H7.8h0L2.9,2.8z M12.1,18.3 c-5.4,2.4-8.3,3.7-9.3,3.9l5-8.3h14.3C18,15.7,14.7,17.1,12.1,18.3z"
                  ></path>
                </symbol>
                <symbol viewBox="0 0 1000 999.5" id="wrench">
                  <path
                    d="M926.5,234.1L771.8,388.7l-121.6-39l-39.1-121.6L765.9,73.4c24.5-28.2,6.8-72-30.5-73.4c-0.6,0-1.2,0-1.8,0 c-68.8-0.2-137.9,26-190.4,78.5c-77.1,77.3-97,190.7-59.7,286.6L31.4,816.9c-41.8,41.8-41.8,110,0,151h0 c41.8,42,109.6,42.2,151.3,0.4l452-451.8c96,37.6,209.4,17.8,286.9-59.8c52.4-52.4,78.5-121.4,78.3-190.1c0-0.6,0-1.2,0-1.8 C998.6,227.3,954.7,209.5,926.5,234.1z"
                  ></path>
                </symbol>
              </svg>
            </div>
          </div>
        </div>

        <div class="fsSection fs1Col" id="fsSection150035770">
          <div class="fsSectionHeader">
            <h2 class="fsSectionHeading">Draft Day Availability</h2>
          </div>

          <div id="fsRow5415035-2" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell150035771"
              lang="en"
              fs-field-type="name"
              fs-field-validation-name="Name"
            >
              <span id="label150035771" class="fsLabel fsRequiredLabel"
                >Name<span class="fsRequiredMarker">*</span></span
              >

              <div class="fsSubFieldGroup">
                <div class="fsSubField fsNameFirst">
                  <input
                    type="text"
                    id="field150035771-first"
                    name="field150035771-first"
                    size="22"
                    aria-label="First Name"
                    value=""
                    required=""
                    class="fsField fsFieldName fsRequired"
                    aria-required="true"
                  />
                  <label
                    class="fsSupporting fsRequiredLabel"
                    for="field150035771-first"
                    >First Name<span class="hidden">*</span></label
                  >
                </div>

                <div class="fsSubField fsNameLast">
                  <input
                    type="text"
                    id="field150035771-last"
                    name="field150035771-last"
                    size="22"
                    aria-label="Last Name"
                    value=""
                    required=""
                    class="fsField fsFieldName fsRequired"
                    aria-required="true"
                  />
                  <label
                    class="fsSupporting fsRequiredLabel"
                    for="field150035771-last"
                    >Last Name<span class="hidden">*</span></label
                  >
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>

          <div id="fsRow5415035-3" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell150035772"
              lang="en"
              fs-field-type="email"
              fs-field-validation-name="Email"
            >
              <label
                id="label150035772"
                class="fsLabel fsRequiredLabel"
                for="field150035772"
                >Email<span class="fsRequiredMarker">*</span>
              </label>

              <input
                type="email"
                id="field150035772"
                name="field150035772"
                size="50"
                required="required"
                value=""
                class="fsField fsFormatEmail fsRequired"
                aria-required="true"
              />
            </div>
          </div>

          <div id="fsRow5415035-4" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell150035773"
              lang="en"
              fs-field-type="richtext"
              fs-field-validation-name=""
            >
              <p>
                <strong
                  ><span style="font-size: medium;"
                    >Mark the days you are available for the draft</span
                  ></strong
                >
              </p>
            </div>
          </div>

          <div id="fsRow5415035-5" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell150035774"
              lang="en"
              fs-field-type="checkbox"
              fs-field-validation-name="Mark the days you are available for the draft"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend150035774"
                id="label150035774"
              >
                <legend
                  id="fsLegend150035774"
                  class="fsLabel fsRequiredLabel fsLabelVertical hidden"
                >
                  <span
                    >Mark the days you are available for the draft<span
                      class="fsRequiredMarker"
                      >*</span
                    ></span
                  >
                </legend>
                <div class="fieldset-content">
                  <label class="fsOptionLabel horizontal" for="field150035774_2"
                    ><input
                      type="checkbox"
                      id="field150035774_2"
                      name="field150035774[]"
                      value="Sunday"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                    />Sunday</label
                  >
                  <label class="fsOptionLabel horizontal" for="field150035774_3"
                    ><input
                      type="checkbox"
                      id="field150035774_3"
                      name="field150035774[]"
                      value="Monday"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                    />Monday</label
                  >
                  <label class="fsOptionLabel horizontal" for="field150035774_4"
                    ><input
                      type="checkbox"
                      id="field150035774_4"
                      name="field150035774[]"
                      value="Tuesday"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                    />Tuesday</label
                  >
                  <label class="fsOptionLabel horizontal" for="field150035774_5"
                    ><input
                      type="checkbox"
                      id="field150035774_5"
                      name="field150035774[]"
                      value="Wednesday"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                    />Wednesday</label
                  >
                  <label class="fsOptionLabel horizontal" for="field150035774_6"
                    ><input
                      type="checkbox"
                      id="field150035774_6"
                      name="field150035774[]"
                      value="Thursday"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                    />Thursday</label
                  >
                  <label class="fsOptionLabel horizontal" for="field150035774_7"
                    ><input
                      type="checkbox"
                      id="field150035774_7"
                      name="field150035774[]"
                      value="Friday"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                    />Friday</label
                  >
                  <label class="fsOptionLabel horizontal" for="field150035774_8"
                    ><input
                      type="checkbox"
                      id="field150035774_8"
                      name="field150035774[]"
                      value="Saturday"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                    />Saturday</label
                  >
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5415035-6" class="fsRow fsFieldRow fsLastRow fsHidden">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsHidden fsSpan100"
              id="fsCell150035775"
              lang="en"
              fs-field-type="checkbox"
              fs-field-validation-name="Availability for Sunday"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend150035775"
                id="label150035775"
              >
                <legend
                  id="fsLegend150035775"
                  class="fsLabel fsRequiredLabel fsLabelVertical"
                >
                  <span
                    >Availability for Sunday<span class="fsRequiredMarker"
                      >*</span
                    ></span
                  >
                </legend>
                <div class="fieldset-content">
                  <label class="fsOptionLabel horizontal" for="field150035775_1"
                    ><input
                      type="checkbox"
                      id="field150035775_1"
                      name="field150035775[]"
                      value="9am-11am"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                      disabled="disabled"
                    />9am-11am</label
                  >
                  <label class="fsOptionLabel horizontal" for="field150035775_2"
                    ><input
                      type="checkbox"
                      id="field150035775_2"
                      name="field150035775[]"
                      value="11am-2pm"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                      disabled="disabled"
                    />11am-2pm</label
                  >
                  <label class="fsOptionLabel horizontal" for="field150035775_3"
                    ><input
                      type="checkbox"
                      id="field150035775_3"
                      name="field150035775[]"
                      value="2pm-5pm"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                      disabled="disabled"
                    />2pm-5pm</label
                  >
                  <label class="fsOptionLabel horizontal" for="field150035775_4"
                    ><input
                      type="checkbox"
                      id="field150035775_4"
                      name="field150035775[]"
                      value="5pm-8pm"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                      disabled="disabled"
                    />5pm-8pm</label
                  >
                  <label class="fsOptionLabel horizontal" for="field150035775_5"
                    ><input
                      type="checkbox"
                      id="field150035775_5"
                      name="field150035775[]"
                      value="8pm-11pm"
                      class="fsField fsRequired horizontal"
                      aria-required="true"
                      disabled="disabled"
                    />8pm-11pm</label
                  >

                  <div class="horizontal">
                    <label
                      class="fsOptionLabel horizontal"
                      style="margin-right: 5px;"
                      for="field150035775_other"
                      ><input
                        type="checkbox"
                        id="field150035775_other"
                        name="field150035775[]"
                        value="Other"
                        class="fsField fsRequired"
                        aria-required="true"
                        disabled="disabled"
                      />Other:</label
                    >
                    <input
                      type="text"
                      id="field150035775_othervalue"
                      name="field150035775_other"
                      size="15"
                      class="fsOtherField"
                      aria-required="true"
                      disabled=""
                    /><label class="hidden" for="field150035775_othervalue"
                      >Other Value</label
                    >
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5415035-7" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell150035822"
              lang="en"
              fs-field-type="select"
              fs-field-validation-name="Dropdown List"
            >
              <label id="label150035822" class="fsLabel" for="field150035822"
                >Dropdown List
              </label>

              <select
                id="field150035822"
                name="field150035822"
                size="1"
                class="fsField"
              >
                <option value="Option1">Option1</option>
                <option value="Option2">Option2</option>
                <option value="Option3">Option3</option>
              </select>
            </div>
          </div>

          <div id="fsRow5415035-8" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell150035823"
              lang="en"
              fs-field-type="radio"
              fs-field-validation-name="Radio Button"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend150035823"
                id="label150035823"
              >
                <legend id="fsLegend150035823" class="fsLabel fsLabelVertical">
                  <span>Radio Button</span>
                </legend>
                <div class="fieldset-content">
                  <label class="fsOptionLabel vertical" for="field150035823_1"
                    ><input
                      type="radio"
                      id="field150035823_1"
                      name="field150035823"
                      value="Option1"
                      class="fsField vertical"
                    />Option1</label
                  >

                  <label class="fsOptionLabel vertical" for="field150035823_2"
                    ><input
                      type="radio"
                      id="field150035823_2"
                      name="field150035823"
                      value="Option2"
                      class="fsField vertical"
                    />Option2</label
                  >

                  <label class="fsOptionLabel vertical" for="field150035823_3"
                    ><input
                      type="radio"
                      id="field150035823_3"
                      name="field150035823"
                      value="Option3"
                      class="fsField vertical"
                      disabled="true"
                    />Option3</label
                  >
                </div>
              </fieldset>
            </div>
          </div>

          <div id="fsRow5415035-9" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell150035826"
              lang="en"
              fs-field-type="phone"
              fs-field-validation-name="Phone"
            >
              <label id="label150035826" class="fsLabel" for="field150035826"
                >Phone
              </label>

              <input
                type="tel"
                id="field150035826"
                name="field150035826"
                size="2"
                value=""
                class="fsField fsFormatPhoneUS "
                data-country="US"
                data-format="national"
              />
            </div>
          </div>

          <div id="fsRow5415035-10" class="fsRow fsFieldRow fsLastRow">
            <div
              class="fsRowBody fsCell fsFieldCell fsFirst fsLast fsLabelVertical fsSpan100"
              id="fsCell150035828"
              lang="en"
              fs-field-type="checkbox"
              fs-field-validation-name="Checkbox"
            >
              <fieldset
                role="group"
                aria-labelledby="fsLegend150035828"
                id="label150035828"
              >
                <legend id="fsLegend150035828" class="fsLabel fsLabelVertical">
                  <span>Checkbox</span>
                </legend>
                <div class="fieldset-content">
                  <label class="fsOptionLabel vertical" for="field150035828_1"
                    ><input
                      type="checkbox"
                      id="field150035828_1"
                      name="field150035828[]"
                      value="Option1"
                      class="fsField vertical"
                    />Option1</label
                  >
                  <label class="fsOptionLabel vertical" for="field150035828_2"
                    ><input
                      type="checkbox"
                      id="field150035828_2"
                      name="field150035828[]"
                      value="Option2"
                      class="fsField vertical"
                    />Option2</label
                  >
                  <label class="fsOptionLabel vertical" for="field150035828_3"
                    ><input
                      type="checkbox"
                      id="field150035828_3"
                      name="field150035828[]"
                      value="Option3"
                      class="fsField vertical"
                      disabled="true"
                    />Option3</label
                  >
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>

      <div id="fsSubmit5415035" class="fsSubmit fsPagination">
        <button
          type="button"
          id="fsPreviousButton5415035"
          class="fsPreviousButton"
          value="Previous Page"
          style="display:none;"
          aria-label="Previous"
        >
          <span class="fsFull">Previous</span><span class="fsSlim">←</span>
        </button>
        <button
          type="button"
          id="fsNextButton5415035"
          class="fsNextButton"
          value="Next Page"
          style="display:none;"
          aria-label="Next"
        >
          <span class="fsFull">Next</span><span class="fsSlim">→</span>
        </button>
        <input
          id="fsSubmitButton5415035"
          class="fsSubmitButton"
          style=""
          type="submit"
          value="Submit Form"
        />

        <div class="clear"></div>
        <div class="withAds"></div>
      </div>
      <script type="text/javascript">
        window.FS_FIELD_DATA_5415035 = {
          150035832: {
            id: '150035832',
            type: 'rating',
            addNa: false,
            allowHalfRatings: false,
            count: 5,
            icon: 'star',
            isRequired: false,
            isUnique: false,
            shouldHideLabel: false,
            isReadOnly: false,
            defaultValue: '',
          },
        };
      </script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/jquery-3.5.1.min_dc5e7f18c8.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/jquery-ui-1.13.2.min_1e20479789.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/scripts_8ef5a1adee.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/analytics_7d49daa365.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/libphonenumber-min_6f64debfdd.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/forms/js/3/modernizr_60a2d5aeb5.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/admin/forms-frontend/build/modules/runtime/runtime_4bf793703947a15e95b8.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/admin/forms-frontend/build/modules/polyfills/polyfills_32bfe2d99af64e9974e7.js"
      ></script>
      <script
        type="text/javascript"
        src="//static.formstack.com/admin/forms-frontend/build/modules/live-form/live-form_ef412cee6a92f15ea78f.js"
      ></script>

      <script type="text/javascript">
        (function () {
          var isLocalStorageSafe = true;
          try {
            if (
              typeof sessionStorage !== 'undefined' &&
              sessionStorage.fsFonts
            ) {
              document.documentElement.className =
                document.documentElement.className += ' wf-active';
            }
          } catch (e) {
            console.log('Failed to read from localStorage', e.message);
            isLocalStorageSafe = false;
          }
          var pre = document.createElement('link');
          pre.rel = 'preconnect';
          pre.href = 'https://fonts.googleapis.com/';
          pre.setAttribute('crossorigin', '');
          var s = document.getElementsByTagName('head')[0];
          s.appendChild(pre);
          var fontConfig = {
            google: {
              families: ['Lato:400,700'],
            },
            timeout: 2000,
            active: function () {
              if (
                !isLocalStorageSafe ||
                typeof sessionStorage === 'undefined'
              ) {
                return;
              }
              sessionStorage.fsFonts = true;
            },
          };
          if (typeof WebFont === 'undefined') {
            window.WebFontConfig = fontConfig;
            var wf = document.createElement('script');
            wf.type = 'text/javascript';
            wf.async = 'true';
            wf.src =
              ('https:' == document.location.protocol ? 'https' : 'http') +
              '://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
            s.appendChild(wf);
          } else {
            WebFont.load(fontConfig);
          }
        })();

        if (window.addEventListener) {
          window.addEventListener('load', loadFormstack, false);
        } else if (window.attachEvent) {
          window.attachEvent('onload', loadFormstack);
        } else {
          loadFormstack();
        }

        function loadFormstack() {
          var form5415035 = new Formstack.Form(
            5415035,
            'https://abc-xjsgw.formstack.com/forms/'
          );

          form5415035.checks.push({
            target: '150035775',
            action: 'Show',
            bool: 'AND',
            fields: ['150035774'],
            checks: [{ field: '150035774', condition: '==', option: 'Sunday' }],
          });

          form5415035.logicFields = ['150035774'];

          form5415035.calcFields = [];

          form5415035.dateCalcFields = [];
          form5415035.init();
          if (Formstack.Analytics) {
            form5415035.plugins.analytics = new Formstack.Analytics(
              'https://abc-xjsgw.formstack.com',
              5415035,
              form5415035
            );
            form5415035.plugins.analytics.trackTouch();
            form5415035.plugins.analytics.trackBottleneck();
          }

          window.form5415035 = form5415035;
        }
      </script>
      <input
        name="fsUserAgent"
        id="fsUserAgent"
        type="hidden"
        value="Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/114.0.0.0 Safari/537.36"
      />
    </form>
    <div
      class="fs-ngdialog fs-modal-small fs-form-dialog fs-form-dialog--hidden"
    >
      <div class="fs-ngdialog-overlay"></div>
      <div class="fs-ngdialog-content">
        <div class="fs-modal__top fs-form-dialog__title"></div>
        <div class="fs-modal__middle">
          <div class="fs-form-dialog__message"></div>
          <label class="hidden" for="fsSaveResumePassword"
            >Enter your save and resume password</label
          >
          <input
            type="password"
            id="fsSaveResumePassword"
            class="fs-form-input fs-form-dialog__password fs-form-dialog--hidden fs--mt20"
            placeholder="Enter your save and resume password"
          />
          <textarea
            class="fs-form-dialog__textarea fs-form-dialog--hidden"
            rows="3"
            style="width: 100%; margin-top: 10px"
            aria-label="Add an optional comment"
          ></textarea>
        </div>
        <div class="fs-modal__bottom">
          <a
            class="fs-form-dialog__cancel fs-btn2 fs-btn2--size_medium fs-btn2--style_edit-dark"
            title="Cancel"
          >
            <div class="fs-btn2__content">
              <div class="fs-btn2__text">
                <span class="fs-form-dialog__button-text">Cancel</span>
              </div>
            </div>
          </a>
          <a
            class="fs-form-dialog__confirm fs-btn2 fs-btn2--size_medium fs-btn2--style_create fs--float-right"
            title="Confirm"
          >
            <div class="fs-btn2__content">
              <div class="fs-btn2__text">
                <span class="fs-form-dialog__button-text">Confirm</span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
`;
